<template>
  <div class="home">
    <div class="container-fluid">
      <div class="row">
        <div class="col p-0">
          <TopBarMember />
        </div>
      </div>
    </div>
    <div class="container px-0 px-sm-3">
      <div class="row mx-0">
        <div
          class="bar-back col d-flex justify-content-between align-items-center"
        >
          <router-link
            :to="
              lottoInfo.lotto &&
              (lottoInfo.lotto.lottoType == 1 || lottoInfo.lotto.lottoType == 2)
                ? '/lottery/yeekee'
                : '/lottery'
            "
            class="mr-auto text-secondary"
          >
            <i class="fas fa-chevron-left"></i> ย้อนกลับ
          </router-link>
          <a
            href="#"
            class="btn btn-outline-secondary btn-sm mr-1 text-dark"
            data-toggle="modal"
            data-target="#rule-yeekee"
            @click="modalActive = 'ruleyeekee'"
            >กติกา</a
          >
          <div
            class="tanghuay-time"
            v-if="
              lottoInfo.lotto !== undefined &&
                getTimeLeft(lottoCloseTime) <= 0 &&
                lottoInfo.lotto.isDiceAvailable
            "
          >
            <i class="sn-icon sn-icon--daily2"></i>
            <span class="countdown">
              <vue-countdown
                :time="lottoTimeLeftDice"
                v-slot="{ days, hours, minutes, seconds }"
                @start="getLottoCloseDate()"
                @end="getLottoResult()"
              >
                <span v-if="days > 0">
                  {{ zeroPad(days, 2) }}
                  <sup>วัน</sup>&nbsp;&nbsp;
                </span>
                {{ zeroPad(hours, 2) }}:{{ zeroPad(minutes, 2) }}:{{
                  zeroPad(seconds, 2)
                }}
              </vue-countdown>
            </span>
          </div>
          <a
            :class="[
              'btn',
              'btn-danger',
              'btn-sm',
              'btn-numpage',
              numPageActive == 'numpage_2' ? 'd-none' : '',
            ]"
            @click="numPageActive = 'numpage_2'"
            data-id="numpage_2"
            v-if="
              lottoName == 'PingPongVIP' &&
                lottoInfo.lotto &&
                getTimeLeft(lottoCloseTime) > 0
            "
          >
            <i class="fas fa-calculator"></i> ยิงเลข
          </a>
          <a
            :class="[
              'btn',
              'btn-danger',
              'btn-sm',
              'btn-numpage',
              numPageActive == 'numpage_1' ? 'd-none' : '',
            ]"
            @click="numPageActive = 'numpage_1'"
            data-id="numpage_1"
          >
            <i class="fas fa-calculator"></i> แทงเลข
          </a>
        </div>
      </div>
      <div
        class="p-2 w-100 bg-light main-content align-self-stretch"
        style="min-height: calc((100vh - 94px) - 90px);"
        v-if="
          lottoInfo.lotto && getTimeLeft(lottoCloseTime) <= 0
        "
      >
        <!-- {{getTimeLeft(lottoCloseTime)}} -->
        <b-card
          class="mb-3"
          body-class="p-2"
          v-if="!lottoInfo.lotto.isDiceAvailable"
        >
          <div class="lotto-title">
            <h5 class="mb-0"><i class="fas fa-award"></i> ผลรางวัล</h5>
          </div>
        </b-card>

        <b-card body-class="p-2">
          <h6 v-if="!lottoInfo.lotto.isDiceAvailable">
            <i class="fas fa-trophy"></i>
            {{ lottoInfo.lotto ? lottoName : "" }}
            <span class="badge badge-dark"
              >รอบที่ {{ lottoInfo.lotto.roundNumber }}</span
            >
          </h6>
          <b-card
            border-variant="dark"
            header-class="p-2 text-center"
            :header-html="
              '<h6 class=\'mb-0 font-weight-bold\' style=\'color: rgb(189, 132, 41) !important;\'>หวยยี่กี - รอบที่ ' +
                lottoInfo.lotto.roundNumber +
                '</h6>'
            "
            body-class="p-0"
            v-if="!lottoInfo.lotto.isDiceAvailable"
          >
            <b-card
              body-class="p-1 text-center"
              class="rounded-0 border-top-0 border-right-0 border-left-0"
            >
              <small class="text-secondary"
                >- ปิดรับการทายผลตัวเลขออกรางวัล -</small
              >
            </b-card>
            <b-row v-if="dice.pingPongStatus == '2'">
              <b-col cols="12">
                <b-card
                  body-class="p-1 text-center"
                  class="rounded-0 border-top-0 border-right-0 border-left-0"
                >
                  <div class="text-secondary">
                    <small class="font-weight-bold">ผลรางวัล</small>
                  </div>
                  <div class="result-number top">
                    <span>{{
                      dice.diceResult
                        ? dice.diceResult.substring(
                            0,
                            dice.diceResult.length - 5
                          )
                        : ""
                    }}</span>
                    <span class="text-success">{{
                      dice.diceResult
                        ? dice.diceResult.substring(
                            dice.diceResult.length - 5,
                            dice.diceResult.length - 3
                          )
                        : ""
                    }}</span>
                    <span class="text-gold">{{
                      dice.diceResult
                        ? dice.diceResult.substring(
                            dice.diceResult.length - 3,
                            dice.diceResult.length
                          )
                        : ""
                    }}</span>
                  </div>
                </b-card>
              </b-col>
              <b-col cols="6" class="pr-0">
                <b-card
                  body-class="p-1 text-center"
                  class="rounded-0 border-top-0 border-right-0 border-left-0"
                >
                  <div class="text-secondary">
                    <small class="font-weight-bold">3 ตัวบน</small>
                  </div>
                  <div class="result-number top">
                    {{ lottoInfo.lotto.threeTop }}
                  </div>
                </b-card>
              </b-col>
              <b-col cols="6" class="pl-0">
                <b-card
                  body-class="p-1 text-center"
                  class="rounded-0 border-top-0 border-right-0"
                >
                  <div class="text-secondary">
                    <small class="font-weight-bold">2 ตัวล่าง</small>
                  </div>
                  <div class="result-number top">
                    {{ lottoInfo.lotto.twoDown }}
                  </div>
                </b-card>
              </b-col>
              <b-col cols="12">
                <b-card
                  body-class="p-1 text-center"
                  class="rounded-0 border-top-0 border-right-0"
                >
                  <div class="text-secondary">
                    <small class="font-weight-bold">ผลรวมยิงเลข</small>
                  </div>
                  <div class="result-number second">{{ dice.totalDice }}</div>
                </b-card>
              </b-col>
              <b-col cols="12">
                <b-card
                  body-class="p-1 text-center"
                  class="rounded-0 border-top-0 border-right-0"
                >
                  <div class="text-secondary">
                    <small class="font-weight-bold">เลขแถวที่ 16</small>
                  </div>
                  <div class="result-number second text-primary">
                    {{ dice.diceList[15].number }}
                  </div>
                </b-card>
              </b-col>
              <b-col cols="6">
                <b-card
                  body-class="p-1 text-center"
                  class="rounded-0 border-top-0 border-right-0"
                >
                  <div class="text-secondary">
                    <small class="font-weight-bold"
                      >สมาชิกยิงเลขได้ <u>อันดับ 1</u></small
                    >
                  </div>
                  <div class="result-number second">
                    {{ dice.diceList[0].username.substring(0, 2) }}****{{
                      dice.diceList[0].username.substring(
                        dice.diceList[0].username.length - 2
                      )
                    }}
                  </div>
                </b-card>
              </b-col>
              <b-col cols="6">
                <b-card
                  body-class="p-1 text-center"
                  class="rounded-0 border-top-0 border-right-0"
                >
                  <div class="text-secondary">
                    <small class="font-weight-bold"
                      >สมาชิกยิงเลขได้ <u>อันดับ 16</u></small
                    >
                  </div>
                  <div class="result-number second">
                    {{ dice.diceList[15].username.substring(0, 2) }}****{{
                      dice.diceList[15].username.substring(
                        dice.diceList[15].username.length - 2
                      )
                    }}
                  </div>
                </b-card>
              </b-col>
            </b-row>
            <b-row v-else>
              <b-col cols="12" class="text-center">
                <div class="text-danger p-3">ไม่มีการออกผลรางวัลในรอบนี้</div>
              </b-col>
            </b-row>
          </b-card>
          <div
            :class="[
              'bgwhitealpha',
              'text-secondary',
              'shadow-sm',
              'rounded',
              'p-2',
              'p-2',
              'mt-1',
              'flex-column',
              'mb-5',
            ]"
            id="numpage_2"
          >
            <!-- <div
              class="tanghuay-time"
              v-if="lottoInfo.lotto !== undefined && getTimeLeftDice(lottoCloseTime) <= 0 && lottoInfo.lotto.isDiceAvailable"
            >
              <i class="sn-icon sn-icon--daily2"></i>
              <span class="countdown">
                <vue-countdown
                  :time="getTimeLeftDice(lottoCloseTime)"
                  v-slot="{ days, hours, minutes, seconds }"
                  @end="setTimeout(() => { getLottoInfo() }, 5000)"
                >
                  <span v-if="days > 0">
                    {{zeroPad(days, 2)}}
                    <sup>วัน</sup>&nbsp;&nbsp;
                  </span>
                  {{zeroPad(hours, 2)}}:{{zeroPad(minutes, 2)}}:{{zeroPad(seconds, 2)}}
                </vue-countdown>
              </span>
            </div> -->
            <h3 class="text-center" v-if="lottoInfo.lotto.isDiceAvailable">
              <i class="fas fa-chart-line"></i> ผลรวมยี่กี
            </h3>
            <h3
              class="text-center"
              id="total_ying"
              v-if="lottoInfo.lotto.isDiceAvailable"
            >
              {{ dice.totalDice }}
            </h3>
            <div class="text-center" v-if="pending">
              <h4>กำลังออกผล กรุณารอสักครู่</h4>
              <b-progress value="100" animated height="2rem"></b-progress>
            </div>
            <div
              class="form-shot-number"
              v-else-if="lottoInfo.lotto.isDiceAvailable && !pending"
            >
              <input
                placeholder="กรอกตัวเลข 5 หลัก"
                maxlength="5"
                type="text"
                v-model="yingNumber"
                readonly="readonly"
                class="form-control form-control-lg text-center show-input-number"
              />
              <div class="key-pad box__keyboard yeekee__number">
                <div class="row p-2 group">
                  <div class="col-3 p-1">
                    <button
                      class="btn btn-outline-primary btn-block"
                      @click="addYingNumber('1')"
                    >
                      1
                    </button>
                  </div>
                  <div class="col-3 p-1">
                    <button
                      class="btn btn-outline-primary btn-block"
                      @click="addYingNumber('2')"
                    >
                      2
                    </button>
                  </div>
                  <div class="col-3 p-1">
                    <button
                      class="btn btn-outline-primary btn-block"
                      @click="addYingNumber('3')"
                    >
                      3
                    </button>
                  </div>
                  <div class="col-3 p-1">
                    <button
                      class="btn btn-danger btn-block delete__number"
                      @click="
                        yingNumber = yingNumber.substring(
                          0,
                          yingNumber.length - 1
                        )
                      "
                    >
                      <i class="fas fa-backspace"></i>
                    </button>
                  </div>
                  <div class="col-3 p-1">
                    <button
                      class="btn btn-outline-primary btn-block"
                      @click="addYingNumber('4')"
                    >
                      4
                    </button>
                  </div>
                  <div class="col-3 p-1">
                    <button
                      class="btn btn-outline-primary btn-block"
                      @click="addYingNumber('5')"
                    >
                      5
                    </button>
                  </div>
                  <div class="col-3 p-1">
                    <button
                      class="btn btn-outline-primary btn-block"
                      @click="addYingNumber('6')"
                    >
                      6
                    </button>
                  </div>
                  <div class="col-3 p-1">
                    <button
                      class="btn btn-secondary btn-block random__number px-0"
                      @click="randomYing()"
                    >
                      <span>สุ่มเลข</span>
                    </button>
                  </div>
                  <div class="col-3 p-1">
                    <button
                      class="btn btn-outline-primary btn-block"
                      @click="addYingNumber('7')"
                    >
                      7
                    </button>
                  </div>
                  <div class="col-3 p-1">
                    <button
                      class="btn btn-outline-primary btn-block"
                      @click="addYingNumber('8')"
                    >
                      8
                    </button>
                  </div>
                  <div class="col-3 p-1">
                    <button
                      class="btn btn-outline-primary btn-block"
                      @click="addYingNumber('9')"
                    >
                      9
                    </button>
                  </div>
                  <div class="col-3 p-1">
                    <button
                      class="btn btn-success btn-block submit-number yeekee__submit px-0"
                      @click="submitDice"
                      :disabled="diceButtonDisabled ? true : false"
                    >
                      เพิ่มเลข
                      <vue-countdown
                        v-if="countDownDice > 0"
                        :time="countDownDice"
                        v-slot="{ seconds }"
                        @end="
                          sendingDice = false;
                          countDownDice = 0;
                        "
                      >
                        ({{ seconds }})
                      </vue-countdown>
                    </button>
                  </div>
                  <div class="col-3 p-1">
                    <button class="btn btn-blank" disabled></button>
                  </div>
                  <div class="col-3 p-1">
                    <button
                      class="btn btn-outline-primary btn-block"
                      @click="addYingNumber('0')"
                    >
                      0
                    </button>
                  </div>
                  <div class="col-3 p-1">
                    <button class="btn btn-blank" disabled></button>
                  </div>
                  <div class="col-3 p-1">
                    <!-- <button class="btn btn-blank" disabled></button> -->
                  </div>
                </div>
              </div>
            </div>

            <hr class="mt-1 mb-2" />

            <div class="d-flex flex-column yeekee__lists-number">
              <h5 class="text-center text-success">
                <i class="fas fa-th-list"></i> รายชื่อผู้ทายเลข
              </h5>
              <span id="yresult">
                <div
                  class="flex-row justify-content-between align-items-stretch mb-1 d-flex"
                  id="list_ying_0"
                  v-for="(item, index) in dice.diceList"
                  v-bind:key="item.referID"
                >
                  <div
                    :class="[
                      'text-white text-center rounded p-2 w-25 d-flex flex-column justify-content-around',
                      index == 0 || index == 15 ? 'bg-success' : 'bg-secondary',
                    ]"
                  >
                    <span
                      :class="[
                        'badge badge-pill badge-light',
                        index == 0 || index == 15
                          ? 'text-success'
                          : 'text-secondary',
                      ]"
                    >
                      อันดับที่
                      <span data-id="ly_ranked">{{ index + 1 }}</span>
                    </span>
                    <h3 class="mb-0">
                      <small>{{ item.number }}</small>
                    </h3>
                  </div>
                  <div
                    :class="[
                      'border bg-light rounded p-2 ml-1 flex-fill d-flex flex-column justify-content-around',
                      index == 0 || index == 15
                        ? 'border-success'
                        : 'border-secondary',
                    ]"
                  >
                    <div>
                      <span
                        :class="[
                          'badge badge-pill badge-light',
                          index == 0 || index == 15
                            ? 'text-success'
                            : 'text-secondary',
                        ]"
                      >
                        <i class="fas fa-user-circle"></i>
                        ผู้ส่งเลข
                      </span>
                      <span data-id="ly_send"
                        >{{ item.username.substring(0, 2) }}****{{
                          item.username.substring(item.username.length - 2)
                        }}</span
                      >
                    </div>
                    <hr class="my-1" />
                    <div>
                      <span
                        :class="[
                          'badge badge-pill badge-light',
                          index == 0 || index == 15
                            ? 'text-success'
                            : 'text-secondary',
                        ]"
                      >
                        <i class="fas fa-calendar-check"></i>
                        เมื่อ
                      </span>
                      <span data-id="ly_date">{{
                        formatDate(item.diceTime, "DD/MM/YYYY HH:mm:ss")
                      }}</span>
                    </div>
                  </div>
                </div>
              </span>
            </div>
          </div>
        </b-card>
      </div>

      <div
        class="p-2 w-100 bg-light main-content align-self-stretch"
        style="min-height: calc((100vh - 94px) - 90px);"
        v-if="
          lottoInfo.lotto !== undefined &&
            getTimeLeft(lottoCloseTime) > 0
        "
      >
        <div
          class="bgwhitealpha text-secondary shadow-sm rounded p-2 px-2 xtarget col-lotto d-flex flex-row mb-0 pb-0"
        >
          <div
            class="d-flex justify-content-between align-items-center mb-0 flex-fill lotto-title"
          >
            <h4 class="tanghuay-h4 font-weight-bold">
              {{
                lottoName == "PingPongVIP"
                  ? "หวยยี่กี"
                  : lottoInfo.lotto && lottoInfo.lotto.lottoDesc
                  ? lottoInfo.lotto.lottoDesc
                  : lottoInfo.lotto.lottoName
                  ? lottoInfo.lotto.lottoName
                  : lottoName
              }}
              <span class="badge badge-pill badge-danger font-weight-light">
                <small v-if="lottoName == 'PingPongVIP'"
                  >รอบที่ {{ lottoInfo.lotto.roundNumber }}</small
                >
                <small v-else>{{
                  lottoInfo.lotto !== undefined
                    ? formatDate(lottoInfo.lotto.lottoDate, "DD MMM YYYY")
                    : ""
                }}</small>
              </span>
            </h4>
            <!-- {{formatDateDice(lottoCloseTime, "DD/MM/YYYY HH:mm:ss")}} -->
            <div
              class="tanghuay-time"
              v-if="
                lottoInfo.lotto !== undefined &&
                  getTimeLeft(lottoCloseTime) > 0
              "
            >
              <i class="sn-icon sn-icon--daily2"></i>
              <span class="countdown">
                <vue-countdown
                  :time="lottoTimeLeft"
                  v-slot="{ days, hours, minutes, seconds }"
                  @start="getLottoCloseDate()"
                  @end="getLottoInfo()"
                >
                  <span v-if="days > 0">
                    {{ zeroPad(days, 2) }}
                    <sup>วัน</sup>&nbsp;&nbsp;
                  </span>
                  {{ zeroPad(hours, 2) }}:{{ zeroPad(minutes, 2) }}:{{
                    zeroPad(seconds, 2)
                  }}
                </vue-countdown>
              </span>
            </div>
          </div>
        </div>
        <div
          class="row-menu-grid"
          style="min-height: calc((100vh - 157.5px) - 90px);"
        >
          <div
            :class="[]"
            v-bind:style="
              numPageActive == 'numpage_1'
                ? { display: [''] }
                : { display: ['none'] }
            "
          >
            <div
              :class="[
                'd-flex',
                'flex-row',
                'justify-content-between',
                'align-items-stretch',
                'p-1',
                'mt-1',
                'pr-2',
                'bg-white',
                'rounded',
                'shadow-sm',
                'flex-fill',
                'cart-item-lists',
                numPageActive == 'numpage_1' ? '' : 'd-none',
              ]"
              id="numpage_1"
            >
              <div
                :class="['d-flex', 'flex-column', 'flex-fill', 'box__play']"
                id="show_poy_list"
                v-bind:style="
                  numPageActive == 'numpage_1'
                    ? { display: [''] }
                    : { display: ['none'] }
                "
              >
                <!-- <div id="hide-list-huay">
                  <a class="btn-move btn-move-left mb-1">
                    <span>
                      <i class="fas fa-chevron-circle-left"></i> ซ่อน
                    </span>
                  </a>
                </div> -->
                <div
                  class="sidebar-huay d-flex flex-column flex-fill"
                  id="sidebar-huay"
                >
                  <button
                    class="btn btn-light btn-sm btn-block number-sets triggerPoy"
                    @click="$bvModal.show('numberSetModal')"
                  >
                    <i class="fas fa-list-ol"></i> ดึงโพย
                  </button>
                  <button
                    class="btn btn-danger btn-sm btn-block show-lists triggerPrice"
                    @click="$bvModal.show('priceModal')"
                  >
                    <i class="fas fa-edit"></i> ใส่ราคา
                  </button>
                  <h5 class="title-huay mt-2">
                    <i class="fas fa-receipt d-none d-sm-block"></i> รายการแทง
                  </h5>
                  <span class="bet_num_count">{{ selectedAmount }} รายการ</span>
                  <div class="list-huay flex-fill">
                    <ol class="num-huay" id="show_bet_num">
                      <div v-if="selectedSortedNumbers.run.bon.length > 0">
                        วิ่งบน
                      </div>
                      <li
                        v-for="(num, index) in selectedSortedNumbers.run.bon"
                        v-bind:key="'run-bon' + num.number + '-' + index"
                      >
                        {{ num.number }}
                      </li>
                      <div v-if="selectedSortedNumbers.songTua.bon.length > 0">
                        สองตัวบน
                      </div>
                      <li
                        v-for="(num, index) in selectedSortedNumbers.songTua.bon"
                        v-bind:key="'songTua-bon' + num.number + '-' + index"
                      >
                        {{ num.number }}
                      </li>
                      <div v-if="selectedSortedNumbers.samTua.front.length > 0">
                        สามตัวหน้า
                      </div>
                      <li
                        v-for="(num, index) in selectedSortedNumbers.samTua.front"
                        v-bind:key="'samTua-front' + num.number + '-' + index"
                      >
                        {{ num.number }}
                      </li>
                      <div v-if="selectedSortedNumbers.samTua.bon.length > 0">
                        สามตัวบน
                      </div>
                      <li
                        v-for="(num, index) in selectedSortedNumbers.samTua.bon"
                        v-bind:key="'samTua-bon' + num.number + '-' + index"
                      >
                        {{ num.number }}
                      </li>
                      <div v-if="selectedSortedNumbers.run.down.length > 0">
                        วิ่งล่าง
                      </div>
                      <li
                        v-for="(num, index) in selectedSortedNumbers.run.down"
                        v-bind:key="'run-down' + num.number + '-' + index"
                      >
                        {{ num.number }}
                      </li>
                      <div v-if="selectedSortedNumbers.songTua.down.length > 0">
                        สองตัวล่าง
                      </div>
                      <li
                        v-for="(num, index) in selectedSortedNumbers.songTua.down"
                        v-bind:key="'songTua-down' + num.number + '-' + index"
                      >
                        {{ num.number }}
                      </li>
                      <div v-if="selectedSortedNumbers.samTua.tode.length > 0">
                        สามตัวโต๊ด
                      </div>
                      <li
                        v-for="(num, index) in selectedSortedNumbers.samTua.tode"
                        v-bind:key="'samTua-tode' + num.number + '-' + index"
                      >
                        {{ num.number }}
                      </li>
                      <div v-if="selectedSortedNumbers.samTua.down.length > 0">
                        สามตัวล่าง
                      </div>
                      <li
                        v-for="(num, index) in selectedSortedNumbers.samTua.down"
                        v-bind:key="'samTua-down' + num.number + '-' + index"
                      >
                        {{ num.number }}
                      </li>
                    </ol>
                  </div>
                </div>
              </div>

              <div
                class="sidebar-tanghuay box__play"
                id="page_tang"
                v-bind:style="
                  numPageActive == 'numpage_1'
                    ? { display: [''] }
                    : { display: ['none'] }
                "
              >
                <!-- <div id="show-list-huay" class="d-flex justify-content-between" style="width: 0px;">
                  <span class="btn-move bet_num_count justify-content-center rounded"></span>
                  <a class="btn-move btn-move-right flex-fill">
                    <span>
                      แสดง
                      <i class="fas fa-chevron-circle-right"></i>
                    </span>
                  </a>
                </div> -->
                <nav>
                  <div
                    class="nav nav-tabs nav-pills nav-justified"
                    id="nav-tab1"
                    role="tablist"
                  >
                    <a
                      :class="[
                        'nav-item',
                        'nav-link',
                        'p-1',
                        tabActive == 'keyboard' ? 'active show' : '',
                      ]"
                      @click="tabActive = 'keyboard'"
                      href="javascript:void()"
                      id="nav-keyboard-tab"
                      data-toggle="tab"
                      role="tab"
                      aria-controls="nav-keyboard"
                      :aria-selected="tabActive == 'keyboard'"
                      >กดเลขเอง</a
                    >
                    <!-- <a :class="['nav-item', 'nav-link', 'p-1', tabActive == 'keyboard' ? 'active show' : '']" id="nav-keyboard-tab" data-toggle="tab" href="#nav-keyboard" role="tab" aria-controls="nav-keyboard" aria-selected="false">กดเลขเอง</a> -->
                    <a
                      :class="[
                        'nav-item',
                        'nav-link',
                        'p-1',
                        tabActive == 'panghuay' ? 'active show' : '',
                      ]"
                      @click="tabActive = 'panghuay'"
                      href="javascript:void()"
                      id="nav-panghuay-tab"
                      data-toggle="tab"
                      role="tab"
                      aria-controls="nav-keyboard"
                      :aria-selected="tabActive == 'panghuay'"
                      >เลือกจากแผง</a
                    >
                    <!-- <a :class="['nav-item', 'nav-link', 'p-1', tabActive == 'panghuay' ? 'active show' : '']" id="nav-panghuay-tab" data-toggle="tab" href="#nav-panghuay" role="tab" aria-controls="nav-panghuay" aria-selected="true">เลือกจากแผง</a> -->
                  </div>
                </nav>

                <div class="tab-content" id="nav-tabContent">
                  <div
                    :class="[
                      'tab-pane',
                      tabActive == 'keyboard' ? 'fade active show' : '',
                    ]"
                    id="nav-keyboard"
                    role="tabpanel"
                    aria-labelledby="nav-keyboard-tab"
                  >
                    <div class="row px-2 row-btn-tanghuay setting__number">
                      <div class="col-6 col-sm-6 col-md-4 col-lg-3 p-1">
                        <button
                          :class="[
                            'btn',
                            'btn-outline-red',
                            'btn-sm',
                            'btn-block',
                            'h-100',
                            'd-flex',
                            'justify-content-between',
                            'align-items-center',
                            'btn-tanghuay',
                            tabSamTuaSelected.bon === true ? 'active show' : '',
                          ]"
                          @click="setSamTuaSelected('bon')"
                          id="teng_bon_3"
                        >
                          <!-- <button class="btn btn-outline-red btn-sm btn-block h-100 d-flex justify-content-between align-items-center btn-tanghuay" id="teng_bon_3"> -->
                          <div class="bg-danger text-white">
                            <i>
                              <small>3</small>
                            </i>
                            <i>ตัวบน</i>
                          </div>
                          <div>{{rate.samTua.bon}}</div>
                        </button>
                      </div>
                      <div class="col-6 col-sm-6 col-md-4 col-lg-3 p-1">
                        <button
                          :class="[
                            'btn',
                            'btn-outline-red',
                            'btn-sm',
                            'btn-block',
                            'h-100',
                            'd-flex',
                            'justify-content-between',
                            'align-items-center',
                            'btn-tanghuay',
                            tabSamTuaSelected.tode === true
                              ? 'active show'
                              : '',
                          ]"
                          @click="setSamTuaSelected('tode')"
                          id="tode_3"
                        >
                          <!-- <button class="btn btn-outline-red btn-sm btn-block h-100 d-flex justify-content-between align-items-center btn-tanghuay" id="tode_3"> -->
                          <div class="bg-danger text-white">
                            <i>
                              <small>3</small>
                            </i>
                            <i>ตัวโต๊ด</i>
                          </div>
                          <div>{{rate.samTua.tode}}</div>
                        </button>
                      </div>
                      <div class="col-6 col-sm-6 col-md-4 col-lg-3 p-1">
                        <!-- <div :class="['btn','btn-outline-blue','btn-sm','btn-block','h-100','d-flex','justify-content-between','align-items-center','btn-tanghuay','bet_two', tabKeyboardSelected == 'bet_two' ? 'active show' : '']" > -->
                        <!-- <button class="btn btn-outline-blue btn-sm btn-block h-100 d-flex justify-content-between align-items-center btn-tanghuay bet_two" id="teng_bon_2"> -->
                        <button
                          :class="[
                            'btn',
                            'btn-outline-blue',
                            'btn-sm',
                            'btn-block',
                            'h-100',
                            'd-flex',
                            'justify-content-between',
                            'align-items-center',
                            'btn-tanghuay',
                            'bet_two',
                            tabSongTuaSelected.bon === true
                              ? 'active show'
                              : '',
                          ]"
                          @click="setSongTuaSelected('bon')"
                          id="teng_bon_2"
                        >
                          <div class="bg-primary text-white">
                            <i>
                              <small>2</small>
                            </i>
                            <i>ตัวบน</i>
                          </div>
                          <div class="text-center">{{rate.songTua.bon}}</div>
                        </button>
                        <!-- </div> -->
                      </div>
                      <div class="col-6 col-sm-6 col-md-4 col-lg-3 p-1">
                        <button
                          :class="[
                            'btn',
                            'btn-outline-blue',
                            'btn-sm',
                            'btn-block',
                            'h-100',
                            'd-flex',
                            'justify-content-between',
                            'align-items-center',
                            'btn-tanghuay',
                            'bet_two',
                            tabSongTuaSelected.down === true
                              ? 'active show'
                              : '',
                          ]"
                          @click="setSongTuaSelected('down')"
                          id="teng_down_2"
                        >
                          <div class="bg-primary text-white">
                            <i>
                              <small>2</small>
                            </i>
                            <i>ตัวล่าง</i>
                          </div>
                          <div class="text-center">{{rate.songTua.down}}</div>
                        </button>
                      </div>
                      <div class="col-6 col-sm-6 col-md-4 col-lg-3 p-1">
                        <button
                          :class="[
                            'btn',
                            'btn-outline-red',
                            'btn-sm',
                            'btn-block',
                            'h-100',
                            'd-flex',
                            'justify-content-between',
                            'align-items-center',
                            'btn-tanghuay',
                            tabSamTuaSelected.swap === true
                              ? 'active show'
                              : '',
                          ]"
                          @click="setSamTuaSelected('swap')"
                          id="shuffle_3"
                        >
                          <div class="bg-danger text-white">
                            <i>
                              <small>3</small>
                            </i>
                            <i>ตัวกลับ</i>
                          </div>
                          <div class="text-center">
                            <i class="fas fa-random"></i>
                          </div>
                        </button>
                      </div>
                      <div class="col-6 col-sm-6 col-md-4 col-lg-3 p-1">
                        <button
                          :class="[
                            'btn',
                            'btn-outline-blue',
                            'btn-sm',
                            'btn-block',
                            'h-100',
                            'd-flex',
                            'justify-content-between',
                            'align-items-center',
                            'btn-tanghuay',
                            'bet_two',
                            tabSongTuaSelected.swap === true
                              ? 'active show'
                              : '',
                          ]"
                          @click="setSongTuaSelected('swap')"
                          id="shuffle_2"
                        >
                          <div class="bg-primary text-white">
                            <i>
                              <small>2</small>
                            </i>
                            <i>ตัวกลับ</i>
                          </div>
                          <div class="text-center">
                            <i class="fas fa-random"></i>
                          </div>
                        </button>
                      </div>
                      <div
                        class="col-6 col-sm-6 col-md-4 col-lg-3 p-1"
                        v-if="lottoInfo.lotto && lottoInfo.lotto.lottoType == 3"
                      >
                        <button
                          :class="[
                            'btn',
                            'btn-outline-red',
                            'btn-sm',
                            'btn-block',
                            'h-100',
                            'd-flex',
                            'justify-content-between',
                            'align-items-center',
                            'btn-tanghuay',
                            tabSamTuaSelected.front === true
                              ? 'active show'
                              : '',
                          ]"
                          @click="setSamTuaSelected('front')"
                        >
                          <!-- <button class="btn btn-outline-red btn-sm btn-block h-100 d-flex justify-content-between align-items-center btn-tanghuay" id="tode_3"> -->
                          <div class="bg-danger text-white">
                            <i>
                              <small>3</small>
                            </i>
                            <i>ตัวหน้า</i>
                          </div>
                          <div>{{rate.samTua.front}}</div>
                        </button>
                      </div>
                      <div
                        class="col-6 col-sm-6 col-md-4 col-lg-3 p-1"
                        v-if="lottoInfo.lotto && lottoInfo.lotto.lottoType == 3"
                      >
                        <button
                          :class="[
                            'btn',
                            'btn-outline-red',
                            'btn-sm',
                            'btn-block',
                            'h-100',
                            'd-flex',
                            'justify-content-between',
                            'align-items-center',
                            'btn-tanghuay',
                            tabSamTuaSelected.down === true
                              ? 'active show'
                              : '',
                          ]"
                          @click="setSamTuaSelected('down')"
                        >
                          <!-- <button class="btn btn-outline-red btn-sm btn-block h-100 d-flex justify-content-between align-items-center btn-tanghuay" id="tode_3"> -->
                          <div class="bg-danger text-white">
                            <i>
                              <small>3</small>
                            </i>
                            <i>ตัวล่าง</i>
                          </div>
                          <div>{{rate.samTua.down}}</div>
                        </button>
                      </div>
                      <div
                        :class="
                          lottoInfo.lotto && lottoInfo.lotto.lottoType == 3
                            ? 'col-6 col-sm-6 col-md-4 col-lg-3 p-1'
                            : 'col-6 col-sm-6 col-md-6 col-lg-6 p-1'
                        "
                      >
                        <button
                          :class="[
                            'btn',
                            'btn-outline-green',
                            'btn-sm',
                            'btn-block',
                            'h-100',
                            'd-flex',
                            'justify-content-between',
                            'align-items-center',
                            'btn-tanghuay',
                            'bet_run',
                            tabRunSelected.bon === true ? 'active show' : '',
                          ]"
                          @click="setRunSelected('bon')"
                          id="teng_bon_1"
                        >
                          <div class="bg-success text-white">
                            <i>วิ่ง</i>
                            <i>บน</i>
                          </div>
                          <div class="text-center">{{rate.run.bon}}</div>
                        </button>
                      </div>
                      <div
                        :class="
                          lottoInfo.lotto && lottoInfo.lotto.lottoType == 3
                            ? 'col-6 col-sm-6 col-md-4 col-lg-3 p-1'
                            : 'col-6 col-sm-6 col-md-6 col-lg-6 p-1'
                        "
                      >
                        <button
                          :class="[
                            'btn',
                            'btn-outline-green',
                            'btn-sm',
                            'btn-block',
                            'h-100',
                            'd-flex',
                            'justify-content-between',
                            'align-items-center',
                            'btn-tanghuay',
                            'bet_run',
                            tabRunSelected.down === true ? 'active show' : '',
                          ]"
                          @click="setRunSelected('down')"
                          id="teng_down_1"
                        >
                          <div class="bg-success text-white">
                            <i>วิ่ง</i>
                            <i>ล่าง</i>
                          </div>
                          <div class="text-center">{{rate.run.down}}</div>
                        </button>
                      </div>
                    </div>

                    <!-- <div :class="['bg-option','p-1','pb-0','mt-1','rounded','box__two-option','box__play','setting__number']" id="2option" v-bind:style="{display:['none']}"> -->
                    <div
                      :class="[
                        'bg-option',
                        'p-1',
                        'pb-0',
                        'mt-1',
                        'rounded',
                        'box__two-option',
                        'box__play',
                        'setting__number',
                      ]"
                      id="2option"
                      v-bind:style="
                        (tabSongTuaSelected.bon || tabSongTuaSelected.down)
                          ? { display: [''] }
                          : { display: ['none'] }
                      "
                    >
                      <!-- <div class="bg-option p-1 pb-0 mt-1 rounded box__two-option box__play setting__number" id="2option" style="display:none;"> -->
                      <i class="fas fa-bars"></i> ตัวเลือกเพิ่มเติม
                      <div
                        class="d-flex flex-lg-row justify-content-around align-content-stretch flex-wrap"
                      >
                        <div class="flex-fill">
                          <div class="bg-btn">
                            <button
                              class="btn btn-danger btn-sm btn-block h-100 bet_two option2btn"
                              id="option_2_19"
                              @click="selectSongTuaOption('ntDoors')"
                            >
                              19 ประตู
                            </button>
                          </div>
                        </div>
                        <div class="flex-fill">
                          <div class="bg-btn">
                            <button
                              class="btn btn-danger btn-sm btn-block h-100 bet_two"
                              @click="doubleNumber"
                            >
                              เลขเบิ้ล
                            </button>
                          </div>
                        </div>
                        <div class="flex-fill">
                          <div class="bg-btn">
                            <button
                              class="btn btn-primary btn-sm btn-block h-100 bet_two option2btn"
                              @click="selectSongTuaOption('swipeFront')"
                            >
                              รูดหน้า
                            </button>
                          </div>
                        </div>
                        <div class="flex-fill">
                          <div class="bg-btn">
                            <button
                              class="btn btn-primary btn-sm btn-block h-100 bet_two option2btn"
                              @click="selectSongTuaOption('swipeBack')"
                            >
                              รูดหลัง
                            </button>
                          </div>
                        </div>
                        <div class="flex-fill">
                          <div class="bg-btn">
                            <button
                              class="btn btn-info btn-sm btn-block h-100 bet_two"
                              @click="twoBottom"
                            >
                              สองตัวต่ำ
                            </button>
                          </div>
                        </div>
                        <div class="flex-fill">
                          <div class="bg-btn">
                            <button
                              class="btn btn-info btn-sm btn-block h-100 bet_two"
                              @click="twoTop"
                            >
                              สองตัวสูง
                            </button>
                          </div>
                        </div>
                        <div class="flex-fill">
                          <div class="bg-btn">
                            <button
                              class="btn btn-success btn-sm btn-block h-100 bet_two"
                              @click="twoOdd"
                            >
                              สองตัวคี่
                            </button>
                          </div>
                        </div>
                        <div class="flex-fill">
                          <div class="bg-btn">
                            <button
                              class="btn btn-success btn-sm btn-block h-100 bet_two"
                              @click="twoEven"
                            >
                              สองตัวคุ่
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      class="w-100 bg-light px-1 pb-1 text-center border my-1"
                    >
                      <p class="border-bottom mb-1">
                        <small>รายการที่เลือก</small>
                      </p>
                      <div id="resultoption">
                        <b-badge v-if="tabSamTuaSelected.bon" variant="danger"
                          >3 ตัวบน</b-badge
                        >&nbsp;
                        <b-badge v-if="tabSamTuaSelected.front" variant="danger"
                          >3 ตัวหน้า</b-badge
                        >&nbsp;
                        <b-badge v-if="tabSamTuaSelected.tode" variant="danger"
                          >3 ตัวโต๊ด</b-badge
                        >&nbsp;
                        <b-badge v-if="tabSamTuaSelected.down" variant="danger"
                          >3 ตัวท้าย</b-badge
                        >&nbsp;
                        <b-badge v-if="tabSamTuaSelected.swap" variant="danger"
                          >กลับ 3 ตัว</b-badge
                        >&nbsp;
                        <!-- <span
                          class="badge badge-danger font-weight-light d-none"
                          id="teng_down_3_label"
                        >3ตัวล่าง</span>
                        <span
                          class="badge badge-danger font-weight-light d-none"
                          id="teng_down_nha_3_label"
                        >3ตัวหน้า</span>-->
                        <b-badge v-if="tabRunSelected.bon" variant="success"
                          >วิ่งบน</b-badge
                        >&nbsp;
                        <b-badge v-if="tabRunSelected.down" variant="success"
                          >วิ่งล่าง</b-badge
                        >&nbsp;
                        <b-badge v-if="tabSongTuaSelected.bon" variant="primary"
                          >2 ตัวบน</b-badge
                        >&nbsp;
                        <b-badge
                          v-if="tabSongTuaSelected.down"
                          variant="primary"
                          >2 ตัวล่าง</b-badge
                        >&nbsp;
                        <b-badge
                          v-if="tabSongTuaSelected.swap"
                          variant="primary"
                          >กลับ 2 ตัว</b-badge
                        >&nbsp;
                        <span
                          class="badge badge-secondary font-weight-light"
                          id="option_2_19_label"
                          v-if="tabSongTuaSelected.ntDoors"
                          >19 ประตู</span
                        >&nbsp;
                        <span
                          class="badge badge-secondary font-weight-light d-none"
                          id="option_2_ble_label"
                          >เลขเบิ้ล</span
                        >&nbsp;
                        <span
                          class="badge badge-secondary font-weight-light"
                          id="option_2_roodnha_label"
                          v-if="tabSongTuaSelected.swipeFront"
                          >รูดหน้า</span
                        >&nbsp;
                        <span
                          class="badge badge-secondary font-weight-light"
                          id="option_2_roodlung_label"
                          v-if="tabSongTuaSelected.swipeBack"
                          >รูดหลัง</span
                        >&nbsp;
                        <span
                          class="badge badge-secondary font-weight-light d-none"
                          id="option_2_low_label"
                          >สองตัวต่ำ</span
                        >&nbsp;
                        <span
                          class="badge badge-secondary font-weight-light d-none"
                          id="option_2_high_label"
                          >สองตัวสูง</span
                        >&nbsp;
                        <span
                          class="badge badge-secondary font-weight-light d-none"
                          id="option_2_odd_label"
                          >สองตัวคี่</span
                        >&nbsp;
                        <span
                          class="badge badge-secondary font-weight-light d-none"
                          id="option_2_even_label"
                          >สองตัวคุ่</span
                        >&nbsp;
                      </div>
                    </div>

                    <div
                      class="group__keyboard"
                      v-if="
                        tabSamTuaSelected.bon ||
                          tabSamTuaSelected.tode ||
                          tabSamTuaSelected.front ||
                          tabSamTuaSelected.down ||
                          tabSongTuaSelected.bon ||
                          tabSongTuaSelected.down ||
                          tabRunSelected.bon ||
                          tabRunSelected.down
                      "
                    >
                      <div class="num-pad box__show-number">
                        <h4 class="text-center mt-2">ระบุตัวเลข</h4>
                        <b-row>
                          <b-col
                            class="d-flex label-number lists justify-content-center"
                          >
                            <input
                              class="form-control number code-input text-center align-self-center bg-white"
                              maxlength="1"
                              v-model="number[0]"
                              @keypress="isNumber"
                              @keyup="goNext($event.target)"
                              readonly
                            />
                            <input
                              class="form-control number code-input text-center align-self-center bg-white"
                              maxlength="1"
                              v-model="number[1]"
                              @keypress="isNumber"
                              @keyup="goNext($event.target)"
                              readonly
                              v-if="
                                (tabSamTuaSelected.bon ||
                                  tabSamTuaSelected.tode ||
                                  tabSamTuaSelected.front ||
                                  tabSamTuaSelected.down ||
                                  tabSongTuaSelected.bon ||
                                  tabSongTuaSelected.down) &&
                                  !tabSongTuaSelected.ntDoors &&
                                  !tabSongTuaSelected.swipeFront &&
                                  !tabSongTuaSelected.swipeBack
                              "
                            />
                            <input
                              class="form-control number code-input text-center align-self-center bg-white"
                              maxlength="1"
                              v-model="number[2]"
                              @keypress="isNumber"
                              @keyup="goNext($event.target)"
                              readonly
                              v-if="
                                tabSamTuaSelected.bon ||
                                  tabSamTuaSelected.tode ||
                                  tabSamTuaSelected.front ||
                                  tabSamTuaSelected.down
                              "
                            />
                          </b-col>
                        </b-row>
                        <div class="key-pad box__keyboard">
                          <div class="row p-2">
                            <div class="col-9">
                              <b-row class="numpad">
                                <b-col cols="4" class="p-1">
                                  <button
                                    class="btn btn-outline-primary btn-block"
                                    data-id="1"
                                    @click="numpadClick('1')"
                                  >
                                    1
                                  </button>
                                </b-col>
                                <b-col cols="4" class="p-1">
                                  <button
                                    class="btn btn-outline-primary btn-block"
                                    data-id="2"
                                    @click="numpadClick('2')"
                                  >
                                    2
                                  </button>
                                </b-col>
                                <b-col cols="4" class="p-1">
                                  <button
                                    class="btn btn-outline-primary btn-block"
                                    data-id="3"
                                    @click="numpadClick('3')"
                                  >
                                    3
                                  </button>
                                </b-col>
                                <b-col cols="4" class="p-1">
                                  <button
                                    class="btn btn-outline-primary btn-block"
                                    data-id="4"
                                    @click="numpadClick('4')"
                                  >
                                    4
                                  </button>
                                </b-col>
                                <b-col cols="4" class="p-1">
                                  <button
                                    class="btn btn-outline-primary btn-block"
                                    data-id="5"
                                    @click="numpadClick('5')"
                                  >
                                    5
                                  </button>
                                </b-col>
                                <b-col cols="4" class="p-1">
                                  <button
                                    class="btn btn-outline-primary btn-block"
                                    data-id="6"
                                    @click="numpadClick('6')"
                                  >
                                    6
                                  </button>
                                </b-col>
                                <b-col cols="4" class="p-1">
                                  <button
                                    class="btn btn-outline-primary btn-block"
                                    data-id="7"
                                    @click="numpadClick('7')"
                                  >
                                    7
                                  </button>
                                </b-col>
                                <b-col cols="4" class="p-1">
                                  <button
                                    class="btn btn-outline-primary btn-block"
                                    data-id="8"
                                    @click="numpadClick('8')"
                                  >
                                    8
                                  </button>
                                </b-col>
                                <b-col cols="4" class="p-1">
                                  <button
                                    class="btn btn-outline-primary btn-block"
                                    data-id="9"
                                    @click="numpadClick('9')"
                                  >
                                    9
                                  </button>
                                </b-col>
                                <b-col cols="4" class="p-1">
                                  <button
                                    class="btn btn-blank"
                                    disabled
                                  ></button>
                                </b-col>
                                <b-col cols="4" class="p-1">
                                  <button
                                    class="btn btn-outline-primary btn-block"
                                    data-id="0"
                                    @click="numpadClick('0')"
                                  >
                                    0
                                  </button>
                                </b-col>
                                <b-col cols="4" class="p-1">
                                  <button
                                    class="btn btn-blank"
                                    disabled
                                  ></button>
                                </b-col>
                                <b-col cols="4" class="p-1">
                                  <!-- <button class="btn btn-blank" disabled></button> -->
                                </b-col>
                              </b-row>
                            </div>
                            <b-col cols="3">
                              <b-row class="numpad">
                                <b-col cols="12" class="p-1">
                                  <button
                                    class="btn btn-danger btn-block"
                                    data-id="delete"
                                    @click="
                                      number = number.substring(
                                        0,
                                        number.length - 1
                                      )
                                    "
                                  >
                                    <i class="fas fa-backspace"></i>
                                  </button>
                                </b-col>
                                <b-col cols="12" class="p-1">
                                  <button
                                    class="btn btn-secondary btn-block btn-cancel warning btn-cancle-last-add-num"
                                    @click="numbers.splice(-1, 1)"
                                  >
                                    <span class="small">ยกเลิกล่าสุด</span>
                                  </button>
                                </b-col>
                                <b-col cols="12" class="p-1">
                                  <button
                                    class="btn btn-dark btn-block btn-reset btn-reset-jp"
                                    @click="resetSelectedNumbers()"
                                  >
                                    <span class="small">ล้างข้อมูล</span>
                                  </button>
                                </b-col>
                              </b-row>
                            </b-col>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    :class="[
                      'tab-pane',
                      'fade',
                      tabActive == 'panghuay' ? 'active show' : '',
                    ]"
                    id="nav-panghuay"
                    role="tabpanel"
                    aria-labelledby="nav-panghuay-tab"
                  >
                    <div class="w-100 p-1">
                      <ul
                        class="nav nav-pills nav-justified mb-2"
                        id="number-tab"
                        role="tablist"
                      >
                        <li class="nav-item">
                          <a
                            :class="[
                              'nav-link ',
                              'p-1',
                              'py-3',
                              'btn-outline-red',
                              tabPangHuaySelected == 'pills-3'
                                ? 'active show'
                                : '',
                            ]"
                            @click="tabPangHuaySelected = 'pills-3'"
                            href="javascript:void()"
                            id="pills-3-tab"
                            data-toggle="pill"
                            role="tab"
                            aria-controls="pills-3"
                            :aria-selected="tabPangHuaySelected == 'pills-3'"
                            >สามตัว</a
                          >
                        </li>
                        <li class="nav-item">
                          <a
                            :class="[
                              'nav-link ',
                              'p-1',
                              'py-3',
                              'btn-outline-blue',
                              tabPangHuaySelected == 'pills-2'
                                ? 'active show'
                                : '',
                            ]"
                            @click="tabPangHuaySelected = 'pills-2'"
                            href="javascript:void()"
                            id="pills-2-tab"
                            data-toggle="pill"
                            role="tab"
                            aria-controls="pills-2"
                            :aria-selected="tabPangHuaySelected == 'pills-2'"
                            >สองตัว</a
                          >
                        </li>
                        <li class="nav-item">
                          <a
                            :class="[
                              'nav-link',
                              'p-1',
                              'py-3',
                              'btn-outline-green',
                              tabPangHuaySelected == 'pills-1'
                                ? 'active show'
                                : '',
                            ]"
                            @click="tabPangHuaySelected = 'pills-1'"
                            href="javascript:void()"
                            id="pills-1-tab"
                            data-toggle="pill"
                            role="tab"
                            aria-controls="pills-1"
                            :aria-selected="tabPangHuaySelected == 'pills-1'"
                            >เลขวิ่ง</a
                          >
                        </li>
                      </ul>

                      <div class="tab-content" id="pills-tabContent-number">
                        <div
                          :class="[
                            'tab-pane',
                            tabPangHuaySelected == 'pills-3'
                              ? 'fade active show'
                              : '',
                          ]"
                          id="pills-3"
                          role="tabpanel"
                          aria-labelledby="pills-3-tab"
                        >
                          <!-- search row -->
                          <div class="row m-0">
                            <!-- <div class="col-12 col-sm-12 col-md-8 p-1">
                              <div class="input-group input-group-sm">
                                <input
                                  type="text"
                                  class="form-control"
                                  placeholder="ค้นหาตัวเลข"
                                  aria-label="ค้นหาตัวเลข"
                                  aria-describedby="button-addon2"
                                  id="search-number"
                                />
                                <div class="input-group-append">
                                  <button
                                    class="btn btn-outline-secondary"
                                    type="button"
                                    id="button-addon2"
                                  >
                                    <i class="fas fa-search"></i>
                                  </button>
                                </div>
                              </div>
                            </div>
                            <div class="col-12 col-sm-12 col-md-4 p-1">
                              <div class="row-btn-tanghuay">
                                <button
                                  :class="[
                                    'btn btn-outline-secondary btn-block btn-sm btn-panghuay py-2',
                                    tabSamTuaSelected.swap === true
                                      ? 'active'
                                      : ''
                                  ]"
                                  @click="setSamTuaSelected('swap')"
                                  href
                                  id="shuffle_3"
                                >
                                  <i class="fas fa-random"></i> กลับตัวเลข
                                </button>
                              </div>
                            </div>-->
                            <div class="col-12 p-1">
                              <button :class="['btn btn-outline-secondary btn-block btn-sm btn-panghuay py-2', tabSamTuaSelected.swap ? 'active show' : '']" @click="setSamTuaSelected('swap')"><i class="fas fa-random"></i> กลับตัวเลข
                              </button>
                            </div>
                            <div class="col-6 p-1">
                              <div class="row-btn-tanghuay">
                                <button
                                  :class="[
                                    'btn',
                                    'btn-outline-red',
                                    'btn-sm',
                                    'btn-block',
                                    'h-100',
                                    'd-flex',
                                    'justify-content-between',
                                    'align-items-center',
                                    'btn-panghuay',
                                    'bet_three',
                                    tabSamTuaSelected.bon === true
                                      ? 'fade active show'
                                      : '',
                                  ]"
                                  @click="setSamTuaSelected('bon')"
                                  href="javascript:void()"
                                  id="teng_bon_3"
                                >
                                  <div class="bg-danger text-white flex-fill">
                                    <i> <small>3</small> ตัวบน </i>
                                  </div>
                                  <div>{{rate.samTua.bon}}</div>
                                </button>
                              </div>
                            </div>
                            <div class="col-6 p-1">
                              <div class="row-btn-tanghuay">
                                <button
                                  :class="[
                                    'btn',
                                    'btn-outline-red',
                                    'btn-sm',
                                    'btn-block',
                                    'h-100',
                                    'd-flex',
                                    'justify-content-between',
                                    'align-items-center',
                                    'btn-panghuay',
                                    'bet_three',
                                    tabSamTuaSelected.tode === true
                                      ? 'fade active show'
                                      : '',
                                  ]"
                                  @click="setSamTuaSelected('tode')"
                                  href="javascript:void()"
                                  id="tode_3"
                                >
                                  <div class="bg-danger text-white flex-fill">
                                    <i> <small>3</small> ตัวโต๊ด </i>
                                  </div>
                                  <div class="text-center">{{rate.samTua.tode}}</div>
                                </button>
                              </div>
                            </div>
                            <div
                              class="col-6 p-1"
                              v-if="
                                lottoInfo.lotto &&
                                  lottoInfo.lotto.lottoType == 3
                              "
                            >
                              <div class="row-btn-tanghuay">
                                <button
                                  :class="[
                                    'btn',
                                    'btn-outline-red',
                                    'btn-sm',
                                    'btn-block',
                                    'h-100',
                                    'd-flex',
                                    'justify-content-between',
                                    'align-items-center',
                                    'btn-panghuay',
                                    'bet_three',
                                    tabSamTuaSelected.front === true
                                      ? 'fade active show'
                                      : '',
                                  ]"
                                  @click="setSamTuaSelected('front')"
                                  href="javascript:void()"
                                >
                                  <div class="bg-danger text-white flex-fill">
                                    <i> <small>3</small> ตัวหน้า </i>
                                  </div>
                                  <div>{{rate.samTua.front}}</div>
                                </button>
                              </div>
                            </div>
                            <div
                              class="col-6 p-1"
                              v-if="
                                lottoInfo.lotto &&
                                  lottoInfo.lotto.lottoType == 3
                              "
                            >
                              <div class="row-btn-tanghuay">
                                <button
                                  :class="[
                                    'btn',
                                    'btn-outline-red',
                                    'btn-sm',
                                    'btn-block',
                                    'h-100',
                                    'd-flex',
                                    'justify-content-between',
                                    'align-items-center',
                                    'btn-panghuay',
                                    'bet_three',
                                    tabSamTuaSelected.down === true
                                      ? 'fade active show'
                                      : '',
                                  ]"
                                  @click="setSamTuaSelected('down')"
                                  href="javascript:void()"
                                  id="tode_3"
                                >
                                  <div class="bg-danger text-white flex-fill">
                                    <i> <small>3</small> ตัวล่าง </i>
                                  </div>
                                  <div class="text-center">{{rate.samTua.down}}</div>
                                </button>
                              </div>
                            </div>
                          </div>
                          <!-- end search row -->
                          <div id="samtua">
                            <b-overlay
                              :show="tabSamTuaSelected.overlay"
                              rounded="sm"
                            >
                              <template #overlay>
                                <div class="text-center">
                                  กรุณาเลือก 3 ตัวบน หรือ 3 ตัวโต๊ดด้านบนก่อน
                                </div>
                              </template>
                              <div
                                class="overlay-disable"
                                id="oversamtua"
                                style="display: none;"
                              ></div>
                              <ul
                                class="nav nav-pills mb-3 justify-content-center"
                                id="numlist-tab1"
                                role="tablist"
                              >
                                <li
                                  class="nav-item flex-fill text-center"
                                  v-for="item in numberPanel.three.numberSets"
                                  v-bind:key="'btn-' + item.title"
                                >
                                  <a
                                    :class="[
                                      'nav-link',
                                      'border',
                                      'm-1',
                                      'px-1',
                                      'txt-num',
                                      tabSamtuaTabNumberSelected ==
                                      'tab-' + item.title
                                        ? 'active show'
                                        : '',
                                    ]"
                                    @click="
                                      tabSamtuaTabNumberSelected =
                                        'tab-' + item.title
                                    "
                                    href="javascript:void()"
                                    :id="'tab-' + item.title"
                                    data-toggle="pill"
                                    role="tab"
                                    :aria-controls="'pills-' + item.title"
                                    :aria-selected="
                                      tabSamtuaTabNumberSelected ==
                                        'tab-' + item.title
                                    "
                                    >{{ item.title }}</a
                                  >
                                </li>
                              </ul>
                              <div class="tab-content" id="numlist-tabContent1">
                                <div
                                  :class="[
                                    'text-center',
                                    'tab-pane',
                                    tabSamtuaTabNumberSelected ==
                                    'tab-' + item.title
                                      ? 'fade active show'
                                      : '',
                                  ]"
                                  :id="'pills-' + item.title"
                                  role="tabpanel"
                                  :aria-labelledby="
                                    'pills-' + item.title + '-tab'
                                  "
                                  v-for="item in numberPanel.three.numberSets"
                                  v-bind:key="'tab-' + item.title"
                                >
                                  <div
                                    class="btn-group-toggle column d-inline"
                                    data-toggle="buttons"
                                    v-for="(num, index) in item.numbers"
                                    v-bind:key="num + '-' + index"
                                  >
                                    <label
                                      :class="[
                                        'btn',
                                        lottoInfo.lotto && checkLimitNumber(num)
                                          ? 'btn-outline-danger'
                                          : 'btn-outline-danger-gold',
                                        'btn-sm',
                                        'mb-1',
                                        'panghuay_number',
                                        checkNumber(
                                          selectedNumbers.samTua.bon,
                                          num
                                        ) ||
                                        checkNumber(
                                          selectedNumbers.samTua.tode,
                                          num
                                        ) ||
                                        checkNumber(
                                          selectedNumbers.samTua.front,
                                          num
                                        ) ||
                                        checkNumber(
                                          selectedNumbers.samTua.down,
                                          num
                                        )
                                          ? 'active'
                                          : '',
                                      ]"
                                      @click="selectNumber(num)"
                                    >
                                      <!-- <input type="checkbox" autocomplete="off" name="threenumber" :value="num"> -->
                                      {{ num }}
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </b-overlay>
                          </div>
                        </div>

                        <div
                          :class="[
                            'tab-pane',
                            tabPangHuaySelected == 'pills-2'
                              ? 'fade active show'
                              : '',
                          ]"
                          id="pills-2"
                          role="tabpanel"
                          aria-labelledby="pills-2-tab"
                        >
                          <!-- search row -->
                          <div class="row m-0">
                            <!-- <div class="col-12 col-sm-12 col-md-8 p-1">
                              <div class="input-group input-group-sm">
                                <input
                                  type="text"
                                  class="form-control"
                                  placeholder="ค้นหาตัวเลข"
                                  aria-label="ค้นหาตัวเลข"
                                  aria-describedby="button-addon2"
                                  id="search-number2"
                                />
                                <div class="input-group-append">
                                  <button
                                    class="btn btn-outline-secondary"
                                    type="button"
                                    id="button-addon2"
                                  >
                                    <i class="fas fa-search"></i>
                                  </button>
                                </div>
                              </div>
                            </div>
                            <div class="col-12 col-sm-12 col-md-4 p-1">
                              <button
                                :class="[
                                  'btn btn-outline-secondary btn-block btn-sm btn-panghuay py-2',
                                  tabSongTuaSelected.swap ? 'active' : ''
                                ]"
                                href
                                id="shuffle_2"
                                @click="setSongTuaSelected('swap')"
                              >
                                <i class="fas fa-random"></i> กลับตัวเลข
                              </button>
                            </div>-->
                          </div>
                          <!-- end search row -->
                          <div class="row m-0">
                            <div class="col-12 p-1">
                              <button :class="['btn btn-outline-secondary btn-block btn-sm btn-panghuay py-2', tabSongTuaSelected.swap ? 'active' : '']" @click="setSongTuaSelected('swap')"><i class="fas fa-random"></i> กลับตัวเลข
                              </button>
                            </div>
                            <div class="col-6 p-1">
                              <div class="row-btn-tanghuay">
                                <button
                                  :class="[
                                    'btn',
                                    'btn-outline-blue',
                                    'btn-sm btn-block',
                                    'h-100',
                                    'd-flex',
                                    'justify-content-between',
                                    'align-items-center',
                                    'btn-panghuay',
                                    'bet_two',
                                    tabSongTuaSelected.bon ? 'active' : '',
                                  ]"
                                  id="teng_bon_2"
                                  @click="setSongTuaSelected('bon')"
                                >
                                  <div class="bg-primary text-white flex-fill">
                                    <i> <small>2</small> ตัวบน </i>
                                  </div>
                                  <div class="text-center">{{rate.songTua.bon}}</div>
                                </button>
                              </div>
                            </div>
                            <div class="col-6 p-1">
                              <div class="row-btn-tanghuay">
                                <button
                                  :class="[
                                    'btn',
                                    'btn-outline-blue',
                                    'btn-sm',
                                    'btn-block',
                                    'h-100',
                                    'd-flex',
                                    'justify-content-between',
                                    'align-items-center',
                                    'btn-panghuay',
                                    'bet_two',
                                    tabSongTuaSelected.down ? 'active' : '',
                                  ]"
                                  id="teng_down_2"
                                  @click="setSongTuaSelected('down')"
                                >
                                  <div class="bg-primary text-white flex-fill">
                                    <i> <small>2</small> ตัวล่าง </i>
                                  </div>
                                  <div class="text-center">{{rate.songTua.down}}</div>
                                </button>
                              </div>
                            </div>

                            <div
                              class="col-12 col-sm-12 col-md-12 col-lg-4 pt-1 pb-0 px-0 px-sm-0 px-md-2"
                            >
                              <div id="ninetybtn" class></div>
                              <span class="d-block d-sm-block d-md-inline"
                                >19 ประตู</span
                              >
                              <div
                                class="btn-group btn-group-sm d-flex"
                                role="group"
                              >
                                <div
                                  class="btn-group-toggle d-inline flex-fill"
                                  data-toggle="buttons"
                                  v-for="(num, index) in 10"
                                  v-bind:key="index"
                                >
                                  <label
                                    :class="[
                                      'btn btn-outline-secondary btn-rood btn-sm mb-1 panghuay_option_2',
                                      tabSongTuaSelected.overlay == 'show'
                                        ? 'disabled'
                                        : '',
                                      ntDoorsSelected.includes(index)
                                        ? 'active'
                                        : '',
                                    ]"
                                    data-id="0"
                                    data-option="option_2_19"
                                    @click="
                                      tabSongTuaSelected.overlay == 'show'
                                        ? false
                                        : ntDoors(index)
                                    "
                                    >{{ index }}</label
                                  >
                                </div>
                              </div>
                            </div>
                            <div
                              class="col-12 col-sm-12 col-md-12 col-lg-4 pt-1 pb-0 px-0 px-sm-0 px-md-2"
                            >
                              <div id="roodfrontbtn" class></div>
                              <span class="d-block d-sm-block d-md-inline"
                                >รูดหน้า</span
                              >
                              <div
                                class="btn-group btn-group-sm d-flex"
                                role="group"
                              >
                                <div
                                  class="btn-group-toggle d-inline flex-fill"
                                  data-toggle="buttons"
                                  v-for="(num, index) in 10"
                                  v-bind:key="index"
                                >
                                  <label
                                    :class="[
                                      'btn btn-outline-secondary btn-rood btn-sm mb-1 panghuay_option_2',
                                      tabSongTuaSelected.overlay == 'show'
                                        ? 'disabled'
                                        : '',
                                      swipeFrontSelected.includes(index)
                                        ? 'active'
                                        : '',
                                    ]"
                                    data-id="0"
                                    @click="
                                      tabSongTuaSelected.overlay == 'show'
                                        ? false
                                        : swipeFront(index)
                                    "
                                    data-option="option_2_roodnha"
                                    >{{ index }}</label
                                  >
                                </div>
                              </div>
                            </div>
                            <div
                              class="col-12 col-sm-12 col-md-12 col-lg-4 pt-1 pb-0 px-0 px-sm-0 px-md-2"
                            >
                              <div id="roodbackbtn" class></div>
                              <span class="d-block d-sm-block d-md-inline"
                                >รูดหลัง</span
                              >
                              <div
                                class="btn-group btn-group-sm d-flex"
                                role="group"
                              >
                                <div
                                  class="btn-group-toggle d-inline flex-fill"
                                  data-toggle="buttons"
                                  v-for="(num, index) in 10"
                                  v-bind:key="index"
                                >
                                  <label
                                    :class="[
                                      'btn btn-outline-secondary btn-rood btn-sm mb-1 panghuay_option_2',
                                      tabSongTuaSelected.overlay == 'show'
                                        ? 'disabled'
                                        : '',
                                      swipeBackSelected.includes(index)
                                        ? 'active'
                                        : '',
                                    ]"
                                    data-id="0"
                                    @click="
                                      tabSongTuaSelected.overlay == 'show'
                                        ? false
                                        : swipeBack(index)
                                    "
                                    data-option="option_2_roodlung"
                                    >{{ index }}</label
                                  >
                                </div>
                              </div>
                            </div>
                            <div class="w-100 border-top my-1"></div>
                            <b-overlay
                              :show="tabSongTuaSelected.overlay"
                              rounded="sm"
                            >
                              <template #overlay>
                                <div class="text-center">
                                  กรุณาเลือก 2 ตัวบน หรือ 2 ตัวล่างด้านบนก่อน
                                </div>
                              </template>
                              <div
                                class="col-12 text-center px-0 py-1"
                                id="numlist-tabContent2"
                              >
                                <div id="twonumberbtn" class></div>

                                <div
                                  class="btn-group-toggle d-inline column"
                                  data-toggle="buttons"
                                  v-for="(num, index) in numberPanel.two.numbers"
                                  v-bind:key="index + '-' + num"
                                >
                                  <label
                                    :class="[
                                      'btn',
                                      'btn-outline-danger-gold',
                                      'btn-sm mb-1',
                                      'panghuay_number',
                                      checkNumber(
                                        selectedNumbers.songTua.bon,
                                        num
                                      ) ||
                                      checkNumber(
                                        selectedNumbers.songTua.down,
                                        num
                                      )
                                        ? 'active'
                                        : '',
                                    ]"
                                    @click="selectNumber(num)"
                                    >{{ num }}</label
                                  >
                                </div>
                              </div>
                            </b-overlay>
                          </div>
                        </div>

                        <div
                          :class="[
                            'tab-pane',
                            tabPangHuaySelected == 'pills-1'
                              ? 'fade active show'
                              : '',
                          ]"
                          id="pills-1"
                          role="tabpanel"
                          aria-labelledby="pills-1-tab"
                        >
                          <!-- search row -->
                          <!-- <div class="row m-0">
                            <div class="col-12 col-sm-12 col-md-12 p-1">
                              <div class="input-group input-group-sm">
                                <input
                                  type="text"
                                  class="form-control"
                                  placeholder="ค้นหาตัวเลข"
                                  aria-label="ค้นหาตัวเลข"
                                  aria-describedby="button-addon2"
                                  id="search-number3"
                                />
                                <div class="input-group-append">
                                  <button
                                    class="btn btn-outline-secondary"
                                    type="button"
                                    id="button-addon2"
                                  >
                                    <i class="fas fa-search"></i>
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>-->
                          <!-- end search row -->
                          <div class="row m-0">
                            <div class="col-6 p-1">
                              <div class="row-btn-tanghuay">
                                <button
                                  :class="[
                                    'btn btn-outline-green btn-sm btn-block h-100 d-flex justify-content-between align-items-center btn-panghuay bet_run',
                                    tabRunSelected.bon === true ? 'active' : '',
                                  ]"
                                  @click="setRunSelected('bon')"
                                  id="teng_bon_1"
                                >
                                  <div class="bg-success text-white flex-fill">
                                    <i>วิ่ง</i>
                                    <i>บน</i>
                                  </div>
                                  <div class="text-center">{{rate.run.bon}}</div>
                                </button>
                              </div>
                            </div>
                            <div class="col-6 p-1">
                              <div class="row-btn-tanghuay">
                                <button
                                  :class="[
                                    'btn btn-outline-green btn-sm btn-block h-100 d-flex justify-content-between align-items-center btn-panghuay bet_run',
                                    tabRunSelected.down === true
                                      ? 'active'
                                      : '',
                                  ]"
                                  @click="setRunSelected('down')"
                                  id="teng_down_1"
                                >
                                  <div class="bg-success text-white flex-fill">
                                    <i>วิ่ง</i>
                                    <i>ล่าง</i>
                                  </div>
                                  <div class="text-center">{{rate.run.down}}</div>
                                </button>
                              </div>
                            </div>
                            <div id="numlist-tabContent3" class="col-12 p-1">
                              <b-overlay
                                :show="tabRunSelected.overlay"
                                rounded="sm"
                              >
                                <template #overlay>
                                  <div class="text-center">
                                    กรุณาเลือกวิ่งบน/วิ่งล่างจากด้านบนก่อน
                                  </div>
                                </template>
                                <div
                                  class="d-flex flex-wrap flex-row justify-content-center"
                                >
                                  <div
                                    :class="[
                                      'btn-group-toggle',
                                      'flex-fill',
                                      'column p-1',
                                    ]"
                                    v-for="(num, index) in numberPanel.run.numbers"
                                    v-bind:key=" num"
                                  >
                                    <label
                                      :class="[
                                        'btn',
                                        'btn-outline-secondary',
                                        'btn-block',
                                        'txt-num',
                                        'mb-1',
                                        'btn-outline-danger-gold',
                                        'panghuay_number',
                                        checkNumber(
                                          selectedNumbers.run.bon,
                                          num
                                        ) ||
                                        checkNumber(
                                          selectedNumbers.run.down,
                                          num
                                        )
                                          ? 'active'
                                          : '',
                                      ]"
                                      @click="selectNumber(num)"
                                      >{{ num }}</label
                                    >
                                  </div>
                                </div>
                              </b-overlay>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="w-100">
                    <div class="row mb-2 py-3 mx-0 bg-dark rounded">
                      <div class="col pr-1">
                        <button
                          class="btn btn-light btn-sm btn-block number-sets border triggerPoy"
                          @click="$bvModal.show('numberSetModal')"
                        >
                          <i class="fas fa-list-ol"></i> ดึงโพย
                        </button>
                      </div>
                      <div class="col pl-1">
                        <button
                          class="btn btn-danger btn-sm btn-block show-lists triggerPrice"
                          @click="
                            betSlot.length > 0
                              ? [$bvModal.show('priceModal'), resetSamTuaSelected(), resetSongTuaSelected(), resetRunSelected()]
                              : false
                          "
                          :disabled="betSlot.length > 0 ? false : 'disabled'"
                        >
                          <i class="fas fa-edit"></i> ใส่ราคา
                        </button>
                      </div>
                    </div>
                  </div>

                  <div class="box__condition-info">
                    <h2>
                      <i class="fas fa-exclamation-circle"></i> เงื่อนไขการแทง
                    </h2>
                    <div class="row">
                      <div class="col-md-12" id="content_teng_bon_1">
                        <li>2 ตัวบน-ล่าง: แทงสูงสุด/เลข/งวด 2,000</li>
                        <li>3 ตัวตรง-โต๊ด-ล่าง: แทงสูงสุด/เลข/งวด 500</li>
                        <li>วิ่งบน-ล่าง: แทงสูงสุด/เลข/งวด 20,000</li>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            :class="[
              'bgwhitealpha',
              'text-secondary',
              'shadow-sm',
              'rounded',
              'p-2',
              'p-2',
              'mt-1',
              'flex-column',
              'mb-5',
              numPageActive == 'numpage_2' ? '' : 'd-none',
            ]"
            id="numpage_2"
            v-bind:style="
              numPageActive == 'numpage_2'
                ? { display: [''] }
                : { display: ['none'] }
            "
          >
            <h3 class="text-center">
              <i class="sn-icon sn-icon--graph2"></i> ผลรวมยี่กี
            </h3>
            <h3 class="text-center" id="total_ying">{{ dice.totalDice }}</h3>
            <div class="form-shot-number">
              <input
                placeholder="กรอกตัวเลข 5 หลัก"
                maxlength="5"
                type="text"
                v-model="yingNumber"
                readonly="readonly"
                class="form-control form-control-lg text-center show-input-number"
              />
              <div
                class="key-pad box__keyboard yeekee__number"
                v-bind:style="
                  numPageActive == 'numpage_2'
                    ? { display: [''] }
                    : { display: ['none'] }
                "
              >
                <div class="row p-2 group">
                  <div class="col-3 p-1">
                    <button
                      class="btn btn-outline-primary btn-block"
                      @click="addYingNumber('1')"
                    >
                      1
                    </button>
                  </div>
                  <div class="col-3 p-1">
                    <button
                      class="btn btn-outline-primary btn-block"
                      @click="addYingNumber('2')"
                    >
                      2
                    </button>
                  </div>
                  <div class="col-3 p-1">
                    <button
                      class="btn btn-outline-primary btn-block"
                      @click="addYingNumber('3')"
                    >
                      3
                    </button>
                  </div>
                  <div class="col-3 p-1">
                    <button
                      class="btn btn-danger btn-block delete__number"
                      @click="
                        yingNumber = yingNumber.substring(
                          0,
                          yingNumber.length - 1
                        )
                      "
                    >
                      <i class="fas fa-backspace"></i>
                    </button>
                  </div>
                  <div class="col-3 p-1">
                    <button
                      class="btn btn-outline-primary btn-block"
                      @click="addYingNumber('4')"
                    >
                      4
                    </button>
                  </div>
                  <div class="col-3 p-1">
                    <button
                      class="btn btn-outline-primary btn-block"
                      @click="addYingNumber('5')"
                    >
                      5
                    </button>
                  </div>
                  <div class="col-3 p-1">
                    <button
                      class="btn btn-outline-primary btn-block"
                      @click="addYingNumber('6')"
                    >
                      6
                    </button>
                  </div>
                  <div class="col-3 p-1">
                    <button
                      class="btn btn-secondary btn-block random__number px-0"
                      @click="randomYing()"
                    >
                      <span>สุ่มเลข</span>
                    </button>
                  </div>
                  <div class="col-3 p-1">
                    <button
                      class="btn btn-outline-primary btn-block"
                      @click="addYingNumber('7')"
                    >
                      7
                    </button>
                  </div>
                  <div class="col-3 p-1">
                    <button
                      class="btn btn-outline-primary btn-block"
                      @click="addYingNumber('8')"
                    >
                      8
                    </button>
                  </div>
                  <div class="col-3 p-1">
                    <button
                      class="btn btn-outline-primary btn-block"
                      @click="addYingNumber('9')"
                    >
                      9
                    </button>
                  </div>
                  <div class="col-3 p-1">
                    <button
                      class="btn btn-success btn-block submit-number yeekee__submit px-0"
                      @click="submitDice"
                      :disabled="diceButtonDisabled ? true : false"
                    >
                      เพิ่มเลข
                      <vue-countdown
                        v-if="countDownDice > 0"
                        :time="countDownDice"
                        v-slot="{ seconds }"
                        @end="
                          sendingDice = false;
                          countDownDice = 0;
                        "
                      >
                        ({{ seconds }})
                      </vue-countdown>
                    </button>
                  </div>
                  <div class="col-3 p-1">
                    <button class="btn btn-blank" disabled></button>
                  </div>
                  <div class="col-3 p-1">
                    <button
                      class="btn btn-outline-primary btn-block"
                      @click="addYingNumber('0')"
                    >
                      0
                    </button>
                  </div>
                  <div class="col-3 p-1">
                    <button class="btn btn-blank" disabled></button>
                  </div>
                  <div class="col-3 p-1">
                    <!-- <button class="btn btn-blank" disabled></button> -->
                  </div>
                </div>
              </div>
            </div>

            <hr class="mt-1 mb-2" />

            <div
              class="d-flex flex-column yeekee__lists-number"
              v-bind:style="
                numPageActive == 'numpage_2'
                  ? { display: [''] }
                  : { display: ['none'] }
              "
            >
              <h5 class="text-center text-success">
                <i class="fas fa-th-list"></i> รายชื่อผู้ทายเลข
              </h5>
              <span id="yresult">
                <div
                  class="flex-row justify-content-between align-items-stretch mb-1 d-flex"
                  id="list_ying_0"
                  v-for="(item, index) in dice.diceList"
                  v-bind:key="item.referID"
                >
                  <div
                    :class="[
                      'text-white text-center rounded p-2 w-25 d-flex flex-column justify-content-around',
                      index == 0 || index == 15 ? 'bg-success' : 'bg-secondary',
                    ]"
                  >
                    <span
                      :class="[
                        'badge badge-pill badge-light',
                        index == 0 || index == 15
                          ? 'text-success'
                          : 'text-secondary',
                      ]"
                    >
                      อันดับที่
                      <span data-id="ly_ranked">{{ index + 1 }}</span>
                    </span>
                    <h3 class="mb-0">
                      <small>{{ item.number }}</small>
                    </h3>
                  </div>
                  <div
                    :class="[
                      'border bg-light rounded p-2 ml-1 flex-fill d-flex flex-column justify-content-around',
                      index == 0 || index == 15
                        ? 'border-success'
                        : 'border-secondary',
                    ]"
                  >
                    <div>
                      <span
                        :class="[
                          'badge badge-pill badge-light',
                          index == 0 || index == 15
                            ? 'text-success'
                            : 'text-secondary',
                        ]"
                      >
                        <i class="fas fa-user-circle"></i>
                        ผู้ส่งเลข
                      </span>
                      <span data-id="ly_send"
                        >{{ item.username.substring(0, 2) }}****{{
                          item.username.substr(item.username.length - 2)
                        }}</span
                      >
                    </div>
                    <hr class="my-1" />
                    <div>
                      <span
                        :class="[
                          'badge badge-pill badge-light',
                          index == 0 || index == 15
                            ? 'text-success'
                            : 'text-secondary',
                        ]"
                      >
                        <i class="fas fa-calendar-check"></i>
                        เมื่อ
                      </span>
                      <span data-id="ly_date">{{
                        formatDate(item.diceTime, "DD/MM/YYYY HH:mm:ss")
                      }}</span>
                    </div>
                  </div>
                </div>
              </span>
            </div>
          </div>
        </div>
      </div>

      <div
        :class="['modal', modalActive == 'ruleyeekee' ? 'fade show' : '']"
        id="rule-yeekee"
        tabindex="-1"
        aria-labelledby="rule-yeekee"
        :style="
          modalActive == 'ruleyeekee'
            ? { display: ['block'] }
            : { display: [''] }
        "
      >
        <!-- <div class="modal fade show" id="rule-yeekee" tabindex="-1" role="dialog" aria-labelledby="rule-yeekee" style="padding-right: 10px; display: block;"> -->
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content" style="border-radius:10px;">
            <div class="modal-header bg-danger text-white">
              <h5 class="modal-title">กติกา</h5>
              <button
                type="button"
                class="text-white close"
                data-dismiss="modal"
                aria-label="Close"
                @click="modalActive = 'close'"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div class="modal-body">
              <h3>
                <strong>หวยจับยี่กี</strong>
              </h3>
              <p>
                หวยจับยี่กี่ กติกาการเเทง&nbsp;
                <strong>{{getAppName}}</strong>
              </p>
              <ul class="ml-3">
                <li>เปิดรับเเทงออนไลน์วันละ 88 รอบ ออกผลรางวัลทุกๆ 15 นาที</li>
                <li>
                  รอบเเรกเริ่มเวลา 06:00น. (เริ่มทายผลใหม่ได้ตั้งเเต่ 05:00น.)
                </li>
                <li>ปิดรับเเทงรอบสุดท้าย เวลา 03:45น.</li>
                <li>
                  สามารถส่งตัวเลขได้ฟรีไม่จำกัดจำนวนครั้งด้วยกติกาที่ชัดเสจเเละตรวจสอบได้
                </li>
                <li>
                  สมาชิกที่ยิงเลขได้ ลำดับที่ 16 จะได้รับเครดิตฟรี 400 บาท เเละ
                  ลำดับ 1 ฟรี 200 บาท เเต่จะต้องมียอดเดิมพันรอบนั้นขั้นต่ำ 100
                  บาทขั้นไป
                </li>
              </ul>
              <h3>
                <strong>เลขวิ่งบน รับทายผล 3 ตัวบนเหมือนหวยรัฐบาล</strong>
              </h3>
              <p>
                &nbsp; &nbsp; &nbsp;หากเลขที่สมาชิกร่วมทายผล&nbsp;
                <strong>มีไม่ถึง 20 ลำดับ</strong>&nbsp;ไม่ว่ากรณีใดก็ตาม
                ทางระบบจะทำการ
                <strong>คืนโพยเเละยอดเงิน</strong>ที่เเทงเข้ามาในรอบนั้นทันที
              </p>
              <p>
                &nbsp; &nbsp; &nbsp;&nbsp;
                <strong>!!หากระบบล่มหรือขัดข้อง&nbsp;</strong>
                ระหว่างก่อนปิดการร่วมส่งทายผลตัวเลขออกรางวัลจนเป็นสาเหตุทำให้สมาชิกไม่สามารถเเข้าใช้งานระบบได้ทีมงานจะทำการตัดสินการออกรางวัลตามความเหมาะสม
              </p>
              <p>
                <strong>
                  (การตัดสินขึ้นอยู่กับดุลพินิจของทีมงาน
                  ทีมงานจะตัดสินด้วยความโปร่งใสเเละเป็นธรรมที่สุด)
                </strong>
              </p>
              <ul class="ml-3">
                <li>
                  ก่อนหมดเวลาร่วมส่งผลทายผลตัวเลขออกรางวัลที่ 1
                  นาทีระบบเกิดปัญหาข้อข้องไม่สามารถเข้าใช้งานได้
                  ทำให้ท่านไม่สามารถเข้าร่วมทายผลตัวเลขได้
                  กรณีนี้ทางทีมงานจะทำการยกเลิกเเละคืนเงินเครดิตในรอบนั้นทีนที
                  ถึงเเม้ว่าก่อนหน้านั้นจะมีสมาชิยิงเข้ามามากกว่า 20 ลำดับก็ตาม
                </li>
              </ul>
              <p>
                <strong>
                  (การออกผลรางวัล คิดจาก ผลรางวัลทีสมาชิกทุกๆท่านส่งตัวเลขจำนวน
                  5 หลัก [12345]&nbsp;
                </strong>
                <strong>
                  จากนั้นทีมงานจะนำตัวเลขที่สมาชิกส่งเข้ามาทั้งหมดในรอบนั้นๆมารวมกัน
                  เเล้ว เอาผลรวมที่ได้นำไปลบกับเลข ลำดับที่ 16 ของรอบนั้น
                  เเละจะนำผลที่ได้มาเป็ยผลออกรางวัล)
                </strong>
              </p>
              <p>
                <strong>ตัวอย่าง การออกผลรางวัล&nbsp;</strong>
                ผลรวมการยิงเลขทั้งหมดได้&nbsp;
                <strong>1234567890 – [51876&nbsp;</strong>
                ตัวอย่างลำดับที่&nbsp;
                <strong>16] = 1234516014</strong>
                &nbsp;&lt;&lt; ผลหลังจากกลบลำดับที่&nbsp;
                <strong>16</strong>
              </p>
              <p>
                ผลรวม 3 ตัวท้าย จะถูกนำมาออกผลรางวัลเป็นเลข 3
                ตัวบนของหวยยี่กี่รอบนั้นผลรวมหลักพันเเละหลักหมื่นจะถูกนำมาออกผลรางวัลเป็นเลข
                2 ตัวล่าง ของหวยยี่กีรอบนั้น
              </p>
              <p>
                ตามตัวอย่างผลรวมหลังลบลำดับที่ 16 ได้ =
                <strong>12345[16][014]</strong> = เลขที่ออก 3 ตัวบนคือ =
                <strong>[014]</strong> เลขที่ออก 2 ตัวล่างคือ =
                <strong>[16]</strong> สมาชิกที่ยิงเลขได้ลำดับที่ 16
                ได้รับเครดิตฟรี 400 บาท
              </p>
              <p>
                <strong>พิเศษ!!</strong> สมาชิกที่ยิงเลขได้ลำดับที่ 1
                จะได้รับเครดิตฟรี 200 บาท
              </p>
              <p>
                <strong
                  >(เงื่อนไขจะต้องมียอดเดิมพันรอบนั้นขั้นต่ำ 100 บาท
                  ขึ้นไป)</strong
                >
              </p>
              <ul class="ml-3">
                <li>หวยยี่กีเปิดรับเเทงวันละ 88 รอบ</li>
                <li>ออกผลรางวัลทุกๆ 15 นาที</li>
                <li>
                  เปิดรอบเเรก 06:00น. – 03:45น.
                  หลังจากหวยยี่กีปิดรับเเทงเเต่ละรอบ
                </li>
                <li>
                  ระบบยิงเลขเปิดให้ยิง 2 นาทีหลังจากระบบยิงเลขปิดอีก 1 นาที
                </li>
                <li>ระบบจะทำการตรวจโพยโดยใช้เวลาการจ่ายเงิน 2 – 5 นาที</li>
              </ul>
              <p>
                <strong>ตัวอย่าง</strong>
              </p>
              <p>
                ยี่กี่รอบที่ 1 ปิดรับเเทง 06:00น. ยิงเลขได้ถึง 06:02น. เเละ
                ระบบจะตรวจสอบโพยเวลา 06:03น.
                เเละจ่ายเงินท่านทั้งหมดเสร็จภายในเวลาไม่เกิน 06:08น
              </p>
              <p>
                <strong>
                  ** โปรดตั้งเวลาของอุปกรณ์เข้าเล่นของท่านให้ตรงกับเวลาในเว็บ
                  เพื่อที่ท่านจะได้ไม่สับสนกับเวลาปิดรับ
                  เวลาที่เเสดงผลการส่งตัวเลขจะใช้เวลาจากเซิฟเวอร์จริง **
                </strong>
              </p>
              <p>
                <strong>อัตตราการจ่ายหวยยี่กี</strong>
              </p>
              <p>3 ตัวบน ราคาจ่าย 850 บาท</p>
              <p>3 ตัวโต๊ด ราคาจ่าย 120 บาท</p>
              <p>2 ตัวบน – ล่าง ราคา 92 บาท</p>
              <p>เลขวิ่ง 3 ตัวบน ราคา 3.2 บาท</p>
              <p>เลขวิ่ง 2 ตัวล่าง ราคา 4.2 บาท</p>
              <p>
                <strong>
                  *หากราคามีการเปลี่ยนเเปล
                  จะเเจ้งให้ทราบล่วงหน้าก่อนมีการเปลี่ยนเเปลง 7 วัน
                </strong>
              </p>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal">
                ฉันเข้าใจและยอมรับ
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <FooterIndex class="mt-3" />
    <b-modal
      id="priceModal"
      size="xl"
      class="pl-0"
      dialog-class="price-modal mx-0 mx-sm-auto"
      content-class="min-vh-100"
      header-class="golden-header w-100 text-center px-2 py-1"
      header-bg-variant="warning"
      header-text-variant="black"
      body-class="p-0"
      centered
      scrollable
      hide-footer
    >
      <template #modal-title>
        <div class="w-100 text-center text-dark font-weight-bold">
          <small>
            <i class="far fa-edit"></i> ใส่ราคา
            <b-badge variant="dark" pill>จำนวน 12 รายการ</b-badge>
          </small>
        </div>
      </template>
      <div class="border-bottom">
        <table
          class="table table-striped table-hover table-sm"
          v-if="selectedSortedNumbers.run.bon.length > 0"
        >
          <thead>
            <tr class="bg-default">
              <th>#</th>
              <th colspan="2">วิ่งบน</th>
              <th class="text-primary text-center px-0">อัตราคูณ</th>
              <th>เรทชนะ</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) in selectedSortedNumbers.run.bon"
              v-bind:key="index + '-' + item"
            >
              <td class="align-middle px-0 text-center" width="30">
                {{ index + 1 }}.
              </td>
              <td
                class="align-middle bg-success text-white font-weight-bold text-center px-0"
                width="40"
              >
                {{ item.number }}
              </td>
              <td class="align-middle">
                <b-input
                  type="number"
                  min="10"
                  class="text-center px-0"
                  v-model="item.price"
                  @change="
                    parseInt(item.price) < 10
                      ? (item.price = 10)
                      : parseInt(item.price)
                  "
                ></b-input>
              </td>
              <td
                :class="
                  checkLimitNumberWithType(5, item.number)
                    ? 'align-middle text-center px-0 text-danger'
                    : 'align-middle text-center px-0'
                "
                width="50"
              >
                {{
                  checkLimitNumberWithType(5, item.number)
                    ? getLimitNumberPrice(5, item.number)
                    : rate.run.bon
                }}
              </td>
              <td class="align-middle">
                <b-input
                  :class="
                    checkLimitNumberWithType(5, item.number)
                      ? 'px-0 text-center text-danger'
                      : 'px-0 text-center'
                  "
                  readonly
                  :value="
                    (
                      (checkLimitNumberWithType(5, item.number)
                        ? getLimitNumberPrice(5, item.number)
                        : rate.run.bon) * parseInt(item.price)
                    ).toFixed(2) + '฿'
                  "
                ></b-input>
              </td>
              <td class="align-middle text-center" width="50">
                <b-btn
                  variant="warning"
                  @click="deleteNumber('run', 'bon', item.number)"
                >
                  <i class="far fa-trash-alt"></i>
                </b-btn>
              </td>
            </tr>
          </tbody>
        </table>
        <table
          class="table table-striped table-hover table-sm"
          v-if="selectedSortedNumbers.songTua.bon.length > 0"
        >
          <thead>
            <tr class="bg-default">
              <th>#</th>
              <th colspan="2">สองตัวบน</th>
              <th class="text-primary text-center px-0">อัตราคูณ</th>
              <th>เรทชนะ</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) in selectedSortedNumbers.songTua.bon"
              v-bind:key="index + '-' + item"
            >
              <td class="align-middle px-0 text-center" width="30">
                {{ index + 1 }}.
              </td>
              <td
                class="align-middle bg-success text-white font-weight-bold text-center px-0"
                width="40"
              >
                {{ item.number }}
              </td>
              <td class="align-middle">
                <b-input
                  type="number"
                  min="1"
                  class="text-center px-0"
                  v-model="item.price"
                  @change="item.price = parseInt(item.price)"
                ></b-input>
              </td>
              <td
                :class="
                  checkLimitNumberWithType(3, item.number)
                    ? 'align-middle text-center px-0 text-danger'
                    : 'align-middle text-center px-0'
                "
                width="50"
              >
                {{
                  checkLimitNumberWithType(3, item.number)
                    ? getLimitNumberPrice(3, item.number)
                    : rate.songTua.bon
                }}
              </td>
              <td class="align-middle">
                <b-input
                  :class="
                    checkLimitNumberWithType(3, item.number)
                      ? 'px-0 text-center text-danger'
                      : 'px-0 text-center'
                  "
                  readonly
                  :value="
                    (checkLimitNumberWithType(3, item.number)
                      ? getLimitNumberPrice(3, item.number) * parseInt(item.price)
                      : rate.songTua.bon * parseInt(item.price)
                    ).toFixed(2) + '฿'
                  "
                ></b-input>
              </td>
              <td class="align-middle text-center" width="50">
                <b-btn
                  variant="warning"
                  @click="deleteNumber('songTua', 'bon', item.number)"
                >
                  <i class="far fa-trash-alt"></i>
                </b-btn>
              </td>
            </tr>
          </tbody>
        </table>
        <table
          class="table table-striped table-hover table-sm"
          v-if="selectedSortedNumbers.samTua.front.length > 0"
        >
          <thead>
            <tr class="bg-default">
              <th>#</th>
              <th colspan="2">สามตัวหน้า</th>
              <th class="text-primary text-center px-0">อัตราคูณ</th>
              <th>เรทชนะ</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) in selectedSortedNumbers.samTua.front"
              v-bind:key="index + '-' + item"
            >
              <td class="align-middle px-0 text-center" width="30">
                {{ index + 1 }}.
              </td>
              <td
                class="align-middle bg-success text-white font-weight-bold text-center px-0"
                width="40"
              >
                {{ item.number }}
              </td>
              <td class="align-middle">
                <b-input
                  type="number"
                  min="1"
                  class="text-center px-0"
                  v-model="item.price"
                  @change="item.price = parseInt(item.price)"
                ></b-input>
              </td>
              <td
                :class="
                  checkLimitNumberWithType(9, item.number)
                    ? 'align-middle text-center px-0 text-danger'
                    : 'align-middle text-center px-0'
                "
                width="50"
              >
                {{
                  checkLimitNumberWithType(9, item.number)
                    ? getLimitNumberPrice(9, item.number)
                    : rate.samTua.front
                }}
              </td>
              <td class="align-middle">
                <b-input
                  :class="
                    checkLimitNumberWithType(9, item.number)
                      ? 'px-0 text-center text-danger'
                      : 'px-0 text-center'
                  "
                  readonly
                  :value="
                    (
                      (checkLimitNumberWithType(9, item.number)
                        ? getLimitNumberPrice(1, item.number)
                        : rate.samTua.front) * parseInt(item.price)
                    ).toFixed(2) + '฿'
                  "
                ></b-input>
              </td>
              <td class="align-middle text-center" width="50">
                <b-btn
                  variant="warning"
                  @click="deleteNumber('samTua', 'front', item.number)"
                >
                  <i class="far fa-trash-alt"></i>
                </b-btn>
              </td>
            </tr>
          </tbody>
        </table>
        <table
          class="table table-striped table-hover table-sm"
          v-if="selectedSortedNumbers.samTua.bon.length > 0"
        >
          <thead>
            <tr class="bg-default">
              <th>#</th>
              <th colspan="2">สามตัวบน</th>
              <th class="text-primary text-center px-0">อัตราคูณ</th>
              <th>เรทชนะ</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) in selectedSortedNumbers.samTua.bon"
              v-bind:key="index + '-' + item"
            >
              <td class="align-middle px-0 text-center" width="30">
                {{ index + 1 }}.
              </td>
              <td
                class="align-middle bg-success text-white font-weight-bold text-center px-0"
                width="40"
              >
                {{ item.number }}
              </td>
              <td class="align-middle">
                <b-input
                  type="number"
                  min="1"
                  class="text-center px-0"
                  v-model="item.price"
                  @change="item.price = parseInt(item.price)"
                ></b-input>
              </td>
              <td
                :class="
                  checkLimitNumberWithType(1, item.number)
                    ? 'align-middle text-center px-0 text-danger'
                    : 'align-middle text-center px-0'
                "
                width="50"
              >
                {{
                  checkLimitNumberWithType(1, item.number)
                    ? getLimitNumberPrice(1, item.number)
                    : rate.samTua.bon
                }}
              </td>
              <td class="align-middle">
                <b-input
                  :class="
                    checkLimitNumberWithType(1, item.number)
                      ? 'px-0 text-center text-danger'
                      : 'px-0 text-center'
                  "
                  readonly
                  :value="
                    (
                      (checkLimitNumberWithType(1, item.number)
                        ? getLimitNumberPrice(1, item.number)
                        : rate.samTua.bon) * parseInt(item.price)
                    ).toFixed(2) + '฿'
                  "
                ></b-input>
              </td>
              <td class="align-middle text-center" width="50">
                <b-btn
                  variant="warning"
                  @click="deleteNumber('samTua', 'bon', item.number)"
                >
                  <i class="far fa-trash-alt"></i>
                </b-btn>
              </td>
            </tr>
          </tbody>
        </table>
        <table
          class="table table-striped table-hover table-sm"
          v-if="selectedSortedNumbers.run.down.length > 0"
        >
          <thead>
            <tr class="bg-default">
              <th>#</th>
              <th colspan="2">วิ่งล่าง</th>
              <th class="text-primary text-center px-0">อัตราคูณ</th>
              <th>เรทชนะ</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) in selectedSortedNumbers.run.down"
              v-bind:key="index + '-' + item"
            >
              <td class="align-middle px-0 text-center" width="30">
                {{ index + 1 }}.
              </td>
              <td
                class="align-middle bg-success text-white font-weight-bold text-center px-0"
                width="40"
              >
                {{ item.number }}
              </td>
              <td class="align-middle">
                <b-input
                  type="number"
                  min="10"
                  class="text-center px-0"
                  v-model="item.price"
                  @change="
                    parseInt(item.price) < 10
                      ? (item.price = 10)
                      : parseInt(item.price)
                  "
                ></b-input>
              </td>
              <td
                :class="
                  checkLimitNumberWithType(7, item.number)
                    ? 'align-middle text-center px-0 text-danger'
                    : 'align-middle text-center px-0'
                "
                width="50"
              >
                {{
                  checkLimitNumberWithType(7, item.number)
                    ? getLimitNumberPrice(7, item.number)
                    : rate.run.down
                }}
              </td>
              <td class="align-middle">
                <b-input
                  :class="
                    checkLimitNumberWithType(7, item.number)
                      ? 'px-0 text-center text-center'
                      : 'px-0 text-center'
                  "
                  readonly
                  :value="
                    (
                      (checkLimitNumberWithType(7, item.number)
                        ? getLimitNumberPrice(7, item.number)
                        : rate.run.down) * parseInt(item.price)
                    ).toFixed(2) + '฿'
                  "
                ></b-input>
              </td>
              <td class="align-middle text-center" width="50">
                <b-btn
                  variant="warning"
                  @click="deleteNumber('run', 'down', item.number)"
                >
                  <i class="far fa-trash-alt"></i>
                </b-btn>
              </td>
            </tr>
          </tbody>
        </table>
        <table
          class="table table-striped table-hover table-sm"
          v-if="selectedSortedNumbers.songTua.down.length > 0"
        >
          <thead>
            <tr class="bg-default">
              <th>#</th>
              <th colspan="2">สองตัวล่าง</th>
              <th class="text-primary text-center px-0">อัตราคูณ</th>
              <th>เรทชนะ</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) in selectedSortedNumbers.songTua.down"
              v-bind:key="index + '-' + item"
            >
              <td class="align-middle px-0 text-center" width="30">
                {{ index + 1 }}.
              </td>
              <td
                class="align-middle bg-success text-white font-weight-bold text-center px-0"
                width="40"
              >
                {{ item.number }}
              </td>
              <td class="align-middle">
                <b-input
                  type="number"
                  min="1"
                  class="text-center px-0"
                  v-model="item.price"
                  @change="item.price = parseInt(item.price)"
                ></b-input>
              </td>
              <td
                :class="
                  checkLimitNumberWithType(6, item.number)
                    ? 'align-middle text-center px-0 text-danger'
                    : 'align-middle text-center px-0'
                "
                width="50"
              >
                {{
                  checkLimitNumberWithType(6, item.number)
                    ? getLimitNumberPrice(6, item.number)
                    : rate.songTua.down
                }}
              </td>
              <td class="align-middle">
                <b-input
                  :class="
                    checkLimitNumberWithType(6, item.number)
                      ? 'px-0 text-center text-danger'
                      : 'px-0 text-center'
                  "
                  readonly
                  :value="
                    (
                      (checkLimitNumberWithType(6, item.number)
                        ? getLimitNumberPrice(6, item.number)
                        : rate.songTua.down) * parseInt(item.price)
                    ).toFixed(2) + '฿'
                  "
                ></b-input>
              </td>
              <td class="align-middle text-center" width="50">
                <b-btn
                  variant="warning"
                  @click="deleteNumber('songTua', 'down', item.number)"
                >
                  <i class="far fa-trash-alt"></i>
                </b-btn>
              </td>
            </tr>
          </tbody>
        </table>
        <table
          class="table table-striped table-hover table-sm"
          v-if="selectedSortedNumbers.samTua.tode.length > 0"
        >
          <thead>
            <tr class="bg-default">
              <th>#</th>
              <th colspan="2">สามตัวโต๊ด</th>
              <th class="text-primary text-center px-0">อัตราคูณ</th>
              <th>เรทชนะ</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) in selectedSortedNumbers.samTua.tode"
              v-bind:key="index + '-' + item"
            >
              <td class="align-middle px-0 text-center" width="30">
                {{ index + 1 }}.
              </td>
              <td
                class="align-middle bg-success text-white font-weight-bold text-center px-0"
                width="40"
              >
                {{ item.number }}
              </td>
              <td class="align-middle">
                <b-input
                  type="number"
                  min="1"
                  class="text-center px-0"
                  v-model="item.price"
                  @change="item.price = parseInt(item.price)"
                ></b-input>
              </td>
              <td
                :class="
                  checkLimitNumberWithType(2, item.number)
                    ? 'align-middle text-center px-0 text-danger'
                    : 'align-middle text-center px-0'
                "
                width="50"
              >
                {{
                  checkLimitNumberWithType(2, item.number)
                    ? getLimitNumberPrice(2, item.number)
                    : rate.samTua.tode
                }}
              </td>
              <td class="align-middle">
                <b-input
                  :class="
                    checkLimitNumberWithType(2, item.number)
                      ? 'text-danger px-0 text-center'
                      : 'px-0 text-center'
                  "
                  readonly
                  :value="
                    (
                      (checkLimitNumberWithType(2, item.number)
                        ? getLimitNumberPrice(2, item.number)
                        : rate.samTua.tode) * parseInt(item.price)
                    ).toFixed(2) + '฿'
                  "
                ></b-input>
              </td>
              <!-- <td class="align-middle text-center" width="50"><b-btn variant="warning" @click="deletingNumber = {type: ['samTua', 'tode'], number: item.number};$bvModal.show('removeNumberConfirm')"><i class="far fa-trash-alt"></i></b-btn></td> -->
              <td class="align-middle text-center" width="50">
                <b-btn
                  variant="warning"
                  @click="deleteNumber('samTua', 'tode', item.number)"
                >
                  <i class="far fa-trash-alt"></i>
                </b-btn>
              </td>
            </tr>
          </tbody>
        </table>
        <table
          class="table table-striped table-hover table-sm"
          v-if="selectedSortedNumbers.samTua.down.length > 0"
        >
          <thead>
            <tr class="bg-default">
              <th>#</th>
              <th colspan="2">สามตัวล่าง</th>
              <th class="text-primary text-center px-0">อัตราคูณ</th>
              <th>เรทชนะ</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) in selectedSortedNumbers.samTua.down"
              v-bind:key="index + '-' + item"
            >
              <td class="align-middle px-0 text-center" width="30">
                {{ index + 1 }}.
              </td>
              <td
                class="align-middle bg-success text-white font-weight-bold text-center px-0"
                width="40"
              >
                {{ item.number }}
              </td>
              <td class="align-middle">
                <b-input
                  type="number"
                  min="1"
                  class="text-center px-0"
                  v-model="item.price"
                  @change="item.price = parseInt(item.price)"
                ></b-input>
              </td>
              <td
                :class="
                  checkLimitNumberWithType(8, item.number)
                    ? 'text-danger align-middle text-center px-0'
                    : 'align-middle text-center px-0'
                "
                width="50"
              >
                {{
                  checkLimitNumberWithType(8, item.number)
                    ? getLimitNumberPrice(8, item.number)
                    : rate.samTua.down
                }}
              </td>
              <td class="align-middle">
                <b-input
                  :class="
                    checkLimitNumberWithType(8, item.number)
                      ? 'text-danger px-0 text-center'
                      : 'px-0 text-center'
                  "
                  readonly
                  :value="
                    (
                      (checkLimitNumberWithType(8, item.number)
                        ? getLimitNumberPrice(8, item.number)
                        : rate.samTua.down) * parseInt(item.price)
                    ).toFixed(2) + '฿'
                  "
                ></b-input>
              </td>
              <!-- <td class="align-middle text-center" width="50"><b-btn variant="warning" @click="deletingNumber = {type: ['samTua', 'down'], number: item.number};$bvModal.show('removeNumberConfirm')"><i class="far fa-trash-alt"></i></b-btn></td> -->
              <td class="align-middle text-center" width="50">
                <b-btn
                  variant="warning"
                  @click="deleteNumber('samTua', 'down', item.number)"
                >
                  <i class="far fa-trash-alt"></i>
                </b-btn>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <b-row class="border-bottom p-2">
        <b-col class="px-2 py-1">
          <b-button block @click="checkDuplicatedNumber"><i class="fas fa-search"></i> ดูเลขซ้ำ</b-button>
        </b-col>
        <b-col class="px-2 py-1">
          <b-button block><i class="fas fa-eraser"></i> ตัดเลขซ้ำ</b-button>
        </b-col>
      </b-row>
      <b-row class="border-bottom p-2">
        <b-col cols="6" class="text-center px-2">
          <span class="text-success">
            ราคา
            <span class="font-weight-bold">"เท่ากัน"</span> ทั้งหมด
          </span>
          <b-input-group>
            <b-form-input
              v-model="allPrice"
              class="border-success"
              @change="changeAllPrice(allPrice)"
            ></b-form-input>
            <b-input-group-append>
              <b-button variant="outline-success">
                <i class="fas fa-plus"></i>
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-col>
        <b-col cols="6">
          <b-row class="pb-2">
            <b-col class="px-2" cols="3">
              <b-button
                variant="light"
                class="border-secondary px-0"
                block
                size="sm"
                @click="changeAllPrice(5)"
                >5 ฿</b-button
              >
            </b-col>
            <b-col class="px-2" cols="3">
              <b-button
                variant="light"
                class="border-secondary px-0"
                block
                size="sm"
                @click="changeAllPrice(10)"
                >10 ฿</b-button
              >
            </b-col>
            <b-col class="px-2" cols="3">
              <b-button
                variant="light"
                class="border-secondary px-0"
                block
                size="sm"
                @click="changeAllPrice(20)"
                >20 ฿</b-button
              >
            </b-col>
            <b-col class="px-2" cols="3">
              <b-button
                variant="light"
                class="border-secondary px-0"
                block
                size="sm"
                @click="changeAllPrice(50)"
                >50 ฿</b-button
              >
            </b-col>
          </b-row>
          <b-row>
            <b-col class="px-2" cols="12">
              <b-button
                variant="light"
                class="border-secondary px-0"
                block
                size="sm"
                @click="changeAllPrice(100)"
                >100 ฿</b-button
              >
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row class="border-bottom p-3">
        <b-col cols="6" class="bg-primary p-2 text-center">
          <div>
            <b-badge variant="light">ยอดเครดิตคงเหลือ</b-badge>
          </div>
          <div class="text-white">{{ getCashAmount.toFixed(2) }} ฿</div>
        </b-col>
        <b-col cols="6" class="bg-danger p-2 text-center">
          <div>
            <b-badge variant="light">รวมยอดแทง</b-badge>
          </div>
          <div class="text-white">{{ totalPrice.toFixed(2) }} ฿</div>
        </b-col>
      </b-row>
      <b-row class="px-3 pb-3">
        <b-col cols="6" class="p-2">
          <b-button
            variant="light"
            block
            @click="
              resetSelectedNumbers();
              $bvModal.hide('priceModal');
            "
          >
            <i class="fas fa-ban"></i> ยกเลิกทั้งหมด
          </b-button>
        </b-col>
        <b-col cols="6" class="p-2">
          <b-button
            variant="success"
            block
            :disabled="totalPrice == 0 ? true : false"
            @click="$bvModal.show('summaryModal')"
          >
            <i class="fas fa-check"></i> ส่งโพย
          </b-button>
        </b-col>
      </b-row>
      <!-- <b-button class="mt-3" block @click="$bvModal.hide('priceModal')">Close Me</b-button> -->
    </b-modal>
    <b-modal
      id="summaryModal"
      size="xl"
      class="pl-0"
      dialog-class="price-modal"
      content-class="min-vh-100"
      header-class="golden-header w-100 text-center px-2 py-1"
      header-bg-variant="warning"
      header-text-variant="black"
      centered
      scrollable
      hide-footer
    >
      <template #modal-title>
        <div class="w-100 text-center text-dark font-weight-bold">
          <small> <i class="fas fa-check-circle"></i> ยืนยันคำสั่งซื้อ </small>
        </div>
      </template>
      <b-card
        header-bg-variant="dark"
        header-class="rounded-0"
        footer-bg-variant="success"
        footer-class="text-white text-center p-2 rounded-0"
      >
        <template #header>
          <b-row>
            <b-col cols="12" sm="8">
              <div class="logo d-inline-flex align-items-center">
                <img
                  :alt="getAppName"
                  class="d-inline-block"
                  height="30"
                  src="../../assets/images/logo.png"
                />
                <p class="d-inline-block align-middle ml-2 mb-0 text" v-html="getAppTitle"></p>
              </div>
            </b-col>
            <b-col cols="12" sm="4" class="text-right">
              <h4 class="font-weight-bold text-white mb-0">ใบสั่งซื้อ</h4>
            </b-col>
          </b-row>
        </template>
        <b-row>
          <b-col cols="12" sm="7" md="8">
            <h5 class="font-weight-bold">
              {{
                lottoName == "PingPongVIP"
                  ? "หวยยี่กี"
                  : lottoInfo.lotto && lottoInfo.lotto.lottoDesc
                  ? lottoInfo.lotto.lottoDesc
                  : lottoInfo.lotto.lottoName
                  ? lottoInfo.lotto.lottoName
                  : lottoName
              }}
            </h5>
            <b-input-group>
              <b-input-group-prepend>
                <b-input-group-text class="rounded-0">
                  <i class="far fa-clock"></i>
                </b-input-group-text>
              </b-input-group-prepend>
              <b-input-group-append>
                <b-input-group-text
                  v-if="lottoName == 'PingPongVIP'"
                  class="bg-white font-weight-bold rounded-0"
                  >รอบที่ {{ lottoInfo.lotto.roundNumber }}</b-input-group-text
                >
                <b-input-group-text
                  v-else
                  class="bg-white font-weight-bold rounded-0"
                  >{{
                    lottoInfo.lotto !== undefined
                      ? formatDate(lottoInfo.lotto.lottoDate, "DD MMM YYYY")
                      : ""
                  }}</b-input-group-text
                >
              </b-input-group-append>
            </b-input-group>
          </b-col>
          <b-col cols="12" sm="5" md="4">
            <table class="table table-bordered table-sm mb-0">
              <tr>
                <td class="bg-secondary text-white">วันที่:</td>
                <td>{{ formatDate(new Date(), "DD/MM/YYYY") }}</td>
              </tr>
              <tr>
                <td class="bg-secondary text-white">เวลา:</td>
                <td>{{ formatDate(new Date(), "HH:mm") }}</td>
              </tr>
            </table>
          </b-col>
        </b-row>
        <template #footer
          >ยอดเดิมพันทั้งหมด: {{ totalPrice.toFixed(2) }} ฿</template
        >
      </b-card>
      <b-card
        header-bg-variant="light"
        header-class="font-weight-bold p-2"
        body-class="p-2"
        class="mt-3"
        v-if="selectedSortedNumbers.run.bon.length > 0"
      >
        <template #header>
          <b-row>
            <b-col cols="6" class="text-success">วิ่งบน</b-col>
            <b-col cols="6" class="text-right">ราคา</b-col>
          </b-row>
        </template>
        <b-row
          v-for="(item, index) in selectedSortedNumbers.run.bon"
          v-bind:key="'bon-' + index"
        >
          <b-col cols="3">{{ index + 1 }}.</b-col>
          <b-col cols="4">{{ item.number }}</b-col>
          <b-col cols="5" class="text-right">{{ item.price }}</b-col>
        </b-row>
      </b-card>
      <b-card
        header-bg-variant="light"
        header-class="font-weight-bold p-2"
        body-class="p-2"
        class="mt-3"
        v-if="selectedSortedNumbers.songTua.bon.length > 0"
      >
        <template #header>
          <b-row>
            <b-col cols="6" class="text-success">สองตัวบน</b-col>
            <b-col cols="6" class="text-right">ราคา</b-col>
          </b-row>
        </template>
        <b-row
          v-for="(item, index) in selectedSortedNumbers.songTua.bon"
          v-bind:key="'bon-' + index"
        >
          <b-col cols="3">{{ index + 1 }}.</b-col>
          <b-col cols="4">{{ item.number }}</b-col>
          <b-col cols="5" class="text-right">{{ item.price }}</b-col>
        </b-row>
      </b-card>
      <b-card
        header-bg-variant="light"
        header-class="font-weight-bold p-2"
        body-class="p-2"
        class="mt-3"
        v-if="selectedSortedNumbers.samTua.front.length > 0"
      >
        <template #header>
          <b-row>
            <b-col cols="6" class="text-success">สามตัวหน้า</b-col>
            <b-col cols="6" class="text-right">ราคา</b-col>
          </b-row>
        </template>
        <b-row
          v-for="(item, index) in selectedSortedNumbers.samTua.front"
          v-bind:key="'front-' + index"
        >
          <b-col cols="3">{{ index + 1 }}.</b-col>
          <b-col cols="4">{{ item.number }}</b-col>
          <b-col cols="5" class="text-right">{{ item.price }}</b-col>
        </b-row>
      </b-card>
      <b-card
        header-bg-variant="light"
        header-class="font-weight-bold p-2"
        body-class="p-2"
        class="mt-3"
        v-if="selectedSortedNumbers.samTua.bon.length > 0"
      >
        <template #header>
          <b-row>
            <b-col cols="6" class="text-success">สามตัวบน</b-col>
            <b-col cols="6" class="text-right">ราคา</b-col>
          </b-row>
        </template>
        <b-row
          v-for="(item, index) in selectedSortedNumbers.samTua.bon"
          v-bind:key="'bon-' + index"
        >
          <b-col cols="3">{{ index + 1 }}.</b-col>
          <b-col cols="4">{{ item.number }}</b-col>
          <b-col cols="5" class="text-right">{{ item.price }}</b-col>
        </b-row>
      </b-card>
      <b-card
        header-bg-variant="light"
        header-class="font-weight-bold p-2"
        body-class="p-2"
        class="mt-3"
        v-if="selectedSortedNumbers.run.down.length > 0"
      >
        <template #header>
          <b-row>
            <b-col cols="6" class="text-success">วิ่งล่าง</b-col>
            <b-col cols="6" class="text-right">ราคา</b-col>
          </b-row>
        </template>
        <b-row
          v-for="(item, index) in selectedSortedNumbers.run.down"
          v-bind:key="'down-' + index"
        >
          <b-col cols="3">{{ index + 1 }}.</b-col>
          <b-col cols="4">{{ item.number }}</b-col>
          <b-col cols="5" class="text-right">{{ item.price }}</b-col>
        </b-row>
      </b-card>
      <b-card
        header-bg-variant="light"
        header-class="font-weight-bold p-2"
        body-class="p-2"
        class="mt-3"
        v-if="selectedSortedNumbers.songTua.down.length > 0"
      >
        <template #header>
          <b-row>
            <b-col cols="6" class="text-success">สองตัวล่าง</b-col>
            <b-col cols="6" class="text-right">ราคา</b-col>
          </b-row>
        </template>
        <b-row
          v-for="(item, index) in selectedSortedNumbers.songTua.down"
          v-bind:key="'down-' + index"
        >
          <b-col cols="3">{{ index + 1 }}.</b-col>
          <b-col cols="4">{{ item.number }}</b-col>
          <b-col cols="5" class="text-right">{{ item.price }}</b-col>
        </b-row>
      </b-card>
      <b-card
        header-bg-variant="light"
        header-class="font-weight-bold p-2"
        body-class="p-2"
        class="mt-3"
        v-if="selectedSortedNumbers.samTua.down.length > 0"
      >
        <template #header>
          <b-row>
            <b-col cols="6" class="text-success">สามตัวล่าง</b-col>
            <b-col cols="6" class="text-right">ราคา</b-col>
          </b-row>
        </template>
        <b-row
          v-for="(item, index) in selectedSortedNumbers.samTua.down"
          v-bind:key="'down-' + index"
        >
          <b-col cols="3">{{ index + 1 }}.</b-col>
          <b-col cols="4">{{ item.number }}</b-col>
          <b-col cols="5" class="text-right">{{ item.price }}</b-col>
        </b-row>
      </b-card>
      <b-card
        header-bg-variant="light"
        header-class="font-weight-bold p-2"
        body-class="p-2"
        class="mt-3"
        v-if="selectedSortedNumbers.samTua.tode.length > 0"
      >
        <template #header>
          <b-row>
            <b-col cols="6" class="text-success">สามตัวโต๊ด</b-col>
            <b-col cols="6" class="text-right">ราคา</b-col>
          </b-row>
        </template>
        <b-row
          v-for="(item, index) in selectedSortedNumbers.samTua.tode"
          v-bind:key="'tode-' + index"
        >
          <b-col cols="3">{{ index + 1 }}.</b-col>
          <b-col cols="4">{{ item.number }}</b-col>
          <b-col cols="5" class="text-right">{{ item.price }}</b-col>
        </b-row>
      </b-card>
      <b-row class="pt-0 pb-3">
        <b-col cols="6" class="p-2">
          <b-button
            variant="light"
            block
            @click="$bvModal.hide('summaryModal')"
            class="h-100"
          >
            <i class="fas fa-chevron-left"></i> กลับไปแก้ไข
          </b-button>
        </b-col>
        <b-col cols="6" class="p-2">
          <b-button
            variant="success"
            block
            class="h-100"
            :disabled="totalPrice == 0 ? true : false"
            @click="addBet"
          >
            <i class="fas fa-check"></i> ยืนยันการส่งโพย
          </b-button>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal
      id="resultModal"
      size="xl"
      class="pl-0"
      dialog-class="price-modal"
      content-class="min-vh-100"
      header-class="golden-header w-100 text-center px-2 py-1"
      header-bg-variant="warning"
      header-text-variant="black"
      centered
      scrollable
      hide-footer
    >
      <template #modal-title>
        <div class="w-100 text-center text-dark font-weight-bold">
          <small> <i class="fas fa-check-double"></i> ส่งโพยสำเร็จ </small>
        </div>
      </template>
      <b-card
        header-bg-variant="dark"
        header-class="rounded-0"
        footer-bg-variant="success"
        footer-class="text-white text-center p-2 rounded-0"
      >
        <template #header>
          <b-row>
            <b-col cols="12" sm="8">
              <div class="logo d-inline-flex align-items-center">
                <img
                  :alt="getAppName"
                  class="d-inline-block"
                  height="30"
                  src="../../assets/images/logo.png"
                />
                <p class="d-inline-block align-middle ml-2 mb-0 text" v-html="getAppTitle"></p>
              </div>
            </b-col>
            <b-col cols="12" sm="4" class="text-right">
              <small class="text-secondary">โพยเลขที่</small>
              <h4 class="text-white mb-0">#{{ betResult.ticketNo }}</h4>
            </b-col>
          </b-row>
        </template>
        <b-row>
          <b-col cols="12" sm="7" md="8">
            <h5 class="font-weight-bold">
              {{
                lottoName == "PingPongVIP"
                  ? "หวยยี่กี"
                  : lottoInfo.lotto && lottoInfo.lotto.lottoDesc
                  ? lottoInfo.lotto.lottoDesc
                  : lottoInfo.lotto.lottoName
                  ? lottoInfo.lotto.lottoName
                  : lottoName
              }}
            </h5>
            <b-input-group>
              <b-input-group-prepend>
                <b-input-group-text class="rounded-0">
                  <i class="far fa-clock"></i>
                </b-input-group-text>
              </b-input-group-prepend>
              <b-input-group-append>
                <b-input-group-text
                  v-if="lottoName == 'PingPongVIP'"
                  class="bg-white font-weight-bold rounded-0"
                  >รอบที่ {{ lottoInfo.lotto.roundNumber }}</b-input-group-text
                >
                <b-input-group-text
                  class="bg-white font-weight-bold rounded-0"
                  v-else
                  >{{
                    lottoInfo.lotto !== undefined
                      ? formatDate(lottoInfo.lotto.lottoDate, "DD MMM YYYY")
                      : ""
                  }}</b-input-group-text
                >
              </b-input-group-append>
            </b-input-group>
            <div class="text-success mt-2">
              <i class="fas fa-clipboard-check"></i> ส่งโพยสำเร็จ
            </div>
          </b-col>
          <b-col cols="12" sm="5" md="4">
            <table class="table table-bordered table-sm mb-0">
              <tr>
                <td class="bg-secondary text-white">วันที่:</td>
                <td>{{ formatDate(new Date(), "DD/MM/YYYY") }}</td>
              </tr>
              <tr>
                <td class="bg-secondary text-white">เวลา:</td>
                <td>{{ formatDate(new Date(), "HH:mm") }}</td>
              </tr>
            </table>
          </b-col>
        </b-row>
        <template #footer
          >ยอดเดิมพันทั้งหมด: {{ totalPrice.toFixed(2) }} ฿</template
        >
      </b-card>
      <b-card
        header-bg-variant="light"
        header-class="font-weight-bold p-2"
        body-class="p-2"
        class="mt-3"
        v-if="selectedSortedNumbers.run.bon.length > 0"
      >
        <template #header>
          <b-row>
            <b-col cols="6" class="text-success">วิ่งบน</b-col>
            <b-col cols="6" class="text-right">ราคา</b-col>
          </b-row>
        </template>
        <b-row
          v-for="(item, index) in selectedSortedNumbers.run.bon"
          v-bind:key="'bon-' + index"
        >
          <b-col cols="3">{{ index + 1 }}.</b-col>
          <b-col cols="4">{{ item.number }}</b-col>
          <b-col cols="5" class="text-right">{{ item.price }}</b-col>
        </b-row>
      </b-card>
      <b-card
        header-bg-variant="light"
        header-class="font-weight-bold p-2"
        body-class="p-2"
        class="mt-3"
        v-if="selectedSortedNumbers.songTua.bon.length > 0"
      >
        <template #header>
          <b-row>
            <b-col cols="6" class="text-success">สองตัวบน</b-col>
            <b-col cols="6" class="text-right">ราคา</b-col>
          </b-row>
        </template>
        <b-row
          v-for="(item, index) in selectedSortedNumbers.songTua.bon"
          v-bind:key="'bon-' + index"
        >
          <b-col cols="3">{{ index + 1 }}.</b-col>
          <b-col cols="4">{{ item.number }}</b-col>
          <b-col cols="5" class="text-right">{{ item.price }}</b-col>
        </b-row>
      </b-card>
      <b-card
        header-bg-variant="light"
        header-class="font-weight-bold p-2"
        body-class="p-2"
        class="mt-3"
        v-if="selectedSortedNumbers.samTua.front.length > 0"
      >
        <template #header>
          <b-row>
            <b-col cols="6" class="text-success">สามตัวหน้า</b-col>
            <b-col cols="6" class="text-right">ราคา</b-col>
          </b-row>
        </template>
        <b-row
          v-for="(item, index) in selectedSortedNumbers.samTua.front"
          v-bind:key="'front-' + index"
        >
          <b-col cols="3">{{ index + 1 }}.</b-col>
          <b-col cols="4">{{ item.number }}</b-col>
          <b-col cols="5" class="text-right">{{ item.price }}</b-col>
        </b-row>
      </b-card>
      <b-card
        header-bg-variant="light"
        header-class="font-weight-bold p-2"
        body-class="p-2"
        class="mt-3"
        v-if="selectedSortedNumbers.samTua.bon.length > 0"
      >
        <template #header>
          <b-row>
            <b-col cols="6" class="text-success">สามตัวบน</b-col>
            <b-col cols="6" class="text-right">ราคา</b-col>
          </b-row>
        </template>
        <b-row
          v-for="(item, index) in selectedSortedNumbers.samTua.bon"
          v-bind:key="'bon-' + index"
        >
          <b-col cols="3">{{ index + 1 }}.</b-col>
          <b-col cols="4">{{ item.number }}</b-col>
          <b-col cols="5" class="text-right">{{ item.price }}</b-col>
        </b-row>
      </b-card>
      <b-card
        header-bg-variant="light"
        header-class="font-weight-bold p-2"
        body-class="p-2"
        class="mt-3"
        v-if="selectedSortedNumbers.run.down.length > 0"
      >
        <template #header>
          <b-row>
            <b-col cols="6" class="text-success">วิ่งล่าง</b-col>
            <b-col cols="6" class="text-right">ราคา</b-col>
          </b-row>
        </template>
        <b-row
          v-for="(item, index) in selectedSortedNumbers.run.down"
          v-bind:key="'down-' + index"
        >
          <b-col cols="3">{{ index + 1 }}.</b-col>
          <b-col cols="4">{{ item.number }}</b-col>
          <b-col cols="5" class="text-right">{{ item.price }}</b-col>
        </b-row>
      </b-card>
      <b-card
        header-bg-variant="light"
        header-class="font-weight-bold p-2"
        body-class="p-2"
        class="mt-3"
        v-if="selectedSortedNumbers.songTua.down.length > 0"
      >
        <template #header>
          <b-row>
            <b-col cols="6" class="text-success">สองตัวล่าง</b-col>
            <b-col cols="6" class="text-right">ราคา</b-col>
          </b-row>
        </template>
        <b-row
          v-for="(item, index) in selectedSortedNumbers.songTua.down"
          v-bind:key="'down-' + index"
        >
          <b-col cols="3">{{ index + 1 }}.</b-col>
          <b-col cols="4">{{ item.number }}</b-col>
          <b-col cols="5" class="text-right">{{ item.price }}</b-col>
        </b-row>
      </b-card>
      <b-card
        header-bg-variant="light"
        header-class="font-weight-bold p-2"
        body-class="p-2"
        class="mt-3"
        v-if="selectedSortedNumbers.samTua.down.length > 0"
      >
        <template #header>
          <b-row>
            <b-col cols="6" class="text-success">สามตัวล่าง</b-col>
            <b-col cols="6" class="text-right">ราคา</b-col>
          </b-row>
        </template>
        <b-row
          v-for="(item, index) in selectedSortedNumbers.samTua.down"
          v-bind:key="'down-' + index"
        >
          <b-col cols="3">{{ index + 1 }}.</b-col>
          <b-col cols="4">{{ item.number }}</b-col>
          <b-col cols="5" class="text-right">{{ item.price }}</b-col>
        </b-row>
      </b-card>
      <b-card
        header-bg-variant="light"
        header-class="font-weight-bold p-2"
        body-class="p-2"
        class="mt-3"
        v-if="selectedSortedNumbers.samTua.tode.length > 0"
      >
        <template #header>
          <b-row>
            <b-col cols="6" class="text-success">สามตัวโต๊ด</b-col>
            <b-col cols="6" class="text-right">ราคา</b-col>
          </b-row>
        </template>
        <b-row
          v-for="(item, index) in selectedSortedNumbers.samTua.tode"
          v-bind:key="'tode-' + index"
        >
          <b-col cols="3">{{ index + 1 }}.</b-col>
          <b-col cols="4">{{ item.number }}</b-col>
          <b-col cols="5" class="text-right">{{ item.price }}</b-col>
        </b-row>
      </b-card>
      <b-row class="px-3 pb-3">
        <b-col cols="4" class="p-2">
          <b-button variant="dark" block class="h-100">
            <i class="fas fa-save"></i> บันทึกโพย
          </b-button>
        </b-col>
        <b-col cols="4" class="p-2">
          <b-button variant="light" block to="/member/poy" class="h-100">
            <i class="fas fa-history"></i> ประวัติโพย
          </b-button>
        </b-col>
        <b-col cols="4" class="p-2">
          <b-button
            variant="primary"
            block
            class="h-100"
            :disabled="totalPrice == 0 ? true : false"
            @click="
              resetSelectedNumbers();
              $bvModal.hide('resultModal');
            "
          >
            <i class="fas fa-plus"></i> แทงต่อ
          </b-button>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal
      id="numberSetModal"
      size="xl"
      class="pl-0"
      dialog-class="price-modal"
      content-class="min-vh-100"
      header-class="golden-header w-100 text-center px-2 py-1"
      header-bg-variant="warning"
      header-text-variant="black"
      centered
      scrollable
      hide-footer
    >
      <template #modal-title>
        <div class="w-100 text-center text-dark font-weight-bold">
          <small> <i class="fas fa-list"></i> เลขชุด - ดึงโพย </small>
        </div>
      </template>
      <b-tabs content-class="mt-3" card justified>
        <b-tab title="เลขชุด" active>
          <b-input-group size="sm" class="mb-2">
            <b-input-group-prepend>
              <b-btn variant="primary" size="sm" to="/member/numbersets">
                <i class="fas fa-edit"></i> จัดการเลขชุด
              </b-btn>
              <b-btn variant="success" size="sm" to="/member/numbersets/add">
                <i class="fas fa-plus"></i> สร้างเลขชุด
              </b-btn>
            </b-input-group-prepend>
            <b-form-input placeholder="ค้นหา"></b-form-input>
            <b-input-group-append>
              <b-btn variant="outline-secondary" size="sm">
                <i class="fas fa-search"></i>
              </b-btn>
            </b-input-group-append>
          </b-input-group>
          <table class="table table-sm table-striped">
            <thead>
              <tr class="bg-secondary text-white">
                <th>เลขชุด</th>
                <th>เวลาที่แทง</th>
                <th colspan="2">เลข</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in numberSets" v-bind:key="item.numberSetID">
                <td>{{ item.numberSetName }}</td>
                <td>{{ formatDate(item.createdDate, "DD/MM/YYYY HH:mm") }}</td>
                <td>
                  <span
                    v-for="(num, index) in item.NumberSets"
                    v-bind:key="index + '-' + num.number + '-' + num.numberType"
                    >{{ index > 0 ? ", " : "" }}{{ num.number }}</span
                  >
                </td>
                <td class="text-right">
                  <b-btn
                    variant="outline-success"
                    size="sm"
                    @click="addFromNumberSet(item.NumberSets)"
                  >
                    <i class="fas fa-check"></i>
                  </b-btn>
                </td>
              </tr>
            </tbody>
          </table>
        </b-tab>
        <b-tab title="ดึงโพย">
          <table class="table table-sm table-striped">
            <thead>
              <tr class="bg-secondary text-white">
                <th>โพย</th>
                <th>เวลาที่สร้าง</th>
                <th colspan="2">เลข</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in tickets" v-bind:key="item.customerPlayID">
                <td>
                  {{
                    getLottoType.filter((i) =>
                      [item.lottoType].includes(i.lottoType)
                    )[0].lottoDesc
                  }}
                </td>
                <td>{{ formatDate(item.createdDate, "DD/MM/YYYY HH:mm") }}</td>
                <td>
                  <span
                    v-for="(num, index) in item.betSlot"
                    v-bind:key="num.betNumber + '-' + num.betNumberType"
                    >{{ index > 0 ? ", " : "" }}{{ num.betNumber }}</span
                  >
                </td>
                <td class="text-right">
                  <b-btn
                    variant="outline-success"
                    size="sm"
                    @click="addFromPoy(item.betSlot)"
                  >
                    <i class="fas fa-check"></i>
                  </b-btn>
                </td>
              </tr>
            </tbody>
          </table>
        </b-tab>
      </b-tabs>
    </b-modal>
    <b-modal id="removeNumberConfirm" header-class="font-weight-bold">
      <template #modal-header>ข้อความแจ้งเตือน</template>
      คุณแน่ใจว่าต้องการลบเลข {{ deletingNumber.number }} ใช่หรือไม่?
    </b-modal>
  </div>
</template>
<script>
import TopBarMember from "@/components/TopBarMember.vue";
import LottoMenu from "@/components/LottoMenu.vue";
import FooterIndex from "@/components/Footer.vue";
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import axios from "axios";
import VueCountdown from "@chenfengyuan/vue-countdown";

export default {
  name: "Tang",
  props: ["lottoName", "id"],
  components: {
    TopBarMember,
    LottoMenu,
    FooterIndex,
    VueCountdown,
  },
  data() {
    return {
      deletingNumber: {
        type: [],
        number: null,
      },
      addBetErrorMessage: null,
      betSlot: [],
      allPrice: 1,
      number: "",
      numPageActive: "numpage_1",
      tabActive: "panghuay",
      tabKeyboardSelected: "teng_bon_3",
      tabPangHuaySelected: "pills-3",
      ntDoorsSelected: [],
      swipeFrontSelected: [],
      swipeBackSelected: [],
      tabSamTuaSelected: {
        bon: false,
        tode: false,
        front: false,
        down: false,
        swap: false,
        overlay: "show",
        digit: 3,
      },
      tabSongTuaSelected: {
        bon: false,
        down: false,
        swap: false,
        ntDoors: false,
        swipeFront: false,
        swipeBack: false,
        overlay: "show",
        digit: 2,
      },
      tabRunSelected: {
        bon: false,
        down: false,
        overlay: "show",
        digit: 1,
      },
      tabSamtuaTabNumberSelected: "tab-000",
      modalActive: "x",
      selectedNumbers: {
        run: {
          bon: [],
          down: [],
        },
        songTua: {
          bon: [],
          down: [],
        },
        samTua: {
          bon: [],
          tode: [],
          front: [],
          down: [],
        },
      },
      duplicatedNumbers: {
        run: {
          bon: [],
          down: [],
        },
        songTua: {
          bon: [],
          down: [],
        },
        samTua: {
          bon: [],
          tode: [],
          front: [],
          down: [],
        },
      },
      selectedSortedNumbers: {
        run: {
          bon: [],
          down: [],
        },
        songTua: {
          bon: [],
          down: [],
        },
        samTua: {
          bon: [],
          tode: [],
          front: [],
          down: [],
        },
      },
      numberPanel: {
        three: {
          numberSets: [],
        },
        two: {
          numbers: [],
        },
        run: {
          numbers: [],
        },
      },
      rate: {
        run: {
          bon: 0,
          down: 0,
        },
        songTua: {
          bon: 0,
          down: 0,
        },
        samTua: {
          bon: 0,
          tode: 0,
          front: 0,
          down: 0,
        },
      },
      numberDigit: null,
      yingNumber: null,
      numberSets: [],
      dice: [],
      total: 0,
      lottoInfo: [],
      betResult: [],
      tickets: [],
      ticketDetails: [],
      sendingDice: false,
      countDownDice: 0,
      pending: false,
      permutation: [],
      result: [],
      payPrices:[],
      lottoCloseTime: null,
      lottoTimeLeftDice: null,
      lottoTimeLeft: null,
    };
  },
  mounted() {
    this.setNumber();
    this.getLottoInfo();
    this.getNumberSet();
    this.getMyTicket();
    console.log("lottoName", this.lottoName);
    console.log("lottoType", this.getLottoType);
    window.addEventListener('keyup', this.pressNumber);

    this.getLottoCloseDate();
  },
  methods: {
    pressNumber(e) {
      if((this.tabSamTuaSelected.bon ||
        this.tabSamTuaSelected.tode ||
        this.tabSamTuaSelected.front ||
        this.tabSamTuaSelected.down ||
        this.tabSongTuaSelected.bon ||
        this.tabSongTuaSelected.down ||
        this.tabRunSelected.bon ||
        this.tabRunSelected.down) && this.tabActive == "keyboard") {
          if (
            (e.keyCode >= 48 && e.keyCode <= 57) ||
            (e.keyCode >= 96 && e.keyCode <= 105)
          ) {
            this.numpadClick(e.key)
          }
          else if (e.keyCode === 8) {
            this.number = this.number.substring(0, this.number.length - 1);
          }
          else {
            e.preventDefault();
          }
      }
    },
    oddOrEven(x) {
      return ( x & 1 ) ? "odd" : "even";
    },
    selectSongTuaOption(type) {
      switch(type) {
        case "ntDoors":
          this.tabSongTuaSelected.ntDoors = !this.tabSongTuaSelected.ntDoors;
          this.tabSongTuaSelected.swipeFront = false;
          this.tabSongTuaSelected.swipeBack = false;
          break;
        case "swipeFront":
          this.tabSongTuaSelected.swipeFront = !this.tabSongTuaSelected.swipeFront;
          this.tabSongTuaSelected.ntDoors = false;
          this.tabSongTuaSelected.swipeBack = false;
          break;
        case "swipeBack":
          this.tabSongTuaSelected.swipeBack = !this.tabSongTuaSelected.swipeBack;
          this.tabSongTuaSelected.ntDoors = false;
          this.tabSongTuaSelected.swipeFront = false;
          break;
      }
    },
    doubleNumber() {
      const numbers = ["00", "11", "22", "33", "44", "55", "66", "77", "88", "99"];
      for(let i = 0; i <= numbers.length; i++) {
        this.selectNumber(numbers[i]);
      }
    },
    twoBottom() {
      for(let i = 0; i < 50; i++) {
        this.selectNumber(this.zeroPad(i, 2));
      }
    },
    twoTop() {
      for(let i = 50; i < 100; i++) {
        this.selectNumber(this.zeroPad(i, 2));
      }
    },
    twoOdd() {
      for(let i = 0; i < 100; i++) {
        if(this.oddOrEven(i) == 'odd') {
          this.selectNumber(this.zeroPad(i, 2));
        }
      }
    },
    twoEven() {
      for(let i = 0; i < 100; i++) {
        if(this.oddOrEven(i) == 'even') {
          this.selectNumber(this.zeroPad(i, 2));
        }
      }
    },
    getLottoResult() {
      this.pending = true;
      setTimeout(() => {
        this.getLottoInfo();
        this.pending = false;
      }, 10000);
    },
    checkLimitNumber(number) {
      let found = false;
      const objects = this.lottoInfo.lotto.lottoLimit;
      for (let i = 0; i < objects.length; i++) {
        if (objects[i].number == number) {
          found = true;
          break;
        }
      }
      return found;
    },
    checkLimitNumberWithType(numberType, number) {
      let found = false;
      const objects = this.lottoInfo.lotto.lottoLimit;
      for (let i = 0; i < objects.length; i++) {
        if (
          objects[i].number == number &&
          objects[i].numberType == numberType
        ) {
          found = true;
          break;
        }
      }
      return found;
    },
    getLimitNumberPrice(numberType, number) {
      let price = 0;
      const objects = this.lottoInfo.lotto.lottoLimit;
      for (let i = 0; i < objects.length; i++) {
        if (
          objects[i].number == number &&
          objects[i].numberType == numberType
        ) {
          price = objects[i].price;
          break;
        }
      }
      return price;
    },
    getTimeLeft(dt) {
      return moment(dt).diff(moment());
    },
    getTimeLeftDice(dt) {
      return moment(dt)
        .add(2, "minutes")
        .diff(moment());
    },
    getCountDownDice() {
      this.countDownDice = moment()
        .add(10, "seconds")
        .diff(moment());
    },
    changeAllPrice(price) {
      let i = 0;
      for (i = 0; i < this.selectedNumbers.samTua.bon.length; i++) {
        this.selectedNumbers.samTua.bon[i].price = parseInt(price);
      }
      for (i = 0; i < this.selectedNumbers.samTua.tode.length; i++) {
        this.selectedNumbers.samTua.tode[i].price = parseInt(price);
      }
      for (i = 0; i < this.selectedNumbers.samTua.front.length; i++) {
        this.selectedNumbers.samTua.front[i].price = parseInt(price);
      }
      for (i = 0; i < this.selectedNumbers.samTua.down.length; i++) {
        this.selectedNumbers.samTua.down[i].price = parseInt(price);
      }
      for (i = 0; i < this.selectedNumbers.songTua.bon.length; i++) {
        this.selectedNumbers.songTua.bon[i].price = parseInt(price);
      }
      for (i = 0; i < this.selectedNumbers.songTua.down.length; i++) {
        this.selectedNumbers.songTua.down[i].price = parseInt(price);
      }
      for (i = 0; i < this.selectedNumbers.run.bon.length; i++) {
        this.selectedNumbers.run.bon[i].price = parseInt(price);
      }
      for (i = 0; i < this.selectedNumbers.run.down.length; i++) {
        this.selectedNumbers.run.down[i].price = parseInt(price);
      }
    },
    deleteNumber(section, type, number) {
      switch (section) {
        case "samTua":
          switch (type) {
            case "tode":
              this.selectedNumbers.samTua.tode.splice(
                this.selectedNumbers.samTua.tode
                  .map((e) => e.number)
                  .indexOf(number),
                1
              );
              this.selectedSortedNumbers.samTua.tode = this.selectedNumbers.samTua.tode;
              break;
            case "bon":
              this.selectedNumbers.samTua.bon.splice(
                this.selectedNumbers.samTua.bon
                  .map((e) => e.number)
                  .indexOf(number),
                1
              );
              this.selectedSortedNumbers.samTua.bon = this.selectedNumbers.samTua.bon;
              break;
            case "front":
              this.selectedNumbers.samTua.front.splice(
                this.selectedNumbers.samTua.front
                  .map((e) => e.number)
                  .indexOf(number),
                1
              );
              this.selectedSortedNumbers.samTua.front = this.selectedNumbers.samTua.front;
              break;
            case "down":
              this.selectedNumbers.samTua.down.splice(
                this.selectedNumbers.samTua.down
                  .map((e) => e.number)
                  .indexOf(number),
                1
              );
              this.selectedSortedNumbers.samTua.down = this.selectedNumbers.samTua.down;
              break;
          }
          break;
        case "songTua":
          switch (type) {
            case "down":
              this.selectedNumbers.songTua.down.splice(
                this.selectedNumbers.songTua.down
                  .map((e) => e.number)
                  .indexOf(number),
                1
              );
              this.selectedSortedNumbers.songTua.down = this.selectedNumbers.songTua.down;
              break;
            case "bon":
              this.selectedNumbers.songTua.bon.splice(
                this.selectedNumbers.songTua.bon
                  .map((e) => e.number)
                  .indexOf(number),
                1
              );
              this.selectedSortedNumbers.songTua.bon = this.selectedNumbers.songTua.bon;
              break;
          }
          break;
        case "run":
          switch (type) {
            case "down":
              this.selectedNumbers.run.down.splice(
                this.selectedNumbers.run.down
                  .map((e) => e.number)
                  .indexOf(number),
                1
              );
              this.selectedSortedNumbers.run.down = this.selectedNumbers.run.down;
              break;
            case "bon":
              this.selectedNumbers.run.bon.splice(
                this.selectedNumbers.run.bon
                  .map((e) => e.number)
                  .indexOf(number),
                1
              );
              this.selectedSortedNumbers.run.bon = this.selectedNumbers.run.bon;
              break;
          }
          break;
      }
      console.log(section, type, number);
    },
    addFromPoy(betSlot) {
      console.log("bet slot", betSlot);
      for (let i = 0; i < betSlot.length; i++) {
        if (betSlot[i].betNumberType == 1) {
          this.selectedNumbers.samTua.bon.push({
            number: betSlot[i].betNumber,
            price: 1,
          });
          this.selectedSortedNumbers.samTua.bon = this.selectedNumbers.samTua.bon;
          this.selectedSortedNumbers.samTua.bon.sort();
        } else if (betSlot[i].betNumberType == 2) {
          this.selectedNumbers.samTua.tode.push({
            number: betSlot[i].betNumber,
            price: 1,
          });
          this.selectedSortedNumbers.samTua.tode = this.selectedNumbers.samTua.tode;
          this.selectedSortedNumbers.samTua.tode.sort();
        } else if (betSlot[i].betNumberType == 3) {
          this.selectedNumbers.songTua.bon.push({
            number: betSlot[i].betNumber,
            price: 1,
          });
          this.selectedSortedNumbers.songTua.bon = this.selectedNumbers.songTua.bon;
          this.selectedSortedNumbers.songTua.bon.sort();
        } else if (betSlot[i].betNumberType == 6) {
          this.selectedNumbers.songTua.down.push({
            number: betSlot[i].betNumber,
            price: 1,
          });
          this.selectedSortedNumbers.songTua.down = this.selectedNumbers.songTua.down;
          this.selectedSortedNumbers.songTua.down.sort();
        } else if (betSlot[i].betNumberType == 5) {
          this.selectedNumbers.run.bon.push({
            number: betSlot[i].betNumber,
            price: 10,
          });
          this.selectedSortedNumbers.run.bon = this.selectedNumbers.run.bon;
          this.selectedSortedNumbers.run.bon.sort();
        } else if (betSlot[i].betNumberType == 7) {
          this.selectedNumbers.run.down.push({
            number: betSlot[i].betNumber,
            price: 10,
          });
          this.selectedSortedNumbers.run.down = this.selectedNumbers.run.down;
          this.selectedSortedNumbers.run.down.sort();
        } else if (betSlot[i].betNumberType == 8) {
          if (this.lottoInfo.lotto.lottoType == 3) {
            this.selectedNumbers.samTua.down.push({
              number: betSlot[i].betNumber,
              price: 1,
            });
            this.selectedSortedNumbers.samTua.down = this.selectedNumbers.samTua.down;
            this.selectedSortedNumbers.samTua.down.sort();
          }
        } else if (betSlot[i].betNumberType == 9) {
          if (this.lottoInfo.lotto.lottoType == 3) {
            this.selectedNumbers.samTua.front.push({
              number: betSlot[i].betNumber,
              price: 1,
            });
            this.selectedSortedNumbers.samTua.front = this.selectedNumbers.samTua.front;
            this.selectedSortedNumbers.samTua.front.sort();
          }
        }
      }
      this.$bvModal.hide("numberSetModal");
    },
    addFromNumberSet(numberSet) {
      for (let i = 0; i < numberSet.length; i++) {
        if (numberSet[i].numberType == 1) {
          this.selectedNumbers.samTua.bon.push({
            number: numberSet[i].number,
            price: 1,
          });
          this.selectedSortedNumbers.samTua.bon = this.selectedNumbers.samTua.bon;
          this.selectedSortedNumbers.samTua.bon.sort();
        } else if (numberSet[i].numberType == 2) {
          this.selectedNumbers.samTua.tode.push({
            number: numberSet[i].number,
            price: 1,
          });
          this.selectedSortedNumbers.samTua.tode = this.selectedNumbers.samTua.tode;
          this.selectedSortedNumbers.samTua.tode.sort();
        } else if (numberSet[i].numberType == 3) {
          this.selectedNumbers.songTua.bon.push({
            number: numberSet[i].number,
            price: 1,
          });
          this.selectedSortedNumbers.songTua.bon = this.selectedNumbers.songTua.bon;
          this.selectedSortedNumbers.songTua.bon.sort();
        } else if (numberSet[i].numberType == 6) {
          this.selectedNumbers.songTua.down.push({
            number: numberSet[i].number,
            price: 1,
          });
          this.selectedSortedNumbers.songTua.down = this.selectedNumbers.songTua.down;
          this.selectedSortedNumbers.songTua.down.sort();
        } else if (numberSet[i].numberType == 5) {
          this.selectedNumbers.run.bon.push({
            number: numberSet[i].number,
            price: 10,
          });
          this.selectedSortedNumbers.run.bon = this.selectedNumbers.run.bon;
          this.selectedSortedNumbers.run.bon.sort();
        } else if (numberSet[i].numberType == 7) {
          this.selectedNumbers.run.down.push({
            number: numberSet[i].number,
            price: 10,
          });
          this.selectedSortedNumbers.run.down = this.selectedNumbers.run.down;
          this.selectedSortedNumbers.run.down.sort();
        } else if (numberSet[i].numberType == 8) {
          this.selectedNumbers.samTua.down.push({
            number: numberSet[i].number,
            price: 1,
          });
          this.selectedSortedNumbers.samTua.down = this.selectedNumbers.samTua.down;
          this.selectedSortedNumbers.samTua.down.sort();
        } else if (numberSet[i].numberType == 9) {
          this.selectedNumbers.samTua.front.push({
            number: numberSet[i].number,
            price: 1,
          });
          this.selectedSortedNumbers.samTua.front = this.selectedNumbers.samTua.front;
          this.selectedSortedNumbers.samTua.front.sort();
        }
      }
      this.$bvModal.hide("numberSetModal");
    },
    ...mapActions({
      setCashAmount: "setCashAmount",
    }),
    addBet() {
      this.addBetErrorMessage = null;
      axios
        .post(
          this.getApiUrl + "/pingpong/bet",
          {
            lottoType:
              this.lottoName == "PingPongVIP"
                ? 1
                : this.lottoInfo.lotto.lottoType,
            ReferID: this.id,
            betSlot: this.betSlot,
            username: this.getUsername,
          },
          {
            headers: {
              "Content-Type": "application/json",
              token: this.getAccessToken,
              username: this.getUsername,
            },
          }
        )
        .then((response) => {
          if(response.data.statusCode == 400) {
            this.addBetErrorMessage = response.data.message;
            this.$bvToast.toast(this.addBetErrorMessage, {
              title: "Error",
              variant: "danger",
              solid: true,
              appendToast: true
            });
            console.log(response.data.message);
          }
          else {
            // this.resetSelectedNumbers();
            this.resetSamTuaSelected();
            this.resetSongTuaSelected();
            this.resetRunSelected();
            this.$bvModal.hide("summaryModal");
            this.$bvModal.hide("priceModal");
            console.log("add bet", response, response.data.data.customerPlayID);
            axios
              .post(
                parseInt(this.lottoInfo.lotto.lottoType) == 1 ||
                  parseInt(this.lottoInfo.lotto.lottoType) == 2
                  ? this.getApiUrl + "/pingpong/getmyticketdetail"
                  : parseInt(this.lottoInfo.lotto.lottoType) == 26 ||
                    parseInt(this.lottoInfo.lotto.lottoType) == 27 ||
                    parseInt(this.lottoInfo.lotto.lottoType) == 28
                  ? this.getApiUrl + "/lottoset/getmyticketdetail"
                  : parseInt(this.lottoInfo.lotto.lottoType) == 29
                  ? this.getApiUrl + "/jackpot/getmyticketdetail"
                  : this.getApiUrl + "/lotto/getmyticketdetail",
                {
                  lottoType:
                    this.lottoName == "PingPongVIP"
                      ? 1
                      : this.lottoInfo.lotto.lottoType,
                  customerPlayID: response.data.data.customerPlayID,
                  username: this.getUsername,
                },
                {
                  headers: {
                    "Content-Type": "application/json",
                    token: this.getAccessToken,
                    username: this.getUsername,
                  },
                }
              )
              .then((response) => {
                this.$bvModal.show("resultModal");
                this.betResult = response.data.data;
                console.log("get ticket", response);
                axios.post(this.getApiUrl + "/customer/getcurrentfinance",
                  {
                    username: this.getUsername
                  },
                  {
                    headers: {
                      "Content-Type": "application/json",
                      "token": this.getAccessToken,
                      "username": this.getUsername
                    }
                  } )
                  .then(response => {
                    console.log(response);
                    if(response.data.statusCode == 200) {
                      this.setCashAmount(response.data.data.cashAmount);
                    }
                    else {
                      this.logout();
                    }
                  });
              });
          }
        });
    },
    getLottoInfo() {
      // console.log("GetLottoInfo", this.lottoName);
      axios
        .post(
          this.getApiUrl + "/pingpong/GetLottoInfo",
          {
            lottoType:
              this.lottoName != "PingPongVIP"
                ? this.getLottoType[
                    this.getLottoType
                      .map((e) => e.lottoName)
                      .indexOf(this.lottoName)
                  ].lottoType
                : 1,
            ReferID: this.id,
            username: this.getUsername,
          },
          {
            headers: {
              "Content-Type": "application/json",
              token: this.getAccessToken,
              username: this.getUsername,
            },
          }
        )
        .then((response) => {
          console.log("GetLottoInfo", response);
          this.lottoInfo = response.data.data;

          if (
            this.lottoInfo.lotto &&
            (this.getLottoType[
              this.getLottoType.map((e) => e.lottoName).indexOf(this.lottoName)
            ].lottoType == 1 ||
              this.getLottoType[
                this.getLottoType
                  .map((e) => e.lottoName)
                  .indexOf(this.lottoName)
              ].lottoType == 2)
          ) {
            this.getAllDice();
          }
          this.payPrices =  response.data.data.payPrices;
          this.MapPrices();          
        });
    },
    getLottoCloseDate() {
      axios
        .post(
          this.getApiUrl + "/pingpong/GetLottoInfo",
          {
            lottoType:
              this.lottoName != "PingPongVIP"
                ? this.getLottoType[
                    this.getLottoType
                      .map((e) => e.lottoName)
                      .indexOf(this.lottoName)
                  ].lottoType
                : 1,
            ReferID: this.id,
            username: this.getUsername,
          },
          {
            headers: {
              "Content-Type": "application/json",
              token: this.getAccessToken,
              username: this.getUsername,
            },
          }
        )
        .then((response) => {
          this.lottoCloseTime = response.data.data.lotto.lottoCloseDate;

          const currentTime = moment();
          this.lottoTimeLeft = moment(this.lottoCloseTime).diff(currentTime);
          this.lottoTimeLeftDice = moment(this.lottoCloseTime).add(2, "minutes").diff(currentTime);
        });
    },
    MapPrices(){
      if(this.payPrices.filter((i) => i.numberType == 1)[0] !== undefined) {
        this.rate.samTua.bon = this.payPrices.filter((i) => i.numberType ==1)[0].price;
      }
      if(this.payPrices.filter((i) => i.numberType == 2)[0] !== undefined) {
        this.rate.samTua.tode = this.payPrices.filter((i) => i.numberType ==2)[0].price;
      }

      if(this.payPrices.filter((i) => i.numberType == 9)[0] !== undefined) {
        this.rate.samTua.front = this.payPrices.filter((i) => i.numberType ==9)[0].price;
      }
      if(this.payPrices.filter((i) => i.numberType == 8)[0] !== undefined) {
        this.rate.samTua.down = this.payPrices.filter((i) => i.numberType ==8)[0].price;
      }

      if(this.payPrices.filter((i) => i.numberType == 3)[0] !== undefined) {
        this.rate.songTua.bon = this.payPrices.filter((i) => i.numberType ==3)[0].price;
      }
      if(this.payPrices.filter((i) => i.numberType == 6)[0] !== undefined) {
        this.rate.songTua.down = this.payPrices.filter((i) => i.numberType ==6)[0].price;
      }

      if(this.payPrices.filter((i) => i.numberType == 5)[0] !== undefined) {
        this.rate.run.bon = this.payPrices.filter((i) => i.numberType ==5)[0].price;
      }
      if(this.payPrices.filter((i) => i.numberType == 7)[0] !== undefined) {
        this.rate.run.down = this.payPrices.filter((i) => i.numberType ==7)[0].price;      
      }
    },
    checkNumber(arr, num) {
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].number == num) {
          return true;
        }
      }
    },
    numberFormatter(x) {
      return (
        x.split(".")[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") +
        (+x.split(".")[1] ? "." + x.split(".")[1] : "")
      );
    },
    formatDate(datetime, format) {
      return moment(String(datetime)).format(format);
    },
    formatDateDice(datetime, format) {
      return moment(String(datetime))
        .add(2, "minutes")
        .format(format);
    },
    submitDice() {
      this.sendingDice = true;
      axios
        .post(
          this.getApiUrl + "/pingpong/dice",
          {
            lottoType:
              this.lottoName == "PingPongVIP"
                ? 1
                : this.lottoInfo.lotto.lottoType,
            pingPongReferID: this.id,
            diceNumber: this.yingNumber,
            username: this.getUsername,
          },
          {
            headers: {
              "Content-Type": "application/json",
              token: this.getAccessToken,
              username: this.getUsername,
            },
          }
        )
        .then((response) => {
          console.log("getalldice", response);
          if (response.data.statusCode == 200) {
            this.yingNumber = null;
            this.getAllDice();
          } else {
            this.getLottoInfo();
            this.getAllDice();
          }
          this.getCountDownDice();
        });
    },
    getAllDice() {
      axios
        .post(
          this.getApiUrl + "/pingpong/getalldice",
          {
            lottoType:
              this.lottoName == "PingPongVIP"
                ? 1
                : this.lottoInfo.lotto.lottoType,
            pingPongReferID: this.id,
          },
          {
            headers: {
              "Content-Type": "application/json",
              token: this.getAccessToken,
              username: this.getUsername,
            },
          }
        )
        .then((response) => {
          console.log("getalldice", response);
          if (response.data.statusCode == 200) {
            this.dice = response.data.data;
            if (this.dice.diceList.length >= 16) {
              this.dice.diceResult = (
                parseInt(this.dice.totalDice) -
                parseInt(this.dice.diceList[15].number)
              ).toString();
            } else {
              this.dice.diceResult = null;
            }
            // this.$router.push("/member/numbersets");
          }
          if (this.lottoInfo.lotto.isDiceAvailable) {
            setTimeout(() => {
              this.getAllDice();
            }, 5000);
          }
          // else {
          // }
        });
    },
    getNumberSet() {
      axios
        .post(
          this.getApiUrl + "/pingpong/getAllNumberSet",
          {
            lottoType:
              this.lottoName != "PingPongVIP"
                ? this.getLottoType[
                    this.getLottoType
                      .map((e) => e.lottoName)
                      .indexOf(this.lottoName)
                  ].lottoType
                : 1,
            username: this.getUsername,
          },
          {
            headers: {
              "Content-Type": "application/json",
              token: this.getAccessToken,
              username: this.getUsername,
            },
          }
        )
        .then((response) => {
          this.numberSets = response.data.data;
          console.log("Number Set", this.numberSets);
        });
    },
    numpadClick(number) {
      if (this.number.length === null || this.number.length < 4) {
        this.number = this.number + number;
      }
      if (
        this.tabSamTuaSelected.bon ||
        this.tabSamTuaSelected.tode ||
        this.tabSamTuaSelected.front ||
        this.tabSamTuaSelected.down
      ) {
        this.numberDigit = this.tabSamTuaSelected.digit;
      } else if (this.tabSongTuaSelected.bon || this.tabSongTuaSelected.down) {
        if(this.tabSongTuaSelected.ntDoors || this.tabSongTuaSelected.swipeFront || this.tabSongTuaSelected.swipeBack) {
          this.numberDigit = 1;
        }
        else {
          this.numberDigit = this.tabSongTuaSelected.digit;
        }
      } else if (this.tabRunSelected.bon || this.tabRunSelected.down) {
        this.numberDigit = this.tabRunSelected.digit;
      } else {
        this.numberDigit = 0;
      }
      if (this.number.length == this.numberDigit) {
        setTimeout(() => {
          if (this.tabSongTuaSelected.bon || this.tabSongTuaSelected.down) {
            if(this.tabSongTuaSelected.ntDoors) {
              this.ntDoors(number);
            }
            else if(this.tabSongTuaSelected.swipeFront) {
              this.swipeFront(number);
            }
            else if(this.tabSongTuaSelected.swipeBack) {
              this.swipeBack(number);
            }
            else {
              this.selectNumber(this.number);
            }
          }
          else {
              this.selectNumber(this.number);
          }
          this.number = "";
        }, 125);
      }
    },
    addNumber() {
      this.numbers.push({ number: this.number, amount: 1 });
      this.number = "";
      console.log(this.numbers);
    },
    isNumber(val) {
      console.log(val);
      if (isNaN(Number(val.key))) {
        return val.preventDefault();
      }
    },
    addYingNumber(num) {
      if (this.yingNumber === null) {
        this.yingNumber = num;
      } else if (this.yingNumber.length < 5) {
        this.yingNumber = this.yingNumber + num;
      }
    },
    randomYing() {
      this.yingNumber = Math.random()
        .toString()
        .substr(2, 5);
    },
    goNext(elem) {
      if (elem.value.length == 1) {
        const currentIndex = Array.from(elem.form.elements).indexOf(elem);
        elem.form.elements
          .item(
            currentIndex < elem.form.elements.length - 1 ? currentIndex + 1 : 0
          )
          .focus();
      } else if (elem.value.length == 0) {
        const currentIndex = Array.from(elem.form.elements).indexOf(elem);
        elem.form.elements
          .item(
            currentIndex < elem.form.elements.length - 1 ? currentIndex - 1 : 0
          )
          .focus();
      }
    },
    resetSelectedNumbers() {
      // var c = window.confirm('คุณแน่ใจนะว่าต้องการลบ เลขทั้งหมด?');
      // if(c) {
      this.selectedNumbers.run.bon = [];
      this.selectedNumbers.run.down = [];
      this.selectedNumbers.songTua.bon = [];
      this.selectedNumbers.songTua.down = [];
      this.selectedNumbers.samTua.bon = [];
      this.selectedNumbers.samTua.tode = [];
      this.selectedNumbers.samTua.front = [];
      this.selectedNumbers.samTua.down = [];
      this.selectedSortedNumbers = this.selectedNumbers;
      // }
    },
    zeroPad(num, places) {
      const zero = places - num.toString().length + 1;
      return Array(+(zero > 0 && zero)).join("0") + num;
    },
    resetSamTuaSelected() {
      this.tabSamTuaSelected.bon = false;
      this.tabSamTuaSelected.tode = false;
      this.tabSamTuaSelected.front = false;
      this.tabSamTuaSelected.down = false;
      this.tabSamTuaSelected.swap = false;
      this.tabSamTuaSelected.overlay = "show";
    },
    resetSongTuaSelected() {
      this.tabSongTuaSelected.bon = false;
      this.tabSongTuaSelected.down = false;
      this.tabSongTuaSelected.swap = false;
      this.tabSongTuaSelected.ntDoors = false;
      this.tabSongTuaSelected.swipeBack = false;
      this.tabSongTuaSelected.swipeFront = false;
      this.tabSongTuaSelected.overlay = "show";
    },
    resetRunSelected() {
      this.tabRunSelected.bon = false;
      this.tabRunSelected.down = false;
      this.tabRunSelected.overlay = "show";
    },
    swipeFront(num) {
      if (this.swipeFrontSelected.includes(num)) {
        this.swipeFrontSelected.splice(this.swipeFrontSelected.indexOf(num), 1);
        for (let i = 0; i < 10; i++) {
          if (this.tabSongTuaSelected.bon) {
            if (
              this.checkNumber(
                this.selectedNumbers.songTua.bon,
                (num + "" + i).toString()
              )
            ) {
              this.selectedNumbers.songTua.bon.splice(
                this.selectedNumbers.songTua.bon
                  .map((e) => e.number)
                  .indexOf((num + "" + i).toString()),
                1
              );
              this.selectedSortedNumbers.songTua.bon = this.selectedNumbers.songTua.bon;
            }
          }
          if (this.tabSongTuaSelected.down) {
            if (
              this.checkNumber(
                this.selectedNumbers.songTua.down,
                (num + "" + i).toString()
              )
            ) {
              this.selectedNumbers.songTua.down.splice(
                this.selectedNumbers.songTua.down
                  .map((e) => e.number)
                  .indexOf((num + "" + i).toString()),
                1
              );
              this.selectedSortedNumbers.songTua.down = this.selectedNumbers.songTua.down;
            }
          }
        }
      } else {
        this.swipeFrontSelected.push(num);
        for (let i = 0; i < 10; i++) {
          if (this.tabSongTuaSelected.bon) {
            if (
              !this.checkNumber(
                this.selectedNumbers.songTua.bon,
                (num + "" + i).toString()
              )
            ) {
              this.selectedNumbers.songTua.bon.push({
                number: (num + "" + i).toString(),
                price: 1,
              });
              this.selectedSortedNumbers.songTua.bon = this.selectedNumbers.songTua.bon;
              this.selectedSortedNumbers.songTua.bon.sort();
            }
          }
          if (this.tabSongTuaSelected.down) {
            if (
              !this.checkNumber(
                this.selectedNumbers.songTua.down,
                (num + "" + i).toString()
              )
            ) {
              this.selectedNumbers.songTua.down.push({
                number: (num + "" + i).toString(),
                price: 1,
              });
              this.selectedSortedNumbers.songTua.down = this.selectedNumbers.songTua.down;
              this.selectedSortedNumbers.songTua.down.sort();
            }
          }
        }
      }
    },
    swipeBack(num) {
      if (this.swipeBackSelected.includes(num)) {
        this.swipeBackSelected.splice(this.swipeBackSelected.indexOf(num), 1);
        for (let i = 0; i < 10; i++) {
          if (this.tabSongTuaSelected.bon) {
            if (
              this.checkNumber(
                this.selectedNumbers.songTua.bon,
                (i + "" + num).toString()
              )
            ) {
              this.selectedNumbers.songTua.bon.splice(
                this.selectedNumbers.songTua.bon
                  .map((e) => e.number)
                  .indexOf((i + "" + num).toString()),
                1
              );
              this.selectedSortedNumbers.songTua.bon = this.selectedNumbers.songTua.bon;
            }
          }
          if (this.tabSongTuaSelected.down) {
            if (
              this.checkNumber(
                this.selectedNumbers.songTua.down,
                (i + "" + num).toString()
              )
            ) {
              this.selectedNumbers.songTua.down.splice(
                this.selectedNumbers.songTua.down
                  .map((e) => e.number)
                  .indexOf((i + "" + num).toString()),
                1
              );
              this.selectedSortedNumbers.songTua.down = this.selectedNumbers.songTua.down;
            }
          }
        }
      } else {
        this.swipeBackSelected.push(num);
        for (let i = 0; i < 10; i++) {
          if (this.tabSongTuaSelected.bon) {
            if (
              !this.checkNumber(
                this.selectedNumbers.songTua.bon,
                (i + "" + num).toString()
              )
            ) {
              this.selectedNumbers.songTua.bon.push({
                number: (i + "" + num).toString(),
                price: 1,
              });
              this.selectedSortedNumbers.songTua.bon = this.selectedNumbers.songTua.bon;
              this.selectedSortedNumbers.songTua.bon.sort();
            }
          }
          if (this.tabSongTuaSelected.down) {
            if (
              !this.checkNumber(
                this.selectedNumbers.songTua.down,
                (i + "" + num).toString()
              )
            ) {
              this.selectedNumbers.songTua.down.push({
                number: (i + "" + num).toString(),
                price: 1,
              });
              this.selectedSortedNumbers.songTua.down = this.selectedNumbers.songTua.down;
              this.selectedSortedNumbers.songTua.down.sort();
            }
          }
        }
      }
    },
    ntDoors(num) {
      if (this.ntDoorsSelected.includes(num)) {
        this.ntDoorsSelected.splice(this.ntDoorsSelected.indexOf(num), 1);
        for (let i = 0; i < 10; i++) {
          if (i == num) {
            for (let i2 = 0; i2 < 10; i2++) {
              if (this.tabSongTuaSelected.bon) {
                if (
                  this.checkNumber(
                    this.selectedNumbers.songTua.bon,
                    (num + "" + i2).toString()
                  )
                ) {
                  this.selectedNumbers.songTua.bon.splice(
                    this.selectedNumbers.songTua.bon
                      .map((e) => e.number)
                      .indexOf((num + "" + i2).toString()),
                    1
                  );
                  this.selectedSortedNumbers.songTua.bon = this.selectedNumbers.songTua.bon;
                }
              }
              if (this.tabSongTuaSelected.down) {
                if (
                  this.checkNumber(
                    this.selectedNumbers.songTua.down,
                    (num + "" + i2).toString()
                  )
                ) {
                  this.selectedNumbers.songTua.down.splice(
                    this.selectedNumbers.songTua.down
                      .map((e) => e.number)
                      .indexOf((num + "" + i2).toString()),
                    1
                  );
                  this.selectedSortedNumbers.songTua.down = this.selectedNumbers.songTua.down;
                }
              }
            }
          } else {
            if (this.tabSongTuaSelected.bon) {
              if (
                this.checkNumber(
                  this.selectedNumbers.songTua.bon,
                  (i + "" + num).toString()
                )
              ) {
                this.selectedNumbers.songTua.bon.splice(
                  this.selectedNumbers.songTua.bon
                    .map((e) => e.number)
                    .indexOf((i + "" + num).toString()),
                  1
                );
                this.selectedSortedNumbers.songTua.bon = this.selectedNumbers.songTua.bon;
              }
            }
            if (this.tabSongTuaSelected.down) {
              if (
                this.checkNumber(
                  this.selectedNumbers.songTua.down,
                  (i + "" + num).toString()
                )
              ) {
                this.selectedNumbers.songTua.down.splice(
                  this.selectedNumbers.songTua.down
                    .map((e) => e.number)
                    .indexOf((i + "" + num).toString()),
                  1
                );
                this.selectedSortedNumbers.songTua.down = this.selectedNumbers.songTua.down;
              }
            }
          }
        }
      } else {
        this.ntDoorsSelected.push(num);
        for (let i = 0; i < 10; i++) {
          if (i == num) {
            for (let i2 = 0; i2 < 10; i2++) {
              // console.log(num + '' + i2);
              if (this.tabSongTuaSelected.bon) {
                console.log((num + "" + i2).toString());
                if (
                  !this.checkNumber(
                    this.selectedNumbers.songTua.bon,
                    (num + "" + i2).toString()
                  )
                ) {
                  this.selectedNumbers.songTua.bon.push({
                    number: (num + "" + i2).toString(),
                    price: 1,
                  });
                  this.selectedSortedNumbers.songTua.bon = this.selectedNumbers.songTua.bon;
                  this.selectedSortedNumbers.songTua.bon.sort();
                }
              }
              if (this.tabSongTuaSelected.down) {
                if (
                  !this.checkNumber(
                    this.selectedNumbers.songTua.down,
                    (num + "" + i2).toString()
                  )
                ) {
                  this.selectedNumbers.songTua.down.push({
                    number: (num + "" + i2).toString(),
                    price: 1,
                  });
                  this.selectedSortedNumbers.songTua.down = this.selectedNumbers.songTua.down;
                  this.selectedSortedNumbers.songTua.down.sort();
                }
              }
            }
          } else {
            console.log(i + "" + num);
            if (this.tabSongTuaSelected.bon) {
              console.log(i + "" + num);
              if (
                !this.checkNumber(
                  this.selectedNumbers.songTua.bon,
                  (i + "" + num).toString()
                )
              ) {
                this.selectedNumbers.songTua.bon.push({
                  number: (i + "" + num).toString(),
                  price: 1,
                });
                this.selectedSortedNumbers.songTua.bon = this.selectedNumbers.songTua.bon;
                this.selectedSortedNumbers.songTua.bon.sort();
              }
            }
            if (this.tabSongTuaSelected.down) {
              if (
                !this.checkNumber(
                  this.selectedNumbers.songTua.down,
                  (i + "" + num).toString()
                )
              ) {
                this.selectedNumbers.songTua.down.push({
                  number: (i + "" + num).toString(),
                  price: 1,
                });
                this.selectedSortedNumbers.songTua.down = this.selectedNumbers.songTua.down;
                this.selectedSortedNumbers.songTua.down.sort();
              }
            }
          }
        }
      }
    },
    checkDuplicatedNumber() {
      let current = null;
      for(let i = 0; i < this.selectedSortedNumbers.run.bon.length; i++) {
        current = this.selectedSortedNumbers.run.bon[i];
        if(this.selectedSortedNumbers.run.bon.filter(str => str === current).length > 0) {
          console.log('dup-bon', current, this.selectedSortedNumbers.run.bon.filter(str => str === current).length);
        }
      }
    },
    permute() {
      const length = this.permutation.length;
      this.result = [this.permutation.slice()];
      const c = new Array(length).fill(0);
      let i = 1;
      let k = 0;
      let p = 0;

      while (i < length) {
        if (c[i] < i) {
          k = i % 2 && c[i];
          p = this.permutation[i];
          this.permutation[i] = this.permutation[k];
          this.permutation[k] = p;
          ++c[i];
          i = 1;
          this.result.push(this.permutation.slice());
        } else {
          c[i] = 0;
          ++i;
        }
      }
    },
    removeDuplicates(data){
      return data.reduce((acc,curr)=> acc.includes(curr)?acc:[...acc,curr], []);
    },
    selectNumber(num) {
      /* กลับ */
      this.permutation = num.split("");
      console.log("permutation", this.permutation);
      this.permute();
      console.log("result", this.result);
      const numOutput = [];
      let index = 0;
      for (index = 0; index < this.result.length; index++) {
        numOutput.push(this.result[index].join(''));
      }
      console.log("numOutputD", this.removeDuplicates(numOutput));
      /* กลับ */

      if (num.length == 3) {
        if (
          this.checkNumber(this.selectedNumbers.samTua.bon, num) ||
          this.checkNumber(this.selectedNumbers.samTua.tode, num) ||
          this.checkNumber(this.selectedNumbers.samTua.front, num) ||
          this.checkNumber(this.selectedNumbers.samTua.down, num)
        ) {
          if (this.checkNumber(this.selectedNumbers.samTua.bon, num)) {
            // this.selectedNumbers.samTua.bon.splice(
            //   this.selectedNumbers.samTua.bon.map((e) => e.number).indexOf(num),
            //   1
            // );
          }
          if (this.checkNumber(this.selectedNumbers.samTua.tode, num)) {
            // this.selectedNumbers.samTua.tode.splice(
            //   this.selectedNumbers.samTua.tode
            //     .map((e) => e.number)
            //     .indexOf(num),
            //   1
            // );
            this.selectedSortedNumbers.samTua.tode = this.selectedNumbers.samTua.tode;
          }
          if (this.checkNumber(this.selectedNumbers.samTua.front, num)) {
            // this.selectedNumbers.samTua.front.splice(
            //   this.selectedNumbers.samTua.front
            //     .map((e) => e.number)
            //     .indexOf(num),
            //   1
            // );
            this.selectedSortedNumbers.samTua.front = this.selectedNumbers.samTua.front;
          }
          if (this.checkNumber(this.selectedNumbers.samTua.down, num)) {
            // this.selectedNumbers.samTua.down.splice(
            //   this.selectedNumbers.samTua.down
            //     .map((e) => e.number)
            //     .indexOf(num),
            //   1
            // );
            this.selectedSortedNumbers.samTua.down = this.selectedNumbers.samTua.down;
          }
        } else {
          if (this.tabSamTuaSelected.bon) {
            this.selectedNumbers.samTua.bon.push({ number: num, price: 1 });
            if(this.tabSamTuaSelected.swap) {
              for(let i = 0; i < this.result.length; i++) {
                if(!this.checkNumber(this.selectedNumbers.samTua.bon, this.result[i].join(''))) {
                  this.selectedNumbers.samTua.bon.push({ number: this.result[i].join(''), price: 1 });
                }
              }
            }
            this.selectedSortedNumbers.samTua.bon = this.selectedNumbers.samTua.bon;
            this.selectedSortedNumbers.samTua.bon.sort();
          }
          if (this.tabSamTuaSelected.tode) {
            this.selectedNumbers.samTua.tode.push({ number: num, price: 1 });
            if(this.tabSamTuaSelected.swap) {
              for(let i = 0; i < this.result.length; i++) {
                if(!this.checkNumber(this.selectedNumbers.samTua.tode, this.result[i].join(''))) {
                  this.selectedNumbers.samTua.tode.push({ number: this.result[i].join(''), price: 1 });
                }
              }
            }
            this.selectedSortedNumbers.samTua.tode = this.selectedNumbers.samTua.tode;
            this.selectedSortedNumbers.samTua.tode.sort();
          }
          if (this.tabSamTuaSelected.front) {
            this.selectedNumbers.samTua.front.push({ number: num, price: 1 });
            if(this.tabSamTuaSelected.swap) {
              for(let i = 0; i < this.result.length; i++) {
                if(!this.checkNumber(this.selectedNumbers.samTua.front, this.result[i].join(''))) {
                  this.selectedNumbers.samTua.front.push({ number: this.result[i].join(''), price: 1 });
                }
              }
            }
            this.selectedSortedNumbers.samTua.front = this.selectedNumbers.samTua.front;
            this.selectedSortedNumbers.samTua.front.sort();
          }
          if (this.tabSamTuaSelected.down) {
            this.selectedNumbers.samTua.down.push({ number: num, price: 1 });
            if(this.tabSamTuaSelected.swap) {
              for(let i = 0; i < this.result.length; i++) {
                if(!this.checkNumber(this.selectedNumbers.samTua.down, this.result[i].join(''))) {
                  this.selectedNumbers.samTua.down.push({ number: this.result[i].join(''), price: 1 });
                }
              }
            }
            this.selectedSortedNumbers.samTua.down = this.selectedNumbers.samTua.down;
            this.selectedSortedNumbers.samTua.down.sort();
          }
        }
      }
      if (num.length == 2) {
        if (
          this.checkNumber(this.selectedNumbers.songTua.bon, num) ||
          this.checkNumber(this.selectedNumbers.songTua.down, num)
        ) {
          if (this.checkNumber(this.selectedNumbers.songTua.bon, num)) {
            // this.selectedNumbers.songTua.bon.splice(
            //   this.selectedNumbers.songTua.bon
            //     .map((e) => e.number)
            //     .indexOf(num),
            //   1
            // );
            this.selectedSortedNumbers.songTua.bon = this.selectedNumbers.songTua.bon;
          }
          if (this.checkNumber(this.selectedNumbers.songTua.down, num)) {
            // this.selectedNumbers.songTua.down.splice(
            //   this.selectedNumbers.songTua.down
            //     .map((e) => e.number)
            //     .indexOf(num),
            //   1
            // );
            this.selectedSortedNumbers.songTua.down = this.selectedNumbers.songTua.down;
          }
        } else {
          if (this.tabSongTuaSelected.bon) {
            this.selectedNumbers.songTua.bon.push({ number: num, price: 1 });
            if(this.tabSongTuaSelected.swap) {
              for(let i = 0; i < this.result.length; i++) {
                if(!this.checkNumber(this.selectedNumbers.songTua.bon, this.result[i].join(''))) {
                  this.selectedNumbers.songTua.bon.push({ number: this.result[i].join(''), price: 1 });
                }
              }
            }
            this.selectedSortedNumbers.songTua.bon = this.selectedNumbers.songTua.bon;
            this.selectedSortedNumbers.songTua.bon.sort();
          }
          if (this.tabSongTuaSelected.down) {
            this.selectedNumbers.songTua.down.push({ number: num, price: 1 });
            if(this.tabSongTuaSelected.swap) {
              for(let i = 0; i < this.result.length; i++) {
                if(!this.checkNumber(this.selectedNumbers.songTua.down, this.result[i].join(''))) {
                  this.selectedNumbers.songTua.down.push({ number: this.result[i].join(''), price: 1 });
                }
              }
            }
            this.selectedSortedNumbers.songTua.down = this.selectedNumbers.songTua.down;
            this.selectedSortedNumbers.songTua.down.sort();
          }
        }
      }
      if (num.length == 1) {
        if (
          this.checkNumber(this.selectedNumbers.run.bon, num) ||
          this.checkNumber(this.selectedNumbers.run.down, num)
        ) {
          if (this.checkNumber(this.selectedNumbers.run.bon, num)) {
            // this.selectedNumbers.run.bon.splice(
            //   this.selectedNumbers.run.bon.map((e) => e.number).indexOf(num),
            //   1
            // );
            this.selectedSortedNumbers.run.bon = this.selectedNumbers.run.bon;
          }
          if (this.checkNumber(this.selectedNumbers.run.down, num)) {
            // this.selectedNumbers.run.down.splice(
            //   this.selectedNumbers.run.down.map((e) => e.number).indexOf(num),
            //   1
            // );
            this.selectedSortedNumbers.run.down = this.selectedNumbers.run.down;
          }
        } else {
          if (this.tabRunSelected.bon) {
            this.selectedNumbers.run.bon.push({ number: num, price: 10 });
            this.selectedSortedNumbers.run.bon = this.selectedNumbers.run.bon;
            this.selectedSortedNumbers.run.bon.sort();
          }
          if (this.tabRunSelected.down) {
            this.selectedNumbers.run.down.push({ number: num, price: 10 });
            this.selectedSortedNumbers.run.down = this.selectedNumbers.run.down;
            this.selectedSortedNumbers.run.down.sort();
          }
        }
      }
    },
    setSamTuaSelected(type) {
      this.resetRunSelected();
      this.resetSongTuaSelected();
      if (type == "tode") {
        this.tabSamTuaSelected.tode = !this.tabSamTuaSelected.tode;
        this.tabSamTuaSelected.swap = false;
      }
      if (type == "bon") {
        this.tabSamTuaSelected.bon = !this.tabSamTuaSelected.bon;
      }
      if (type == "front") {
        this.tabSamTuaSelected.front = !this.tabSamTuaSelected.front;
      }
      if (type == "down") {
        this.tabSamTuaSelected.down = !this.tabSamTuaSelected.down;
      }
      if (type == "swap") {
        this.tabSamTuaSelected.swap = !this.tabSamTuaSelected.swap;
        this.tabSamTuaSelected.tode = false;
      }

      if (
        this.tabSamTuaSelected.bon ||
        this.tabSamTuaSelected.tode ||
        this.tabSamTuaSelected.front ||
        this.tabSamTuaSelected.down
      ) {
        this.tabSamTuaSelected.overlay = null;
      } else {
        this.tabSamTuaSelected.overlay = "show";
      }
    },
    setSongTuaSelected(type) {
      this.resetSamTuaSelected();
      this.resetRunSelected();
      if (type == "bon") {
        this.tabSongTuaSelected.bon = !this.tabSongTuaSelected.bon;
      }
      if (type == "down") {
        this.tabSongTuaSelected.down = !this.tabSongTuaSelected.down;
      }
      if (type == "swap") {
        this.tabSongTuaSelected.swap = !this.tabSongTuaSelected.swap;
      }

      if (this.tabSongTuaSelected.bon || this.tabSongTuaSelected.down) {
        this.tabSongTuaSelected.overlay = null;
      } else {
        this.tabSongTuaSelected.overlay = "show";
      }
    },
    setRunSelected(type) {
      this.resetSamTuaSelected();
      this.resetSongTuaSelected();
      if (type == "bon") {
        this.tabRunSelected.bon = !this.tabRunSelected.bon;
      }
      if (type == "down") {
        this.tabRunSelected.down = !this.tabRunSelected.down;
      }

      if (this.tabRunSelected.bon || this.tabRunSelected.down) {
        this.tabRunSelected.overlay = null;
      } else {
        this.tabRunSelected.overlay = "show";
      }
    },
    setNumber() {
      let i = 0;
      let j = 0;
      let numbers = [];
      for (i = 0; i < 10; i++) {
        // numbers.title = this.zeroPad(i, 3);
        // numbers.start = i * 100;
        j = 0;
        numbers = [];
        for (j = 0; j < 100; j++) {
          numbers.push(this.zeroPad(i * 100 + j, 3));
        }
        this.numberPanel.three.numberSets.push({
          title: this.zeroPad(i * 100, 3),
          start: i * 100,
          numbers: numbers,
        });
      }

      i = 0;
      numbers = [];
      for (i = 0; i < 100; i++) {
        numbers.push(this.zeroPad(i, 2));
      }
      this.numberPanel.two.numbers = numbers;

      i = 0;
      numbers = [];
      for (i = 0; i < 10; i++) {
        numbers.push(this.zeroPad(i, 1));
      }
      this.numberPanel.run.numbers = numbers;
    },
    getMyTicket() {
      axios
        .post(
          this.getApiUrl + "/pingpong/getmyticket",
          {
            username: this.getUsername,
            lottoType: 1,
          },
          {
            headers: {
              "Content-Type": "application/json",
              token: this.getAccessToken,
              username: this.getUsername,
            },
          }
        )
        .then((response) => {
          const tickets = response.data.data;
          let ticket = [];
          let i = 0;
          for (i = 0; i < tickets.length; i++) {
            ticket = [];
            if (
              moment(tickets[i].createdDate).format("YYYY-MM-DD") ==
              moment().format("YYYY-MM-DD")
            ) {
              ticket = tickets[i];
              ticket["date"] = moment(tickets[i].createdDate).format(
                "YYYY-MM-DD"
              );
              ticket["numbers"] = [];
              this.tickets.push(ticket);
              // this.getMyTicketDetail(tickets[i].lottoType, tickets[i].customerPlayID, i);
            }
          }
          // this.totalBet = this.tickets[0].totalBet;
          console.log("Get my ticket", this.tickets);
        });
    },
    // getMyTicketDetail(lottoType, customerPlayID, i) {
    //   console.log('h', lottoType, customerPlayID, i);
    //   axios
    //     .post(
    //       this.getApiUrl + "/pingpong/getmyticketdetail",
    //       {
    //         lottoType: lottoType,
    //         customerPlayID: customerPlayID,
    //         username: this.getUsername
    //       },
    //       {
    //         headers: {
    //           "Content-Type": "application/json",
    //           token: this.getAccessToken,
    //           username: this.getUsername
    //         }
    //       }
    //     )
    //     .then(function(response) {
    //       // return response.data.data;
    //       this.tickets[i].numbers = response.data.data;
    //     });
    // }
  },
  computed: {
    diceButtonDisabled() {
      if (
        this.yingNumber === null ||
        this.yingNumber.length < 5 ||
        this.sendingDice
      ) {
        return true;
      } else {
        return false;
      }
    },
    selectedAmount() {
      let numbers = 0;
      numbers =
        this.selectedNumbers.samTua.bon.length +
        this.selectedNumbers.samTua.tode.length +
        this.selectedNumbers.samTua.front.length +
        this.selectedNumbers.samTua.down.length +
        (this.selectedNumbers.songTua.bon.length +
          this.selectedNumbers.songTua.down.length) +
        (this.selectedNumbers.run.bon.length +
          this.selectedNumbers.run.down.length);
      return numbers;
    },
    totalPrice() {
      this.price = 0;
      let i = 0;
      this.betSlot = [];
      for (i = 0; i < this.selectedNumbers.samTua.bon.length; i++) {
        this.price =
          this.price + parseInt(this.selectedNumbers.samTua.bon[i].price);
        this.betSlot.push({
          betNumber: this.selectedNumbers.samTua.bon[i].number,
          betNumberType: 1,
          betPrice: parseInt(this.selectedNumbers.samTua.bon[i].price),
        });
      }
      i = 0;
      for (i = 0; i < this.selectedNumbers.samTua.tode.length; i++) {
        this.price =
          this.price + parseInt(this.selectedNumbers.samTua.tode[i].price);
        this.betSlot.push({
          betNumber: this.selectedNumbers.samTua.tode[i].number,
          betNumberType: 2,
          betPrice: parseInt(this.selectedNumbers.samTua.tode[i].price),
        });
      }
      i = 0;
      for (i = 0; i < this.selectedNumbers.samTua.front.length; i++) {
        this.price =
          this.price + parseInt(this.selectedNumbers.samTua.front[i].price);
        this.betSlot.push({
          betNumber: this.selectedNumbers.samTua.front[i].number,
          betNumberType: 9,
          betPrice: parseInt(this.selectedNumbers.samTua.front[i].price),
        });
      }
      i = 0;
      for (i = 0; i < this.selectedNumbers.samTua.down.length; i++) {
        this.price =
          this.price + parseInt(this.selectedNumbers.samTua.down[i].price);
        this.betSlot.push({
          betNumber: this.selectedNumbers.samTua.down[i].number,
          betNumberType: 8,
          betPrice: parseInt(this.selectedNumbers.samTua.down[i].price),
        });
      }
      i = 0;
      for (i = 0; i < this.selectedNumbers.songTua.bon.length; i++) {
        this.price =
          this.price + parseInt(this.selectedNumbers.songTua.bon[i].price);
        this.betSlot.push({
          betNumber: this.selectedNumbers.songTua.bon[i].number,
          betNumberType: 3,
          betPrice: parseInt(this.selectedNumbers.songTua.bon[i].price),
        });
      }
      i = 0;
      for (i = 0; i < this.selectedNumbers.songTua.down.length; i++) {
        this.price =
          this.price + parseInt(this.selectedNumbers.songTua.down[i].price);
        this.betSlot.push({
          betNumber: this.selectedNumbers.songTua.down[i].number,
          betNumberType: 6,
          betPrice: parseInt(this.selectedNumbers.songTua.down[i].price),
        });
      }
      i = 0;
      for (i = 0; i < this.selectedNumbers.run.bon.length; i++) {
        this.price =
          this.price + parseInt(this.selectedNumbers.run.bon[i].price);
        this.betSlot.push({
          betNumber: this.selectedNumbers.run.bon[i].number,
          betNumberType: 5,
          betPrice: parseInt(this.selectedNumbers.run.bon[i].price),
        });
      }
      i = 0;
      for (i = 0; i < this.selectedNumbers.run.down.length; i++) {
        this.price =
          this.price + parseInt(this.selectedNumbers.run.down[i].price);
        this.betSlot.push({
          betNumber: this.selectedNumbers.run.down[i].number,
          betNumberType: 7,
          betPrice: parseInt(this.selectedNumbers.run.down[i].price),
        });
      }
      console.log(this.price);
      return this.price;
    },
    ...mapGetters({
      getAccessToken: "getAccessToken",
      getUsername: "getUsername",
      getCashAmount: "getCashAmount",
      getLottoType: "getLottoType",
      getApiUrl: "getApiUrl",
      getAppName: "getAppName",
      getAppTitle: "getAppTitle"
    }),
  },
};
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css2?family=Mitr:wght@500&display=swap");

#priceModal {
  padding: 0 !important;

  .modal-dialog {
    margin: 0 auto !important;
  }
}

.result-number {
  font-family: "Mitr", sans-serif;

  &.top {
    font-size: 1.75rem;
  }

  &.second {
    font-size: 1.25rem;
  }
}

.text-gold {
  color: #ca8c1a;
}

.golden-header {
  background-image: linear-gradient(
    160deg,
    #a54e07,
    #b47e11,
    #fef1a2,
    #bc881b,
    #a54e07
  );
}

.price-modal {
  margin: 0 auto;
}

.code-input {
  border-color: #bd841b !important;
  width: 50px;
  padding: 0;
  margin: 10px 10px;
  font-size: 30px;
  line-height: 50px;
  height: 50px;
  font-family: SukhumvitBold;
  color: #bd841b !important;
}

.numpad {
  .btn {
    font-family: SukhumvitBold;
  }

  .btn-reset-form {
    font-size: 100%;
    line-height: 1.5;
    height: 48px;
  }
}

label.number {
  display: inline-block;
  width: 50px;
  height: 50px;
  margin: 0px 5px;
  font-size: 40px;
  font-weight: 500;
  text-align: center;
  line-height: 50px;
  background-color: rgba(0, 0, 0, 0.2);
  border: solid 1px #000000;
  color: #976f02;
  border-radius: 2px;
  background-color: rgba(229, 229, 229, 0.2);
  border: solid 1px #976f02;
  position: relative;
  vertical-align: middle;
}

.num-pad h4 {
  font-family: inherit;
  color: #aa7114;
}

.key-pad {
  .col-4 {
    padding-left: 2px;
    padding-right: 2px;
    padding-bottom: 4px;

    .btn-blank {
      color: #fff;
      background-color: #ccc;
      background-image: none;
      border-color: #bbb;
      width: 100%;
      height: 100%;
    }

    .btn {
      font-size: 20px !important;
      padding-left: 0px;
      padding-right: 0px;
    }
  }

  .col-12 {
    .btn {
      font-size: 20px !important;
      padding-left: 0px;
      padding-right: 0px;
    }
  }
}

.tanghuay-time {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 5px;
  padding-bottom: 0px;
  background: rgba(0, 0, 0, 0.8);
  /* border: #ccc 1px solid; */
  text-align: right;
  font-size: 18px;
  line-height: 20px;
  /* color: #dc3545; */
  color: #fff;
  text-shadow: rgb(26, 26, 26) 1px 1px 0;
  border-radius: 5px;
  overflow: hidden;
  font-family: "Gugi", cursive, SukhumvitReg;
}

.tanghuay-time_day {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 5px;
  padding-bottom: 0px;
  background: rgba(0, 0, 0, 0.1);
  border: #ccc 1px solid;
  text-align: right;
  font-size: 15px;
  line-height: 20px;
  /* color: #dc3545; */
  color: #aa1423;
  text-shadow: #fff 1px 1px 0;
  border-radius: 5px;
  overflow: hidden;
}

.lotto-time span {
  font-size: 75%;
}

#numpage_2 h3.mb-0 {
  font-family: inherit;
  font-size: 125%;
}

/**********************************************/

.btn-move {
  padding: 0px;
  /* border: #976f02 1px solid; */
  background: #976f02;
  font-size: 16px;
  line-height: 30px;
  height: 30px !important;
  margin-bottom: 0px;
  color: white;
  cursor: pointer;
  vertical-align: middle;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  transition: 1s;
}

.btn-move a {
  color: white;
  transition: 1s;
}

#hide-list-huay,
#show-list-huay {
  overflow: hidden;
  width: 100%;
  margin-bottom: 2px;
}

#hide-list-huay {
  transition: all 1s;
}

#show-list-huay {
  transition: all 1s;
}

.btn-move span {
  display: inline-block;
  width: 100%;
  text-align: center;
  overflow: hidden;
  transition: all 1s;
  height: 100%;
  vertical-align: middle;
}

span.btn-move {
  display: inline-flex;
  width: 100%;
  text-align: center;
  overflow: hidden;
  height: 100%;
  transition: all 1s;
  vertical-align: middle;
  margin-bottom: 0px;
  margin-right: 2px;
  white-space: nowrap;
}

.btn-move-left:before,
.btn-move-right:after {
  content: "";
  position: relative;
  height: 30px;
  display: flex;
}

.btn-move-left {
  color: #fff !important;
  background: #333;
  margin-left: 15px !important;
  border-top-right-radius: 3px;
  border-bottom-right-radius: 3px;
}

.btn-move-right {
  color: #fff !important;
  background: #333;
  margin-right: 15px !important;
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;
}

.btn-move-left:before {
  border-top: 15px solid transparent;
  border-bottom: 15px solid transparent;
  border-right: 15px solid #333;
  margin-left: -15px;
}

.btn-move-right:after {
  border-top: 15px solid transparent;
  border-bottom: 15px solid transparent;
  border-left: 15px solid #333;
  margin-right: -15px;
}

.sidebar-tanghuay {
  width: 100%;
  padding-left: 7px;
}

#sidebar-huay {
  display: flex;
  flex-flow: column;
  justify-content: start;
  align-items: stretch;
  overflow: hidden;
  transition: all 1s;
}

#show_poy_list {
  opacity: 1;
  width: 30%;
  transition: all 1s;
}

#numpage_2 h3.mb-0 {
  font-family: inherit;
  font-size: 125%;
}

#numpage_1,
#numpage_2 {
  transition: all 1s;
}

.sidebar-huay {
  /* min-width: 300px; */
  width: 100%;
  background: #111;
  border-radius: 3px;
  padding: 3px;
  height: 80vmin;
  transition: 1s;
}

.sidebar-huay .btn {
  margin-bottom: -5px;
}

.sidebar-huay .title-huay {
  color: #ca8c1a;
  font-family: inherit;
  /* background: #444; */
  height: 25px;
  line-height: 1;
  width: 100%;
  padding-left: 5px;
  border-bottom: #333 1px dashed;
}

@media screen and (max-width: 450px) {
  .sidebar-huay .title-huay {
    font-size: 12px !important;
    height: 16px;
  }
}

.sidebar-huay .title-huay i {
  font-size: 16px;
}

.sidebar-huay .list-huay {
  overflow-y: scroll;
  overflow-x: hidden;
  background: transparent;
  color: white;
  height: 100vmin;
}

.sidebar-huay .list-huay ol.num-huay {
  list-style: none;
  counter-reset: number;
  border-radius: 5px;
  overflow: hidden;
  padding-left: 0;
}

ol.num-huay li {
  counter-increment: number;
}

ol.num-huay li::before {
  content: counter(number) ". ";
  font-weight: bold;
  width: 1.2em;
  text-align: left;
  display: inline-block;
  margin-right: 10px;
  color: #555;
  padding-left: 3px;
  font-size: 80%;
}

ol.num-huay li:nth-child(odd) {
  background: rgba(255, 255, 255, 0.07);
}

.list-huay::-webkit-scrollbar {
  width: 8px;
  background: transparent;
  margin-left: 3px;
}

.list-huay::-webkit-scrollbar-track {
  border-radius: 6px;
  background: #523f00;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}

.list-huay::-webkit-scrollbar-thumb {
  border-radius: 6px;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.5);

  background: #c7842d;
}

.num-pad {
  width: 100%;
}

.num-pad h4 {
  font-family: inherit;
  color: #aa7114;
}

.label-number {
  text-align: center;
  width: 100%;
}

.logo {
  vertical-align: middle;
  color: black;
  text-decoration: none;
  line-height: 0;
  text-shadow: goldenrod 0px 1px 0;
  font-family: SukhumvitBold;
  font-size: 25px;

  .text88 {
    color: white !important;
    text-shadow: 0px 0px 2px gray;
    font-size: 108%;
    margin-left: -5px;
  }
}

label.number {
  display: inline-block;
  width: 50px;
  height: 50px;
  margin: 0px 5px;
  font-size: 40px;
  font-weight: 500;
  text-align: center;
  line-height: 50px;
  background-color: rgba(0, 0, 0, 0.2);
  border: solid 1px #000000;
  color: #976f02;
  border-radius: 2px;
  background-color: rgba(229, 229, 229, 0.2);
  border: solid 1px #976f02;
  position: relative;
  vertical-align: middle;
}

label.number span {
  background: rgba(152, 59, 59, 0.8);
  width: 2px;
  height: 70%;
  position: absolute;
  top: 15%;
  left: 50%;
  animation-name: blink;
  animation-duration: 800ms;
  animation-iteration-count: infinite;
  opacity: 1;
}

.sidebar-huay .title-huay {
  color: #ca8c1a;
  font-family: inherit;
  /* background: #444; */
  height: 25px;
  line-height: 1;
  width: 100%;
  padding-left: 5px;
  border-bottom: #333 1px dashed;
}

.btn-danger {
  display: inline-block;
  outline: none;
  font-family: inherit;
  /* font-size: 80%; */
  box-sizing: border-box;
  border: none;
  border-radius: 0.3em;
  height: auto;
  line-height: 1.9em;
  text-transform: uppercase;
  padding: 3px 5px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(110, 80, 20, 0.4),
    inset 0 -1px 2px 1px rgba(139, 66, 8, 1),
    inset 0 -1px 1px 2px rgba(250, 227, 133, 1);
  background-image: linear-gradient(
    160deg,
    #a54e07,
    #b47e11,
    #fef1a2,
    #bc881b,
    #a54e07
  );
  border: 1px solid #a55d07;
  color: rgb(120, 50, 5) !important;
  text-shadow: 0 2px 2px rgba(250, 227, 133, 1);
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  background-size: 100% 100%;
  background-position: center;
}

.btn-danger:focus,
.btn-danger:hover {
  background-size: 150% 150%;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23),
    inset 0 -2px 5px 1px #b17d10, inset 0 -1px 1px 3px rgba(250, 227, 133, 1);
  border: 1px solid rgba(165, 93, 7, 0.6);
  color: rgba(120, 50, 5, 0.8);
}
.btn-danger:active {
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(110, 80, 20, 0.4),
    inset 0 -2px 5px 1px #b17d10, inset 0 -1px 1px 3px rgba(250, 227, 133, 1);
}
/* end gold btn */
.btn-outline-danger-gold:not(:disabled):not(.disabled).active {
  color: #fff !important;
  background-color: #bd841b !important;
  border-color: #bd841b !important;
}
.btn-outline-danger-gold {
  color: #b47e18 !important;
  background-color: white !important;
  background-image: none;
  border-color: #bd841b !important;
  word-wrap: break-word;
  overflow: hidden;
}
@media screen and (max-width: 320px) {
  .btn-af.btn-outline-danger-gold {
    font-size: 80%;
  }
}
.btn-outline-danger-gold:hover {
  color: white !important;
  background-color: #bd841b !important;
  background-image: none;
  border-color: #bd841b !important;
}
.modal-header.bg-danger {
  background-image: linear-gradient(
    160deg,
    #a54e07,
    #b47e11,
    #fef1a2,
    #bc881b,
    #a54e07
  );
  border: 1px solid #a55d07;
  text-shadow: rgb(0, 0, 0) 2px 0px 0px, rgb(0, 0, 0) 1.75517px 0.958851px 0px,
    rgb(0, 0, 0) 1.0806px 1.68294px 0px, rgb(0, 0, 0) 0.141474px 1.99499px 0px,
    rgb(0, 0, 0) -0.832294px 1.81859px 0px,
    rgb(0, 0, 0) -1.60229px 1.19694px 0px, rgb(0, 0, 0) -1.97998px 0.28224px 0px,
    rgb(0, 0, 0) -1.87291px -0.701566px 0px,
    rgb(0, 0, 0) -1.30729px -1.5136px 0px,
    rgb(0, 0, 0) -0.421592px -1.95506px 0px,
    rgb(0, 0, 0) 0.567324px -1.91785px 0px,
    rgb(0, 0, 0) 1.41734px -1.41108px 0px,
    rgb(0, 0, 0) 1.92034px -0.558831px 0px;
  font-weight: normal !important;
}
.w-100.border.border-danger.bg-danger.rounded.p-1.text-center {
  background-image: linear-gradient(
    160deg,
    #a54e07,
    #b47e11,
    #fef1a2,
    #bc881b,
    #a54e07
  );
  border: 1px solid #a55d07 !important;
  text-shadow: black 1px 1px 3px;
}
.badge.badge-danger.font-weight-light.w-100 {
  background: goldenrod;
}

.page-link:hover {
  z-index: 2;
  color: #dca235;
  text-decoration: none;
  background-color: #e9ecef;
  border-color: #dee2e6;
}
.page-link {
  z-index: 2;
  color: #333;
  text-decoration: none;
}

.btn-rood {
  padding: 5px;
  border-radius: 0;
  border-right: 0;
  width: 100%;
}
.btn-group-toggle:last-child > .btn-rood {
  border-right: solid 1px;
  border-top-right-radius: 3px;
  border-bottom-right-radius: 3px;
}
.btn-group-toggle:first-child > .btn-rood {
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;
}
.txt-num {
  font-family: "Gugi", cursive;
}
.btn-group-toggle > .btn-outline-danger-gold.focus,
.btn-group-toggle > .btn-outline-danger-gold:hover {
  background: none !important;
  color: #b47e18 !important;
}
.btn-group-toggle > .btn-outline-danger-gold.focus.active,
.btn-group-toggle > .btn-outline-danger-gold.active {
  color: white !important;
  background: #b47e18 !important;
}
.btn-limitnum {
  border: #b41818 1px solid;
  color: #b41818;
  font-weight: bold;
}
.btn-group-toggle > .btn-limitnum.focus,
.btn-group-toggle > .btn-limitnum:hover {
  background: none !important;
  color: #b41818 !important;
}
.btn-group-toggle > .btn-limitnum.focus.active,
.btn-group-toggle > .btn-limitnum.active {
  color: white !important;
  background: #b41818 !important;
}
.btn-group-toggle > .btn-outline-secondary.focus,
.btn-group-toggle > .btn-outline-secondary:hover {
  background: none !important;
  color: #6c757d !important;
}
.btn-group-toggle > .btn-outline-secondary.focus.active,
.btn-group-toggle > .btn-outline-secondary.active {
  color: white !important;
  background: #6c757d !important;
}
#nav-tab1.nav-pills .nav-link.active {
  color: rgb(121, 82, 0);
  text-shadow: rgb(255, 238, 140) 1px 1px 0;
  background-image: linear-gradient(
    160deg,
    #a54e07,
    #b47e11,
    #fef1a2,
    #bc881b,
    #a54e07
  );
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  line-height: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 600;
  padding: 20px 0 !important;
  border-bottom-width: 8px;
}
#nav-tab1.nav-pills .nav-link {
  display: flex;
  justify-content: center;
  align-items: center;
  border: rgb(199, 153, 4) 1px solid;
  border-radius: 10px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  font-weight: 600;
  text-shadow: rgb(255, 255, 255) 1px 1px;
  background-color: rgb(255, 253, 218);
  color: rgb(182, 140, 2);
}
#samtua {
  position: relative;
}
.sidebar-tanghuay {
  width: 100%;
  padding-left: 7px;
}

.bar-back a {
  color: #aaa;
  text-decoration: none;
}

.bar-back a.btn {
  color: white;
}

.bar-back a.btn:hover,
.bar-back a.btn:focus {
  color: white;
}

.bar-back a.btn-outline-secondary {
  color: #555;
  background: white;
  padding-bottom: 0;
}

.bar-back a.btn-outline-secondary:hover,
.bar-back a.btn-outline-secondary:focus {
  color: #fff;
}

.bar-back a:hover,
.bar-back a:focus {
  color: #976f02;
}

.col-lotto .row .col-6,
.col-lotto .row .col-4,
.col-lotto .row .col-3 {
  margin-bottom: 5px;
  padding: 0 5px;
}

/* .col-lotto .row .col-4 .btn,.col-lotto .row .col-6 .btn{
    line-height: 1.2;
    overflow: hidden;
} */
.col-lotto .bg-btn {
  background: white;
  border-radius: 5px;
  border: 1px solid white;
  box-shadow: rgba(255, 255, 255, 0.5) 0 0 3px;
  width: auto;
}

.bg-option {
  background: rgba(0, 0, 0, 0.2);
  color: #151515;
  text-shadow: #eee 1px 1px 0px;
}

.flex-fill .bg-btn {
  margin: 2.5px;
}

.btn-tanghuay {
  line-height: 1;
}
.btn-panghuay {
  line-height: 1;
}

.row-btn-tanghuay .btn.active .badge {
  background: rgba(0, 0, 0, 0.5) !important;
}

.row-btn-tanghuay .btn div:first-child {
  margin-left: -8px;
  margin-top: -5px;
  margin-bottom: -5px;
  padding: 5px;
  padding-top: 8px;
  border-radius: 0px;
  vertical-align: middle;
}
.row-btn-tanghuay .col-6 button div:first-child {
  width: 80%;
}

.row-btn-tanghuay .btn span {
  font-family: Arial, Helvetica, sans-serif;
  /* font-weight: 400; */
}

.row-btn-tanghuay .btn div:first-child i {
  font-size: 22px;
  font-style: normal;
  text-align: center;
}

.row-btn-tanghuay .btn div:last-child {
  font-style: normal;
  text-align: center;
  width: 20%;
}

.row-btn-tanghuay .flex-fill {
  margin: 2.5px;
  width: auto;
}

.row-btn-tanghuay .btn.active div:first-child {
  background: rgba(0, 0, 0, 0.5) !important;
}

.row-btn-tanghuay .btn.active {
  /* box-shadow: black 1px 1px 8px; */
  outline: 1px dashed black;
  outline-offset: 2px;
}

.btn-outline-red {
  color: #dc3545;
  /* background-color: transparent; */
  background-color: rgba(255, 0, 0, 0.1);
  background-image: none;
  border-color: #dc3545;
}

.btn-outline-red.active {
  color: #fff;
  background-color: #dc3545;
  border-color: #dc3545;
}

.btn-outline-blue {
  color: #007bff;
  /* background-color: transparent; */
  background-color: rgba(0, 89, 255, 0.05);
  background-image: none;
  border-color: #007bff;
}

.btn-outline-blue.active {
  color: #fff;
  background-color: #007bff;
  border-color: #007bff;
}

.btn-outline-green {
  color: #28a745;
  /* background-color: transparent; */
  background-color: rgba(0, 255, 106, 0.1);
  background-image: none;
  border-color: #28a745;
}

.btn-outline-green.active {
  color: #fff;
  background-color: #28a745;
  border-color: #28a745;
}

.num-pad {
  width: 100%;
}

.num-pad h4 {
  font-family: inherit;
  color: #aa7114;
}

.label-number {
  text-align: center;
  width: 100%;
}

label.number {
  display: inline-block;
  width: 50px;
  height: 50px;
  margin: 0px 5px;
  font-size: 40px;
  font-weight: 500;
  text-align: center;
  line-height: 50px;
  background-color: rgba(0, 0, 0, 0.2);
  border: solid 1px #000000;
  color: #976f02;
  border-radius: 2px;
  background-color: rgba(229, 229, 229, 0.2);
  border: solid 1px #976f02;
  position: relative;
  vertical-align: middle;
}

label.number span {
  background: rgba(152, 59, 59, 0.8);
  width: 2px;
  height: 70%;
  position: absolute;
  top: 15%;
  left: 50%;
  animation-name: blink;
  animation-duration: 800ms;
  animation-iteration-count: infinite;
  opacity: 1;
}

// .key-pad > .row > .col-3 {
//   padding-left: 2px;
//   padding-right: 2px;
//   padding-bottom: 4px;
// }

// .key-pad > .row > .col-3 .btn {
//   font-size: 20px;
//   padding-left: 0px;
//   padding-right: 0px;
// }

// .key-pad > .row > .col-3 .btn-blank {
//   color: #fff;
//   background-color: #ccc;
//   background-image: none;
//   border-color: #bbb;
//   width: 100%;
//   height: 100%;
// }

// .key-pad > .row > .col-3 .btn-reset,
// .key-pad > .row > .col-3 .btn-cancel {
//   font-size: 16px;
//   line-height: 1;
//   height: 100%;
//   word-break: break-all;
// }

.box__condition-info h3 {
  font-size: 18px;
  border-radius: 5px;
  background: #dc9c35;
  padding: 5px 10px;
  color: white;
  font-weight: normal;
}

.box__condition-info h2 {
  font-family: inherit;
  color: #dc9c35;
  border-bottom: #ccc 1px dashed;
  font-size: 22px;
}

.box__condition-info {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 5px;
  border: #ccc 1px solid;
  padding: 5px;
  line-height: 1.2;
}

.box__condition-info p {
  padding: 0 5px;
  margin-bottom: 0px;
}

.bet_num_count {
  font-size: 90%;
  text-align: center;
  line-height: 1;
  margin-bottom: 5px;
  font-weight: 500;
  text-shadow: #000 1px 1px 0px;
  color: #fff;
}

.g3-huay {
  width: auto !important;
}

.panghuay_number {
  margin: 1px;
}

.yeekee__number > .row > .col-3 > button {
  font-size: 20px;
}
</style>
